const fr = {
  language: 'fr',
  aiChat: {
    title: 'Glow Intelligence',
    close: 'Fermer',
    resize: 'Redimensionner le panneau',
    move: 'Faites glisser ou utilisez les flèches du clavier pour déplacer',
    send: 'Envoyer',
    stop: 'Arrêter',
    placeholder: 'Posez une question sur le fonctionnement de Glow…',
    empty: "Posez n'importe quelle question sur le fonctionnement de Glow.",
    disclaimer:
      "Les réponses sont générées par IA et peuvent être erronées. L'assistant n'a pas accès à vos données d'envoi.",
    error: 'Une erreur est survenue lors de la réponse.',
    retry: 'Réessayer',
    beta: 'Bêta',
    thinking: 'Réflexion…',
    tools: {
      glossary: {
        running: 'Recherche de {{detail}} dans le glossaire…',
        used: '{{detail}} recherché dans le glossaire'
      },
      fallback: {
        running: 'Récupération d’informations…',
        used: 'Informations récupérées'
      }
    },
    newChat: 'Nouvelle conversation',
    language: 'Langue des réponses',
    copyAnswer: 'Copier la réponse',
    sources: 'Sources',
    sourceUpdated: 'Mis à jour le {{date}}',
    app: { 'internal-frontend': 'Glow', 'customer-frontend': 'Portail client', tracking: 'Suivi' },
    copied: 'Copié',
    history: {
      open: 'Historique des conversations',
      back: 'Retour à la conversation',
      empty: 'Aucune conversation précédente.',
      error: 'Impossible de charger vos conversations.',
      loadError: 'Impossible de charger la conversation.',
      delete: 'Supprimer la conversation « {{title}} »',
      deleteConfirm: 'Supprimer la conversation « {{title}} » ?',
      deleteYes: 'Supprimer',
      deleteCancel: 'Annuler',
      deleteError: 'Impossible de supprimer cette conversation.'
    }
  },
  userRoles: {
    admin: 'Administrateur',
    planner: 'Planificateur',
    read_only_planner: 'Planificateur en lecture seule',
    plus_planner: 'Rôle Planificateur avancé',
    partner: 'Partenaire',
    customer: 'Client',
    customs_agent: 'Agent des douanes',
    handler: 'Manipulateur'
  },
  emptyStates: { notFoundTitle: 'Aucun résultat trouvé !' },
  application: {
    requiredLocation: 'Le lieu est obligatoire',
    all: 'Tous',
    assigned: 'Affecté(e)',
    filter: 'Filtrer',
    reset: 'Réinitialiser',
    cluster: 'Cluster',
    save: 'Enregistrer',
    update: 'Mettre à jour',
    required: '* Champ obligatoire',
    requiredShort: '* Obligatoire',
    endsNextDay: 'se termine le jour suivant',
    search: 'Recherche en cours...',
    lastUpdated: 'Dernière mise à jour',
    logOut: 'Déconnexion',
    courier: 'Coursier',
    drivers: 'Coursiers',
    consignments: 'Expéditions',
    status: 'Statut',
    address: 'Adresse',
    adjusted: 'Ajusté(e)',
    actual: 'Réel(le)',
    tracking: 'Suivi',
    move: 'Déplacer',
    trackingPage: 'Page de suivi de destinataire',
    allSelected: 'Tout sélectionné',
    phoneNumberShort: 'Téléphone',
    yes: 'Oui',
    no: 'Non',
    notSelected: 'Non sélectionné',
    httpErrorToString: 'Erreur HTTP : code {{status}} {{statusText}}',
    anErrorOccurred: "Une erreur s'est produite !",
    noAccessTitle: "Pas d'accès",
    noAccessMessage: "Vous n'avez pas le droit d'utiliser cette fonctionnalité",
    autoComplete: 'Rechercher des lieux...',
    autoCompleteWithoutDots: 'Rechercher des lieux',
    totalWeight: 'Poids total',
    totalVolume: 'Volume total',
    validDeviationCode: 'Veuillez entrer une valeur valide',
    columns: 'Colonnes',
    title: {
      root: 'Bienvenue',
      planner: 'Planificateur',
      settings: 'Paramètres',
      plannerLive: 'Planificateur - En direct',
      plannerLiveSlot: 'Planificateur - En direct - Tournée',
      plannerCouriers: 'Planificateur - Coursiers',
      templateRouteRules: 'Planificateur - Gérer les règles de tournée',
      plannerUnits: 'Planificateur - Unités',
      plannerImport: 'Planificateur - Importation',
      plannerUnresolved: 'Planificateur - Non résolu(e)',
      plannerConsignments: 'Planificateur - Livraisons',
      plannerSearch: 'Planificateur - Recherche',
      plannerPlanning: 'Planificateur - Planification',
      plannerInvoicing: 'Planificateur - Facturation',
      plannerVehicle: 'Planificateur - Vehicles',
      report: 'Rapports',
      customerDepartmentLive: 'Affichage en direct',
      recipient: 'Suivi de colis - suivi - Bring',
      instantBooking: 'Réservation',
      h2Booking: 'Réservation H2',
      orderConfirmation: 'Confirmation de commande',
      customerPortal: 'Portail Clients',
      instantMap: 'Carte instantanée',
      recurringOrder: 'Commandes récurrentes',
      corrections: 'Corrections de commande',
      jobs: 'Surveillance des tâches',
      holidays: 'Jours fériés',
      shipmentLabels: "Étiquettes d'expédition",
      addresses: 'Adresses',
      routeReceiptList: 'Liste des signatures',
      loadList: 'Liste de chargement',
      manageReturns: 'Gérer les retours',
      preAdviceFollowup: 'Gérer les préavis',
      recurring: 'Planificateur - Récurrent'
    },
    language: { en: 'Anglais', nb: 'Norvégien', sv: 'Suédois', dk: 'Danois', fi: 'Finlandais', fr: 'Français' },
    country: {
      AllCountry: 'Tous les pays',
      Country: 'Pays',
      AD: 'Andorre',
      AT: "L'Autriche",
      BE: 'la Belgique',
      BA: 'Bosnie Herzégovine',
      BG: 'Bulgarie',
      HR: 'Croatie',
      CZ: 'Tchéquie',
      DK: 'Danemark',
      GB: 'Royaume-Uni',
      EE: 'Estonie',
      FO: 'Îles Féroé',
      FI: 'Finlande',
      FR: 'La France',
      DE: 'Allemagne',
      GR: 'Grèce',
      HU: 'Hongrie',
      IS: 'Islande',
      IE: 'Irlande',
      IT: 'Italie',
      LV: 'Lettonie',
      LT: 'Lituanie',
      MK: 'Macédoine du Nord',
      MT: 'Malte',
      ME: 'Monténégro',
      NL: 'Pays-Bas',
      NO: 'Norvège',
      PL: 'Pologne',
      PT: 'le Portugal',
      RO: 'Roumanie',
      RU: 'Russie',
      SM: 'Saint Marin',
      RS: 'Serbie',
      SK: 'Slovaquie',
      SI: 'Slovénie',
      ES: 'Espagne',
      SE: 'la Suède',
      CH: 'la Suisse'
    },
    timeDistance: 'Heure et distance prévues',
    driverReturnToAddress: "Ne pas préciser d'adresse d'expéditeur",
    noOptions: 'Aucune option',
    appBuild: "Compilation de l'appli",
    lastLogin: 'Dernière connexion',
    device: 'Appareil',
    model: 'Modèle',
    os: 'OS',
    units: 'Unités',
    helpLink: "(Qu'est-ce que c'est?)",
    groups: 'Groupes',
    departments: 'Départements',
    selectAll: 'Sélectionner tout',
    totalCustomerPrice: 'Prix client total',
    totalUnitPrice: 'Prix unitaire total',
    notFound: 'Introuvable'
  },
  serviceLevel: {
    label: 'Réduire le niveau de service',
    notSet: 'Non établi(e)',
    none: 'Désactivé(e)',
    premium: 'Premium'
  },
  dropdown: {
    nrSelected: '{{count}} sélectionné',
    nrSelected_other: '{{count}} sélectionnés',
    selectedCustomers: '{{count}} client',
    selectedCustomers_other: '{{count}} clients',
    allCustomers: 'Tous les clients',
    filterCustomers: 'Filtrer les clients',
    selectedDepartments: '{{count}} département',
    selectedDepartments_other: '{{count}} départements',
    allDepartments: 'Tous les départements',
    filterDepartments: 'Filtrer les départements',
    selectedServiceCodes: '{{count}} service',
    selectedServiceCodes_other: '{{count}} services',
    allServiceCodes: 'Tous les services',
    filterServiceCodes: 'Filtrer les services',
    selectedVasCodes: '{{count}} vas',
    selectedVasCodes_other: '{{count}} vases',
    allVasCodes: 'Tous les services à valeur ajoutée',
    filterVasCodes: 'Filtrer les services à valeur ajoutée',
    selectedDestinations: '{{count}} destination',
    selectedDestinations_other: '{{count}} destinations',
    filterSelfBillingUnitIds: "Filtrer les identifiants d'unité d'auto-facturation",
    allSelfBillingUnitIds: "Tous les identifiants d'unité d'auto-facturation",
    selectedSelfBillingUnitIds: "{{count}} identifiant d'unité d'auto-facturation",
    selectedSelfBillingUnitIds_other: "{{count}} identifiants d'unité d'auto-facturation"
  },
  button: {
    actions: 'Actions',
    edit: 'Modifier',
    back: 'Retour',
    cancel: 'Annuler',
    done: 'Terminé',
    clear: 'Effacer',
    clearAll: 'Tout effacer',
    selectAll: 'Sélectionner tout',
    close: 'Fermer',
    save: 'Enregistrer',
    delete: 'Supprimer',
    export: 'Exporter',
    new: 'Créer nouveau',
    search: 'Rechercher',
    add: 'Ajouter',
    remove: 'Supprimer',
    assign: 'Affecter',
    fullEdit: 'Modification complète',
    confirm: 'Confirmé',
    continue: 'Continuer',
    copy: 'Copier',
    triggerRollout: 'Déclencher le déploiement',
    triggerRolloutAgain: 'Redéployer'
  },
  consignment: {
    packageType: 'Type de colis',
    palletFootprints: 'Espace palette',
    loadingMeters: 'Mètres de chargement',
    includePreAdvice: 'Avis préliminaire',
    onlyFailedPreAdvice: "Échec de l'avis préliminaire",
    onlyReturnPreAdvice: "Retourner à l'expéditeur",
    search: "Recherche d'expédition",
    noShipmentsFound: 'Aucune expédition trouvée',
    clickButtonToSearch: 'Cliquez sur le bouton Recherche pour lancer la recherche',
    consignmentsForDate: 'Expéditions {{date}}',
    showOnlyEditable: 'Seulement modifiable',
    showOnlyNotAssigned: 'Non affecté(e)',
    withoutDate: 'Sans date',
    extendedSearch: 'Recherche étendue',
    showDeleted: 'Afficher les éléments supprimés',
    showDeviated: 'Afficher les échecs',
    deletedBy: 'Supprimé par',
    deletionReason: 'Raison',
    numberOfConsignments: '{{number}} expéditions trouvées',
    showAll: 'Tout',
    delivery: 'Livraison',
    pickup: 'Enlèvement',
    pickups: '{{count}} enlèvement',
    pickups_other: '{{count}} enlèvements',
    edit: 'Modifier',
    deleteOrders: 'Supprimer',
    duplicateOrder: 'Dupliquer',
    duplicateConfirmation: 'Voulez-vous vraiment dupliquer cette commande ?',
    orderDuplicated: 'La commande a été dupliquée',
    orderDuplicatedFailed: 'Impossible de dupliquer la commande',
    copyOrder: 'Copier',
    editOrder: 'Modifier',
    deletedOrderNotCopyable:
      "La commande supprimée ne peut pas être copiée en raison de l'insuffisance des informations de commande dans Glow",
    restoreOrder: 'Restaurer',
    deletedOrderNotRestorable:
      "La commande supprimée ne pas être restaurée en raison de l'insuffisance des informations de commande dans Glow",
    preplan: 'Préplanifier',
    deleteConfirmation: 'Voulez-vous vraiment supprimer cette expédition ?',
    deleteMultipleConfirmation: 'Voulez-vous vraiment supprimer les expéditions sélectionnées ?',
    copyConfirmation: 'Voulez-vous vraiment copier cette expédition ?',
    editConsignment: "Modifier les informations d'expédition",
    changeDateAndTime: "Changer la date et l'heure",
    searchShipments: 'Rechercher des expéditions :',
    searchCustomers: 'Rechercher des clients :',
    excelExportRemoved:
      "Il ne sera plus possible d'exporter vers Excel depuis cette page. Utilisez plutôt la page <0>Import / Export</0> ou <0>SAGA</0>. Cela fait partie d'une mise à jour plus large : d'autres fonctionnalités seront supprimées progressivement avant que la page ne soit définitivement désactivée et fermée. Tout le travail doit être effectué sur <1>cette page</1>.",
    filterBy: 'Filtrer par :',
    limitedShipmentsShownMessage: "Affichage de {{count}} expéditions maximum, envisagez d'affiner la recherche",
    limitedUnresolvedAddressesShownMessage: "Affichage d'un maximum de {{count}} adresses non résolues",
    bulkActions: 'Actions en bloc',
    bulkActionsMultiple: 'Actions en bloc ({{count}})',
    moveShipmentsToDifferentDepartment: 'Aller à un département différent',
    addToRecurringGroup: 'Ajouter au groupe récurrent',
    addEvents: 'Ajouter des événements',
    disabledEditDeleteHelperText:
      'Cette commande ne peut pas être modifiée ni supprimée, contactez votre bureau Bring local pour la modifier.',
    editPickupConsignment: "Mettre à jour les informations d'enlèvement",
    editDeliveryConsignment: 'Mettre à jour les informations de livraison',
    editPickupAndDeliveryTime: "Mettre à jour les heures d'enlèvement et de livraison",
    editConsignmentLocation: ' Emplacement',
    editConsignmentTime: ' Heure',
    editConsignmentName: ' Nom',
    editConsignmentPhone: ' Numéro de téléphone',
    editConsignmentInstructions: 'Instructions',
    earliestPickupTime: "Première heure d'enlèvement*",
    latestPickupTime: "Dernière heure d'enlèvement*",
    earliestDeliveryTime: 'Première heure de livraison',
    latestDeliveryTime: 'Dernière heure de livraison',
    enterPickupInstructions: "Entrer les instructions d'enlèvement",
    enterDeliveryInstructions: 'Entrer les instructions de livraison',
    enterDeliveryName: 'Entrer le nom de livraison',
    enterPickupName: "Entrer le nom d'enlèvement",
    enterPickupPhone: "Entrer le numéro de téléphone d'enlèvement",
    enterDeliveryPhone: 'Entrer le numéro de téléphone de livraison',
    specificationSize: 'Les dimensions de spécification',
    enterSpecificationSize: 'Entrer les dimensions de spécification',
    editSpecificationSize: 'Modifier les dimensions de spécification',
    enterSpecificationDescription: 'Entrer la description',
    editSpecificationDescription: 'Modifier la description',
    editPickupInfoDescription: "Pour pouvoir modifier les infos, vous devez choisir l'une des options ci-dessus.",
    updateLocationFor: 'Mettre à jour les informations pour {{count}} expéditions',
    updateLocationFor_other: "Mettre à jour les informations d'enlèvement pour {{count}} expéditions",
    comment: 'Commentaires',
    show: 'Afficher',
    filter: 'Filtrer les expéditions',
    state: 'État',
    estimatedDelivery: 'Livraison estimée',
    requestedTimePickup: "Heure d'enlèvement demandée",
    requestedTimeDelivery: 'Heure de livraison demandée',
    timeNotSet: 'Non établi(e)',
    customerReference: 'Référence client',
    shipmentId: 'ID expédition',
    packageId: 'ID colis',
    noCourier: 'Aucun coursier',
    noSlot: 'Aucune tournée',
    showEvents: 'Afficher les événements →',
    hideEvents: 'Masquer les événements ←',
    events: 'Événements',
    send: 'Envoyer',
    sendMessage: 'Envoyer un message',
    sendCommentFailed: "Échec de l'enregistrement des commentaires",
    recipient: 'Destinataire',
    unresolved: 'Expéditions non résolues',
    description: 'Description',
    pickupAddress: "Adresse d'enlèvement",
    numberOfPackages: 'Nombre de colis',
    registeredPickupAddress: "Adresse enregistrée d'enlèvement",
    pickupZipCode: 'Code postal',
    pickupZipArea: 'Région',
    deliveryAddress: 'Adresse de livraison',
    deliveryZipCode: 'Code postal',
    deliveryZipArea: 'Région',
    deliveryLocation: 'Emplacement',
    registeredDeliveryAddress: 'Adresse enregistrée de livraison',
    updated: 'La commande a été mise à jour',
    moved: 'La commande a été déplacée',
    unresolvedMessage:
      "Il y a {{count}} expédition pour laquelle nous ne pouvons pas trouver l'adresse, merci de l'ajouter.",
    unresolvedMessage_other:
      "Il y a {{count}} expéditions pour lesquelles nous ne pouvons pas trouver l'adresse, merci de les ajouter.",
    foundUnresolvedMessage:
      'Nous avons trouvé les adresses valides suivantes pour cette expédition. Si elles sont correctes, appuyez sur Mettre à jour. Sinon, veuillez trouver la bonne adresse sur la carte ci-dessous.',
    remove: 'Supprimer',
    optimizingNewSlot: "L'optimisation de l'expédition dans la nouvelle tournée est en cours",
    slotSelect: 'Choisir une tournée',
    pickupInstructions: "Instructions d'enlèvement",
    deliveryInstructions: 'Instructions de livraison',
    tracking: 'Suivi',
    recipientPhone: 'Numéro de téléphone du destinataire',
    customerRef: 'Réf. client',
    message: {
      CREATED: 'Créée',
      ASSIGNED: 'Affectée à la tournée',
      UNASSIGNED: 'Non affectée',
      COLLECTED: 'Enlèvement effectué',
      DELIVERED: 'Livraison effectuée',
      DEVIATED: 'Echec',
      COMMENT: 'Commentaires',
      RESOLVED: 'Résolue',
      UNRESOLVED: 'Non résolue',
      OFFERED: 'Offerte',
      REJECTED: 'Refusée',
      ACCEPTED: 'Acceptée',
      RETURNED: 'Retournée',
      DELETED: 'Supprimée',
      UNCONFIRMED: 'Non confirmé',
      REFUSED: 'Refusé'
    },
    adjustTabTitle: 'Modifier',
    bookingPanelTitle: 'Réservation',
    mapPanelTitle: 'Carte',
    recipientName: 'Nom du destinataire',
    receivedBy: 'Reçu par :',
    manuallyChangeLocations: 'Remplacer manuellement les lieux',
    manualOverrideDeviationTimeConfirm: "Confirmer la commande manuelle pour l'échec de l'expédition sélectionnée",
    manualOverrideDeliveryTimeConfirm: "Confirmer la commande manuelle pour la livraison de l'expédition sélectionnée",
    onManuallyChangeLocationsConfirm: 'Voulez-vous vraiment que cette expédition soit non résolue ?',
    unresolveDeliveryAddress: "Annuler la résolution de l'adresse de livraison",
    unresolvePickupAddress: "Annuler la résolution de l'adresse d'enlèvement",
    unresolveAddress: "Annuler la résolution de l'adresse",
    reference: 'Référence',
    shipmentIdNumber: 'Non',
    shipmentDetails: "Détails d'expédition",
    customer: 'Client',
    subcustomer: 'Client no',
    dateAndTime: 'Date et heures',
    filterCustomer: 'Filtrer le client',
    searchShipmentDateError: 'Entrer une plage de dates inférieure à 120 jours.',
    searchPhraseLength:
      'Pour une recherche étendue, la phrase de recherche doit comporter au moins {{minLength}} caractères.',
    moveOrder: "Déplacer l'expédition",
    moveOrderTitle: "Déplacer l'expédition vers un autre département",
    moveOrderDefault: 'Sélectionner un département',
    label: 'Étiquette',
    createLabel: 'Créer une étiquette',
    createLabelShipment: 'Créer une étiquette (Expédition)',
    createMultipleLabel: 'Créer une étiquette ({{count}})',
    viewLabel: "Afficher l'étiquette",
    viewLabels: "Afficher l'étiquette",
    generateLabelErrorTitle: "Une erreur s'est produite",
    generateLabelErrorDescription: "Désolé, impossible de créer d'étiquette pour le moment",
    generateLabelErrorButton: "Voir le code d'erreur",
    generatingLabels: "Les URL de PDF d'étiquette apparaîtront ci-dessous dans un instant",
    labelsGeneratedSuccessfully: "Tous les PDF d'étiquette ont été créés avec succès",
    vas: 'Services à valeur ajoutée (SVA)',
    price: 'Prix',
    orderSources: {
      glow: 'Glow',
      glow_customerBooking: 'Réservation de client GLOW',
      glow_recurring: 'Récurrent(e)',
      ShipmentAPI: "API d'expédition"
    },
    pickupDeviation: "Echec d'enlèvement",
    deliveryDeviation: 'Echec de livraison',
    shipmentSyncStatus: { no: 'Non', yes: 'Oui', partial: 'Partiel(le)' },
    selectOtherActions: 'Sélectionner d’autres actions'
  },
  eventsList: { timeWindow: 'Créneau horaire', from: 'De', to: 'A' },
  status: {
    started: 'Commencé(e)',
    notStarted: 'Non commencé(e)'
  },
  consignmentEvent: {
    message: {
      'auto-dispatch-succeeded': 'Auto-dispatch lancé',
      'auto-dispatch-failed': 'Auto-dispatch échoué',
      'optimizing-failed': 'Échec de l’optimisation de la tournée',
      'order-excluded-from-invoicing': 'Exclu de la facturation',
      'reoptimized-with-fallback-window': 'Tournée réoptimisée automatiquement',
      routeName: 'Nom de la route',
      resolved: "Coordonnées de l'adresse définies",
      unresolved: "Coordonnées de l'adresse non définies",
      comment: 'Commentaires',
      created: 'Créée',
      completed: 'Terminé(e)',
      assigned: 'Coursier affecté',
      plannedOnRoute: 'Itinéraire prévu',
      plannedOnRouteMoreInfo: 'Itinéraire prévu {{routeName}} ({{unitName}})',
      nameOfUnit: 'Nom de l’unité',
      optimizeProviderId: "ID d'optimisation",
      noOptimizationEngine: "Aucun moteur d'optimisation",
      failedOptimizeProviderId: "ID d'optimisation en échec",
      retryOptimizeProviderId: "ID d'optimisation de la nouvelle tentative",
      optimizationTimeWindow: "Fenêtre horaire d'optimisation",
      extendedBy: 'Prolongée de {{minutes}} min',
      optimizingFailedOtherNotPlanned: "Un autre envoi de la tournée n'a pas pu être planifié",
      optimizingFailedError: "L'optimisation s'est arrêtée sur une erreur",
      delivered: 'Livraison effectuée',
      collected: 'Enlèvement effectué',
      returned: 'Retourné(e)',
      deviated: 'Echec',
      damaged: 'Endommagé(e)',
      slotChanged: 'Tournée changée manuellement',
      unassigned: 'Non affecté(e)',
      rejected: 'Refusé(e)',
      error: 'Erreur',
      started: 'Démarré(e)',
      stopped: 'Arrêté(e)',
      accepted: 'Accepté(e)',
      offered: 'Offert(e)',
      unitName: 'Unité',
      driverName: 'Livreur',
      'delivery-id-check': "Vérification d'identité",
      'delivered-manually-overridden': 'Livraison choisie manuellement',
      'deviated-manually-overridden': 'Echec choisi manuellement',
      'collected-manually-overridden': 'Enlèvement choisi manuellement',
      'pickup-location-changed': "Adresse d'enlèvement modifiée",
      'delivery-time-estimated': 'Créneau de livraison mis à jour',
      'slot-manually-changed': 'Tournée choisie manuellement',
      'pickup-time-changed': "Adresse d'enlèvement modifiée",
      'manually-change-location': 'Commande manuelle des lieux',
      'pickup-consignment-data-changed': "Les détails d'enlèvement ont été modifiés",
      'delivery-consignment-data-changed': 'Les détails de livraison ont été modifiés',
      'specification-size-data-changed': 'Les dimensions de spécification ont été modifiées',
      'specification-description-data-changed': 'La description a été modifiée',
      'digital-identity-verified': 'Identité du destinataire vérifiée numériquement',
      'digital-identity-verification-failed': "Impossible de vérifier l'identité du destinataire numériquement",
      'flex-delivery-ordered': 'Une livraison simplifiée a été commandée',
      'flex-delivery-changed': 'Une livraison simplifiée a été modifiée',
      'flex-delivery-confirmation-sms-sent': 'Un SMS de confirmation de livraison simplifiée a été envoyé',
      'flex-delivery-confirmation-app-notification':
        'Notification push pour la confirmation de livraison simplifiée envoyée',
      'return-to-pickup-point-delivery-deviated': 'Sera remis au point de collecte',
      recipientName: 'Nom du destinataire',
      receivedBy: 'Reçu par',
      'reject-order-correction': 'Correction de commande refusée',
      'accept-order-correction': 'Correction de commande acceptée',
      'handed-over-to-other-unit': 'Transmission à une autre unité',
      'handed-over': 'Transmission à une autre unité',
      deliveredWithoutSignature: 'Livraison effectuée sans signature',
      deliveredWithoutSignatureReason: {
        left_package_outside: 'Colis déposé(s) selon les instructions',
        did_not_get_signature: 'En personne'
      },
      'returned-manually-overridden': 'Retour choisi manuellement',
      'eta-sms-sent': "Un SMS d'ETA e a été envoyé",
      calculatedEta: "Heure d'arrivée estimée : {{eta}}",
      etaSmsLabel: "Heure d'arrivée estimée",
      scanned: 'Arrivé(e) au terminal',
      'arrived-at-terminal': 'Arrivé(e) au terminal de distribution',
      'order-sorted': 'Tri effectué',
      'pickup-eta-sms-sent': "Un SMS d'ETA d'enlèvement a été envoyé",
      'handed-in-at-posten-terminal': 'Arrivé(e) au terminal de tri',
      'pickup-sms-sent': 'Un SMS de suivi a été envoyé',
      'pre-pickup-sms-sent': 'Un SMS de suivi a été pré-envoyé',
      'pickup-address-unresolved': "Adresse d'enlèvement non résolue",
      'delivery-address-unresolved': 'Adresse de livraison non résolue',
      'in-transit': 'En transit',
      'upcoming-pickup-sms-sent': 'Un SMS de livraison à venir a été envoyé',
      'order-sorted-same-day': "Date fixée à aujourd'hui par l'appli terminal",
      'signature-sms-sent': 'Un SMS de signature a été envoyé',
      'flex-delivery-cancelled': 'Livraison simplifiée annulée',
      'delivery-time-ordered': 'La date de livraison a été modifiée par le destinataire',
      'delivery-time-ordered-internal': 'Date de livraison modifiée',
      'delivery-time-updated-from-hf-sync': 'Heure de livraison synchronisée de HF',
      'planned-delivery-date-ordered': 'Une date de livraison prévue a été commandée',
      'delay-sms-sent': 'Un SMS de retard de livraison a été envoyé',
      'production-deviation': 'Ecart de production',
      'manual-delay-sms-sent': 'Un SMS de retard manuel a été envoyé',
      'route-planning-complete': 'Itinéraire terminé',
      'signature-delivered': 'Signature du destinataire',
      showPicture: 'Afficher photo',
      'external-address-wash': 'Les détails de livraison ont été modifiés',
      'order-note-changed': 'Bon modifié',
      'customer-details-changed': 'Détails du client modifiés',
      'order-data-changed': 'Commande modifiée',
      'order-moved-to-department': 'Déplacée entre départements',
      'order-moved-to-department-with-data': 'Expédition déplacée de',
      'package-data-changed': "Les données de l'expédition ont été modifiées",
      'package-measurements-changed': 'Dimensions colis modifiées',
      'driver-deviated-from-route': "Le livreur s'est écarté de la route prévue",
      'driver-deviated-from-route-at-pickup': "Le livreur s'est écarté de la route prévue lors de l'enlèvement",
      'delivered-outside-service-time-window': 'Livraison ou échec hors du créneau horaire de service',
      'delivered-outside-estimated-time-window': 'Livraison ou échec hors du créneau horaire prévu',
      'delivered-in-estimated-time-window': 'Livraison ou échec dans le créneau horaire prévu',
      'picked-up-outside-service-time-window': 'Ramassage ou échec hors du créneau horaire de service',
      'picked-up-outside-estimated-time-window': 'Ramassage ou échec hors du créneau horaire prévu',
      'picked-up-in-estimated-time-window': 'Ramassage ou échec dans le créneau horaire prévu',
      'ordered-delivery-time-set-by-production-time-window': 'Créneau horaire de production défini',
      'delivery-location-deviation': "La livraison n'a pas été faite à l'endroit convenu.",
      'seen-by-recipient': 'La page de suivi a été vue par le destinataire',
      'first-estimated-times-seen': 'Les premières heures estimées ont été vues par le destinataire',
      'pre-advice-push-sms-sent': "Un SMS PUSH d'avis préliminaire a été envoyé",
      'pre-advice-push-return-sms-sent': "Un SMS PUSH RETURN d'avis préliminaire a été envoyé",
      'pre-advice-pull-sms-sent': "Un SMS PULL d'avis préliminaire a été envoyé",
      'pre-advice-pull-reminder-sms-sent': "Un SMS PULL d'avis préliminaire rappel au destinataire a été envoyé",
      'pre-advice-pup-sms-sent': "Un SMS PUP d'avis préliminaire a été envoyé",
      'pre-advice-return-sms-sent': "Un SMS RETOUR d'avis préliminaire a été envoyé",
      'pre-advice-return-email-sent': "Un e-mail RETOUR d'avis préliminaire a été envoyé",
      'pre-advice-manual-request': "D'avis préliminaire manuel",
      'pre-advice-status-changed': 'Statut de préavis modifié',
      'reported-damaged': 'Dommages signalés',
      'reported-missing-article': 'Articles manquants signalés',
      'delivery-sms-sent': 'SMS de livraison envoyé',
      'parcelbox-allocated': 'Emplacement réservé dans la boîte à colis',
      unconfirmed: 'Non confirmé',
      'accepted-by-planner': 'Accepté',
      'apartment-information-updated': "Informations sur l'appartement mises à jour",
      'lock-code-entered': 'Digicode saisi',
      'service-upgrade-purchased': 'Ventes incitatives: Service de portage commandé par le destinataire',
      serviceUpgradePurchasedDescription: "La livraison a été mise à jour de bordure de route à l'intérieu",
      'claim-registered-email-sent': 'Envoyer un e-mail concernant les articles endommagés ou manquants',
      'invoicing-failed': 'Échec de la facturation',
      'invoiced-ok': 'Facturé OK',
      'invoice-awaiting-acknowledgement': 'En attente de confirmation de commande',
      'invoice-acknowledged-by-external-system': 'Commande confirmée par un système externe',
      'invoice-created-in-external-system': 'Facture créée dans le système externe',
      'invoice-sent-to-customer': 'Facture envoyée au client',
      'invoice-paid-by-customer': 'Facture payée par le client',
      'invoice-due-date-updated': "Date d'échéance de la facture mise à jour",
      'invoice-paid-to-vendor': 'Facture payée au fournisseur',
      'preliminary-loaded': 'Chargé temporairement',
      'manual-price-override': 'Prix écrasé',
      'incomplete-price-approved': 'Prix incomplet approuvé',
      'incomplete-price-unapproved': 'Approbation de prix incomplète révoquée',
      unloaded: 'Déchargé',
      'manually-changed-measurements': 'Poids et volume modifiés manuellement',
      'internal-trade-order-created': "Création d'un ordre commercial interne",
      'delivery-time-purchased': 'Ventes incitatives: fenêtre de temps plus courte commandée par le destinataire',
      'load-carrier-ready-for-distribution': 'Conteneur prêt pour la distribution',
      'pre-advice-result': 'Préavis',
      'bom-articles-muted': 'BOM PU/DEL exclu de la facturation',
      'bom-articles-unmuted': 'BOM PU/DEL non exclu de la facturation',
      'pickup-app-notification': 'Notification push pour le suivi envoyée',
      'ready-for-pickup': 'Prêt pour le retrait (PUP au terminal)',
      'return-address-updated': 'Adresse de retour mise à jour',
      restored: 'Restauré'
    },
    cause: {
      plannedStop:
        "Les informations d'enlèvement ont été mises à jour car la commande a été chargée à un arrêt planifié",
      adhocHenteordre:
        'Les informations de livraison ont été mises à jour, car la tournée a une adresse de fin différente de celle du terminal',
      shipmentDelayed: 'Les informations de livraison ont été mises à jour car l’expédition est retardée',
      movedToNextWorkingDay: 'Reporté au jour ouvrable suivant',
      optimizedInLoadCarrier:
        "Les informations de livraison ont été mises à jour car l'expédition a été planifiée sur une tournée dans le cadre d'un support de charge"
    },
    source: 'Source',
    unassignedReason: 'Raison',
    returnAddressSource: {
      OrderSource: 'L’adresse de retour indiquée par le client dans le fichier de réservation est utilisée',
      CustomerAdmin: 'L’adresse de retour configurée dans Customer Admin est utilisée',
      SenderAddress:
        'Aucune adresse de retour n’est indiquée dans le fichier de réservation du client, l’adresse de l’expéditeur est utilisée'
    },
    rejectedReason: {
      reason: 'Raison',
      private: 'Raisons privées',
      notEnoughTime: 'Impossible de livrer à temps',
      notEnoughSpaceOnVehicle: 'Manque de place dans le véhicule',
      other: 'Autre',
      OL1: 'Pas sur la tournée',
      OL2: 'Pas assez de place dans le camion',
      OL3: 'Pas assez de temps',
      OL4: 'Envoi introuvable',
      OL5: 'Planifié pour plus tard, mais il ne reste plus d’arrêts au terminal',
      comment: 'Commentaire'
    },
    idCheck: {
      idCheckFailed: "Échec de la vérification d'identité, mais livraison effectuée avec {{idCheckFailedResult}}",
      idCheckSummaryOther: 'Autre ({{otherType}}), date de naissance {{birthDate}}',
      idCheckSummary: '{{idCheckType}}, date de naissance {{birthDate}}',
      idCheckSummaryOtherLabel: 'Autre ({{otherType}})',
      idCheckValue: 'Date de naissance {{birthDate}}'
    },
    damaged: {
      damageType: 'Type de dégât',
      courierInput: 'Informations du coursier',
      showPictureLink: 'Afficher photo {{idx}}',
      type: { A: 'Colis/emballage endommagé', D: 'Dommage dû à une pression/compression', E: 'Compléter dommage' }
    },
    invoiceInitiationType: {
      automatic: 'Facturation planifiée',
      'manual-department-level': 'Facturation manuelle du département',
      'manual-order-level': 'Facturation manuelle des commandes',
      'multiple-order-level': "Facturation manuelle de plusieurs commandes par l'utilisateur"
    },
    autoDispatchFailedReason: {
      NO_MATCHING_ROUTE: 'Aucune route correspondante trouvée',
      DISPATCH_REJECTED: "Échec de la planification de l'optimisation",
      RETRIES_EXHAUSTED: 'Toutes les tentatives ont échoué'
    },
    excludedFromInvoicingReason: {
      UNIT_NOT_SELF_BILLING_WITH_INTERNAL_TRADE:
        "Exclu automatiquement car l'unité n'a pas à la fois l'autofacturation et la transaction interne actives"
    },
    autoDispatchSucceeded: {
      matchedRange: 'Plage de codes postaux correspondante : {{from}}-{{to}}.',
      matchedPostalCode: 'Code postal correspondant : {{code}}.',
      viewRuleDetails: 'Voir les détails de la règle <a>ici</a>',
      sentForOptimization:
        "La commande correspondait à une règle d'auto-dispatch et a été envoyée pour l'optimisation de la tournée."
    },
    invoiceCallback: {
      timeOfTransaction: 'Heure de la transaction',
      transactionNumber: 'Numéro de transaction dans {{systemId}}',
      invoiceLink: 'Cliquer pour voir la facture'
    },
    changedFrom: 'Modifier de -',
    blankText: '(vierge)',
    name: 'Nom',
    unresolved: {
      missingPickupCoordinates: "Coordonnées d'enlèvement manquantes",
      missingDeliveryCoordinates: 'Coordonnées de livraison manquantes'
    },
    resolved: {
      source: {
        DepartmentLocation: 'coordonnées du département',
        GeocodingAPI: 'Google',
        DatabaseLookup: 'coordonnées préenregistrées',
        PickupPointAPI: 'Pickup Point API',
        GlowFrontend: 'Glow',
        EDI: 'inconnu',
        CustomerSite: 'emplacement du site client',
        ParcelInMailbox: 'les coordonnées de la boîte aux lettres',
        Driver: 'livreur',
        OriginalOrder: 'Ordre original',
        Google: 'Google',
        GoodsReturnAddress: 'adresse de retour des marchandises'
      },
      pickup: {
        coordinatesSetBy: 'Coordonnées de ramassage définies par {{source}}',
        coordinatesManuallySet: 'Les coordonnées de ramassage ont été définies manuellement',
        coordinatesRestored: 'Coordonnées de ramassage restaurées',
        coordinatesSwapped: 'Coordonnées de ramassage définies sur les anciennes coordonnées de livraison'
      },
      delivery: {
        coordinatesSetBy: 'Coordonnées de livraison définies par {{source}}',
        coordinatesManuallySet: 'Les coordonnées de livraison ont été définies manuellement',
        coordinatesRestored: 'Coordonnées de livraison restaurées',
        coordinatesSwapped: 'Coordonnées de livraison définies sur les anciennes coordonnées de ramassage'
      }
    },
    created: {
      recurringOrder: 'Créé à partir d’une commande récurrente.',
      showOriginalOrder: 'Afficher l’original',
      recurringRoute: 'Créé à partir d’un itinéraire récurrent',
      recurringRouteLink: 'vers les paramètres d’itinéraire'
    },
    outsideTimeWindow: {
      'delivered-outside-estimated-time-window': 'Plage horaire estimée',
      'delivered-in-estimated-time-window': 'Plage horaire estimée',
      'delivered-outside-service-time-window': 'Plage horaire de service',
      'picked-up-outside-estimated-time-window': 'Plage horaire estimée',
      'picked-up-in-estimated-time-window': 'Plage horaire estimée',
      'picked-up-outside-service-time-window': 'Plage horaire de service',
      actual: 'Livraison réelle ou écart',
      actualPickup: 'Ramassage réel ou écart'
    },
    deliveryInstructions: 'Instructions de livraison'
  },
  jobs: {
    job: 'Tâche',
    lastStarted: 'Démarrée la dernière fois',
    lastFinished: 'Terminée la dernière fois',
    maxDuration: 'Durée max',
    timeBetweenRuns: 'Temps entre exécutions',
    disable: 'Désactiver',
    enable: 'Activer',
    disabled: 'Désactivée',
    disabledInConfig: 'Désactivée dans la configuration',
    mustBeASuperAdmin: 'Vous devez être super administrateur pour activer et désactiver des tâches',
    showOnlyStruggling: 'Afficher seulement les tâches en difficulté',
    runningLongerThanExpected: 'En cours plus longtemps que prévu',
    notStartedForLongerThanExpected: "N'a pas démarré dans le délai attendu"
  },
  numberSeries: {
    numberSeries: 'Numéro de série',
    comparisonError: 'La valeur maximale doit être supérieure à la valeur minimale',
    successfullyAdded: 'La série de numéros a été ajoutée à la liste',
    successfullyDeleted: 'La série de numéros a été supprimée',
    addNewNumberSeries: 'Ajouter une nouvelle série de numéros',
    addedNumberSeries: 'Série de numéros ajoutée',
    addedNumberSeriesSubHeading: 'Ajouter la série de numéros (ne pas inclure les chiffres de contrôle)',
    selectType: 'Sélectionner le type',
    shipmentNumber: 'GSIN (Numéro de livraison)',
    packageNumber: 'SSCC (Numéro de colis)',
    minimum: 'Minimum',
    maximum: 'Maximum',
    addNumberSeriesButton: 'Ajouter la série de numéros à la liste',
    type: 'Type',
    currentNumber: 'Numéro actuel',
    maxNumber: 'Numéro max',
    numbersLeft: 'Nombres restants',
    validMinimumValue: 'Vous devez entrer une valeur minimale valide',
    validMaximumValue: 'Vous devez entrer une valeur maximale valide',
    deleteModalTitle: 'Supprimer la série de numéros',
    deleteModalDescription: 'Cette action ne peut pas être annulée'
  },
  preadvice: {
    searchPlaceholder: 'Saisissez au moins 3 caractères pour filtrer',
    selectedCustomers: 'Client sélectionné ({{count}})',
    customerSearch: 'Champ de recherche - Tapez au moins 3 caractères pour rechercher des clients',
    settingTargetCustomers:
      "Ce paramètre de préavis cible un client spécifique. Supprimez tous les clients sélectionnés pour pouvoir passer à l'option des groupes de clients",
    nameDescription: 'Nom et description',
    createNewPreadvice: 'Créer une nouvelle règle de préavis',
    bizArea: "Sélectionner le domaine d'activité",
    filterDepartmentAndGroups: 'Filtrer par départements ou groupes de départements',
    filterCustomersAndGroups: 'Filtrer par clients ou groupes de clients',
    preadvice: 'Avis préliminaire',
    hdDepartments: 'Dpts Livraisons à Domicile',
    ceDepartments: 'Départements coursier',
    departmentGroups: 'Groupes de départements',
    customers: 'Clients',
    customerGroups: 'Groupes de clients',
    customersCount: 'Clients',
    customerGroupsCount: 'Groupes de clients',
    noSelectedCustomers: 'Aucun client sélectionné',
    departmentsCount: 'Départements',
    departmentGroupsCount: 'Groupes de départements',
    locked: 'Préavis verrouillé',
    updated: 'Préavis mis à jour',
    rule: 'Règle',
    ruleTrigger: 'Préavis sur',
    type: 'Type',
    trigger: 'Déclencheur',
    action: 'Variante',
    result: {
      NO_VALID_PHONE_OR_EMAIL: 'Aucun numéro de téléphone ou adresse e-mail valide'
    },
    error: {
      PRE_ADVICE_RULE_COLLISIONS: {
        label: 'Conflit de règle !',
        detail:
          'La règle pour {{service}} remplacera la règle pour {{policySetNames}} par le biais de la relation au {{relations}}.',
        department: 'département',
        department_group: 'groupe de départements',
        customer: 'client',
        customer_group: 'groupe de clients'
      }
    },
    noPoliciesFound: "Aucun paramètre d'avis préliminaire",
    policies: "Paramètres d'avis préliminaire",
    policy: {
      servicePoliciesDescription:
        'En fonction du type de notification que vous sélectionnez, différents champs de saisie seront affichés',
      exception: 'Exception',
      name: 'nom',
      new: "Nouveaux paramètres d'avis préliminaire",
      edit: "Modifier les paramètres d'avis préliminaire",
      save: 'Enregistrer',
      saveAnyway: 'Enregistrer malgré tout',
      servicePolicies: "Règles d'avis préliminaire",
      targets: 'Paramètres client/service',
      servicePolicy: {
        edit: 'Modifier les paramètres',
        new: "Ajouter des paramètres d'avis préliminaire de service",
        remove: 'Supprimer la sélection',
        sameDay: 'Même jour',
        triggerEvent: 'Avis préliminaire à',
        cutoff: 'Heure limite',
        calendarDays: 'Jours ouvrés',
        returnToCustomer: 'Retour au client',
        redirectToPuP: 'Retour au point de livraison',
        reminderToCustomer: 'Rappel au client',
        noServicePoliciesFound: "Aucun paramètre n'a été ajouté pour le moment",
        returnToSenderAfterDays: "Retour à l'expéditeur après (jours)",
        searchCustomer: 'Rechercher un client',
        remindAfterHours: 'Rappel après',
        reminderToSenderAfterHours: "Rappel à l'expéditeur après",
        label: { days: 'Jours', hours: 'Heures' },
        legend: { days: 'Jours', hours: 'Heures', smss: 'Nombre maxi de SMS' },
        returnToPup: 'Retour à point de ramassage',
        addNewRule: 'Ajouter une nouvelle règle',
        typeOfOrders: "Type d'expéditions",
        ordersWithDate: 'Expéditions avec date de livraison',
        ordersWithoutDate: 'Expéditions sans date de livraison',
        ordersWithAndWithoutDate: 'Expeditions avec et sans date de livraison',
        triggerEventTitle: 'Générer le préavis de livraison',
        dateAndTimeChangeBookingPageTitle: "Modifications de la date et de l'heure sur la page de réservation",
        yesRecipientShouldChange: "La modification de la date et de l'heure par le destinataire est autorisée",
        noRecipientShouldNotChange: "La modification de la date et de l'heure par le destinataire n'est pas autorisée",
        sameDayTitle: "Autoriser les réservations le jour même avant l'heure limite",
        deliveryAttemptsChoiceTitle: 'Action à effectuer après le nombre maximal de tentatives de livraison',
        emailToCustomer: 'Email au client',
        deliveryAttempts: 'Tentatives de livraison',
        preAdviceAttempts: 'Tentatives de préavis',
        triggerEventType: {
          EDI: 'EDI',
          HUB: 'PLATEFORME DE TRI',
          DIP: 'CENTRE DE DISTRIBUTION',
          MANUAL: 'MANUEL'
        }
      }
    },
    tooltip: "Verrouiller la commande = aucune notification n'est envoyée au destinataire.",
    customerCode: 'Code client'
  },
  holidays: {
    holidays: 'Jours fériés',
    holiday: 'Jour férié',
    dayBeforeHoliday: 'Jour avant le jour férié',
    addHoliday: 'Ajouter un nouveau jour férié',
    country: 'Pays',
    type: 'Type',
    date: 'Date',
    successfullyAdded: 'Les vacances ont été ajoutées avec succès à la liste',
    successfullyDeleted: 'La vacance a été supprimée avec succès',
    filterOnCountry: 'Filtrer par pays',
    selectHolidayType: 'Sélectionner le type de jour férié',
    addHolidayToList: 'Ajouter des jours fériés à la liste',
    selectCountry: 'Sélectionner le pays',
    addedHolidays: 'Jours fériés ajoutés',
    deleteModalTitle: 'Supprimer les jours fériés',
    deleteModalDescription: 'Vous ne pourrez pas récupérer cette action.'
  },
  distributionMapping: {
    title: 'Association de distribution',
    addDips: 'Ajouter un DIP',
    addedDips: 'Site DIP ajouté ({{count}})',
    addedDips_other: 'Sites DIP ajoutés ({{count}})',
    connectedToPickupPoints: 'Associé à {{count}} point de collecte',
    connectedToPickupPoints_other: 'Associé à {{count}} points de collecte',
    emptyTitle: 'Aucun point de distribution (DIP) associé',
    emptyDescription:
      "Vous devez d'abord sélectionner un DIP pour pouvoir ajouter des points de collecte.\nCliquez sur le bouton en haut à droite pour commencer.",
    addDipModalTitle: 'Ajouter une association de distribution',
    addDipModalDescription: 'Sélectionnez le DIP auquel vous souhaitez ajouter des points de collecte',
    selectDipLabel: 'Rechercher un point de distribution (DIP)',
    searchPlaceholder: 'PUP ID, nom ou adresse',
    selectButton: 'Sélectionner',
    editDip: 'Modifier {{name}}',
    selectPickupPointHeading: 'Sélectionnez le point de collecte à ajouter au DIP',
    selectPickupPointLabel: 'Rechercher un point de collecte (PUP)',
    addedPickupPoints: 'Points de collecte ajoutés au DIP',
    removePickupPoint: 'Supprimer {{name}}',
    editPickupPoint: 'Modifier {{name}}',
    editPickupPointDescription: 'Sélectionnez les jours où le PUP peut recevoir des livraisons',
    deliveryDays: 'Jours de livraison',
    deliveryDaysHint: 'Sélectionnez les jours où les points de collecte peuvent recevoir des livraisons',
    addPickupPoint: 'Ajouter un point de collecte',
    saveToast: 'Association de distribution pour {{name}} enregistrée',
    addLocations: 'Ajouter des sites',
    removeDip: 'Supprimer {{name}}',
    removeDipQuestion: "Supprimer {{name}} de l'association de distribution ?",
    removeDipDescription: 'Ses points de collecte associés perdront leur DIP.',
    removeConnectionQuestion: "Supprimer l'association avec {{name}} ?",
    removeConnectionDescription: "Le point de collecte n'aura aucun DIP jusqu'à ce qu'il soit associé de nouveau.",
    alreadyAdded: 'Ce point de collecte est déjà sur ce DIP. Le rajouter remplacera ses jours de livraison.',
    alreadyMappedToOtherDip:
      "Ce point de collecte est déjà associé à {{dip}}. Supprimez-le de ce DIP avant de l'ajouter ici.",
    loadFailed: "Impossible de charger l'association de distribution. Réessayez ou rechargez la page.",
    errorSelectPickupPoint: 'Vous devez sélectionner un point de collecte',
    errorSelectDeliveryDay: 'Vous devez sélectionner au moins un jour de livraison',
    errorSelectDip: 'Vous devez sélectionner un DIP',
    deleteToast: '{{name}} a été supprimé'
  },
  department: {
    region: 'Région',
    createNewDepartment: 'Créer un nouveau département',
    addressAndContact: 'Adresse et informations de contact',
    searchAddressError:
      "Valeurs manquantes pour l'adresse. Vous devez utiliser le champ de recherche pour obtenir la bonne adresse.",
    addressContactIngress:
      "Pour obtenir la bonne adresse, utilisez le champ de recherche. L'adresse, le code postal et la ville seront remplis automatiquement.",
    settingsInGlow: 'Paramètres sur la page de suivi du destinataire',
    settingsBodyText:
      'En fonction de votre sélection, différents contenus et communications seront affichés/envoyés aux destinataires.',
    emailAddress: 'Adresse e-mail',
    routePlanning: "Planification de l'itinéraire",
    autoRouteCreationTime: "Création automatique de l'itinéraire",
    autoRouteOptimizationTime: "Optimisation automatique de l'itinéraire",
    clearTime: 'Supprimer le temps',
    departmentTitle: 'Département',
    departmentsLabel: 'départements',
    labels: 'Étiquettes',
    labelsDescription:
      "Créez des étiquettes pour définir des règles de filtrage pour ce département. Les étiquettes d'une même catégorie sont associées avec une logique <bold>OR</bold>, tandis que les différentes catégories sont combinées avec une logique <bold>AND</bold>. N'oubliez pas d'assigner les étiquettes à vos itinéraires pour que le filtrage prenne effet.\n" +
      '\n' +
      "Si des étiquettes ont été créées pour un département, les utilisateurs seront invités à sélectionner les étiquettes qu'ils souhaitent afficher la première fois qu'ils ouvrent la page <bold>Vue d'ensemble des tournées</bold>. Ils peuvent modifier leur sélection à tout moment en utilisant le panneau de filtres habituel sur la page <bold>Vue d'ensemble des tournées</bold>. Leur sélection est enregistrée dans le navigateur. En savoir plus ici (ou dans la fenêtre “Qu'est-ce que c'est ?”) : <supportLink>Labels (Only for Parcel Norway departments) – GLOW Support</supportLink>",
    labelsCategory: 'Catégorie',
    labelsCategoryHint: 'Utilisez un nom de catégorie existant pour ajouter plusieurs étiquettes au même groupe.',
    labelName: "Nom de l'étiquette",
    existingLabels: 'Étiquettes existantes',
    labelsEmpty: "Aucune étiquette n'a encore été créée.",
    labelsPreview: 'Aperçu',
    labelsPreviewEmpty: 'Sélectionnez des étiquettes pour voir comment la logique de filtrage sera construite.',
    labelsDuplicate: 'Cette étiquette existe déjà dans la catégorie sélectionnée.',
    labelsNotAdded: 'Cliquez sur Ajouter pour ajouter l’étiquette avant d’enregistrer.',
    nameRequired: 'Le nom est obligatoire',
    addressRequired: "L'adresse est obligatoire",
    zipCodeRequired: 'Le code postal est obligatoire',
    zipAreaRequired: 'La région est obligatoire',
    labelsCategoryRequired: 'La catégorie est obligatoire',
    labelNameRequired: "Le nom de l'étiquette est obligatoire",
    departmentTypeRequired: 'Le type de département est obligatoire',
    departmentIdRequired: 'L’identité du département est obligatoire',
    descriptionRequired: 'La description est obligatoire',
    regionRequired: 'La région est obligatoire',
    minutesAfterOrderArrivalRequired: 'Les minutes après réception de la commande sont obligatoires',
    createLabels: 'Créer des étiquettes',
    departmentWithCount: '{{count}} département',
    departmentWithCount_other: '{{count}} départements',
    departmentGroups: 'Groupes de départements',
    numberOfDepartmentGroups: 'Groupes de départements',
    numberOfDepartments: 'Nombre de départements',
    search: 'Rechercher des départements',
    searchGroups: 'Rechercher des groupes de département',
    noDepartmentGroupsFound: 'Groupe de département non trouvé',
    manageDepartment: 'Gérer le département',
    searchDepartmentGroups: 'Rechercher par nom du groupe département',
    searchDepartmentByNameOrId: 'Filtrer par nom de département ou par identifiant de département',
    noDepartmentName: 'Le nom est manquant',
    noDepartmentId: "L'identité est manquante.",
    noCouriers: 'Aucun coursier',
    courierCount_other: '{{count}} coursiers',
    courierCount: '{{count}} coursier',
    noCourier: 'Aucun coursier',
    couriers: 'Nombre de coursiers',
    plannerCount_other: '{{count}} planificateurs',
    plannerCount: '{{count}} planificateur',
    noPlanner: 'Aucun planificateur',
    planners: 'Nombre de planificateurs',
    choose: 'Choisir le département',
    new: 'Nouveau département',
    description: 'Description',
    name: 'Nom',
    created: 'Département créé',
    updated: 'Département mis à jour',
    departmentType: 'Type de département',
    notSet: 'Non établi(e)',
    courier: 'Coursier',
    hd: 'Livraison à domicile',
    other: 'Autre',
    all: 'Tout',
    deliveryDisplayType: "Affichage de l'heure de livraison",
    terminalName: 'Nom du dépôt',
    terminalNameTooltip:
      'Si le point d’enlèvement et le nom de département sont différents, remplissez ces informations',
    selectArea: 'Sélectionner la région...',
    address: 'Adresse',
    zipCode: 'Code postal',
    zipArea: 'Région',
    autoRecurrentTime: 'Heure automatiquement récurrente',
    autoInvoiceTitle: 'Facturation récurrente',
    autoInvoiceEnable: 'Configurer la facturation automatique',
    autoInvoiceTime: 'Heure de facturation',
    autoInvoiceOffset: {
      legend: 'Quelles commandes facturer',
      oneDayEarlier: 'Livré 1 jour plus tôt',
      twoDaysEarlier: 'Livré 2 jours plus tôt',
      threeDaysEarlier: 'Livré 3 jours plus tôt',
      fourDaysEarlier: 'Livré 4 jours plus tôt',
      fiveDaysEarlier: 'Livré 5 jours plus tôt'
    },
    autoDispatchSettings: {
      title: "Répartition automatique des commandes d'enlèvement",
      enable: "Configurer la répartition automatique des commandes d'enlèvement",
      minutesAfterOrderArrival: 'Minutes après réception de la commande',
      startTime: 'Heure de début'
    },
    unitNumber: "Nombre d'unités",
    npsId: 'ID NPS',
    defaultAlystraUnitId: "Identité de l'unité d'autofacturation",
    timeWindow: 'Créneau horaire',
    pickupEarliest: "Premier heure d'enlèvement",
    pickupLatest: "Dernière heure d'enlèvement",
    deliveryEarliest: 'Première heure de livraison',
    deliveryLatest: 'Dernière heure de livraison',
    cutoff: 'Seuil',
    updateTimeWindow: 'Mettre à jour la fenêtre horaire',
    listAllDepartments: 'Lister tous les départements',
    listAllGroups: 'Lister tous les groupes de départements',
    orderBillingType: {
      title: 'Type de facturation de la commande',
      selectBillingType: 'Sélectionnez le type de facturation',
      pickup: 'Enlèvement',
      customerBillingNumber: 'Numéro de facturation client',
      addMoreOrderBillingInfo: 'Ajouter un nouveau type de facturation de commande'
    },
    departmentId: 'Identité département',
    disableSms: 'Désactiver le suivi et les SMS d’ETA sur l’itinéraire',
    smsShouldNotBeSent:
      'Les SMS de suivi et les SMS d’ETA sont désactivés et ne doivent pas être envoyés aux destinataires des itinéraires produits par ce service.'
  },
  departmentGroup: {
    countries: 'Pays',
    departmentTypes: 'Types de départements',
    manageDepartments: 'Gérer les départements dans le groupe',
    createDepartmentGroup: 'Créer un nouveau groupe de départements',
    selectAllFor: 'Sélectionner tout pour {{name}}',
    departmentGroup: 'Groupe de départements',
    name: 'Nom',
    edit: 'Modifier le groupe de départements',
    deleteConfirm: 'Voulez-vous vraiment supprimer ce groupe de départements ?',
    selectedDepartments: 'Départements sélectionnés ({{count}})',
    noSelectedDepartments: 'Aucun département sélectionné',
    selectedCountries: '{{count}} pays sélectionné',
    selectedCountries_other: '{{count}} pays sélectionnés',
    selectedDepartmentTypes_other: 'Types de département sélectionnés pour le groupe de départements',
    type: 'Type',
    types: {
      DEFAULT: 'Par défaut',
      FOLLOW_UP: 'Suivi',
      INVOICING: 'Facturation',
      PLANNING: 'Planification',
      PREADVICE: 'Préavis',
      REGION: 'Région',
      SEARCH: 'Recherche'
    }
  },
  deliveryDisplayType: { instant: 'Instantané', customized: 'Personnalisé(e)' },
  templateRouteRules: {
    title: 'Gérer les règles de tournée',
    ruleName: 'Nom de la règle',
    type: 'Type',
    POSTAL_CODE: 'Code postal',
    searchPlaceholder: 'Rechercher par nom ou type',
    createNew: 'Créer une nouvelle règle',
    createNewRule: 'Créer une nouvelle règle de tournée',
    edit: 'Modifier',
    settings: 'Paramètres',
    assignToTemplateRoutes: 'Trajets du modèle',
    connectedToRule: 'associé à "{{name}}"',
    noTemplateRoutesInDepartment: 'Aucun trajet du modèle disponible dans ce département',
    templateHasNoRoutes: 'Le modèle sélectionné ne contient aucun trajet',
    noRecurringRoutesInDepartment: 'Aucun itinéraire récurrent disponible dans ce département',
    template: 'Modèle',
    selectTemplate: 'Sélectionner un modèle',
    templateRoute: 'Trajet du modèle',
    selectTemplateRoutes: 'Sélectionner les trajets du modèle',
    assignedTemplateRoutes: 'Trajets du modèle attribués ({{count}})',
    noAssignedTemplateRoutes: 'Aucun trajet du modèle attribué pour le moment',
    assignToRecurringRoutes: 'Itinéraires récurrents',
    recurringRoute: 'Itinéraire récurrent',
    selectRecurringRoutes: 'Sélectionner les itinéraires récurrents',
    assignedRecurringRoutes: 'Itinéraires récurrents attribués ({{count}})',
    noAssignedRecurringRoutes: 'Aucun itinéraire récurrent attribué pour le moment',
    atLeastOneRule: 'Ajoutez au moins une règle de code postal',
    successfullyAdded: '{{name}} a été ajoutée avec succès',
    successfullyUpdated: '{{name}} a été mise à jour avec succès',
    successfullyDeleted: 'La règle de tournée a été supprimée avec succès',
    deleteRule: 'Supprimer la règle de tournée',
    deleteRuleDescription: 'Êtes-vous sûr de vouloir supprimer cette règle de tournée ?',
    serviceExclusion: 'Exclusion de services',
    serviceExclusionDescription:
      "Les commandes portant l'un de ces codes de service ne sont jamais affectées à des tournées par cette règle.",
    serviceCode: 'Code de service',
    addServiceCode: 'Ajouter un code de service',
    excludedServices: 'Services exclus',
    noExcludedServices: 'Aucun service exclu',
    serviceCodeRequired: 'Saisissez un code de service',
    serviceCodeAlreadyExcluded: '{{code}} est déjà exclu',
    removeServiceCode: 'Supprimer {{code}}'
  },
  menu: {
    distributionMapping: 'Association DIP',
    manageRouteRules: 'Gérer les règles de tournée',
    defaultDisabled: 'Sélectionnez un client pour activer cet élément de menu',
    backToOldShipmentsPage: "Retour à l'ancien site.",
    home: 'Accueil',
    planner: 'Planificateur',
    volumeReport: 'Rapports de volume',
    report: 'Rapports',
    customer: 'Client',
    apiOrder: 'Trouver la commande API',
    support: 'Aide',
    priceMotor: 'Moteur de tarification',
    departments: 'Départements',
    users: 'Utilisateurs',
    customers: 'Client',
    customerGroups: 'Groupes de clients',
    numberSeries: 'Numéro de série',
    optimizing: 'Optimisation',
    services: 'Services',
    matrix: 'Matrice',
    jobsMonitoring: 'Surveillance des tâches',
    holidays: 'Jours fériés',
    settings: 'Paramètres',
    preadvice: 'Avis préliminaire',
    userRoles: "Rôles d'utilisateur",
    integrations: 'Integrations',
    live: 'En direct',
    routePlanning: "Planification d'itinéraire",
    dispatching: 'Dispatch',
    booking: 'Réservation',
    h2Booking: 'H2 Réservation',
    setCoordinates: 'Définir les coordonnées',
    pickupOrders: 'Commandes d’enlèvement',
    shipments: 'Rechercher',
    corrections: 'Corrections',
    units: 'Unités',
    couriers: 'Coursiers',
    vehicles: 'Véhicules',
    recurring: 'Récurrent(e)',
    importExport: 'Importer / Eksporter',
    addresses: 'Adresses',
    invoicing: 'Facturation',
    manageReturns: 'Gérer les retours',
    preAdviceFollowup: 'Gérer les préavis',
    vendors: 'Fournisseurs',
    mainNavigation: 'Menu principal',
    closePanel: 'Fermer le panneau',
    expandPanel: 'Développer le panneau',
    goToHomepage: "Aller à la page d'accueil",
    admin: 'Administration',
    productionTimeWindow: 'Créneaux de livraisons',
    routesOverview: "Vue d'ensemble des tournées"
  },
  planner: {
    colorPicker: 'Sélecteur de couleur',
    chooseYourDepartment: 'Choisissez votre département',
    userRolesCount_other: '{{count}} rôles utilisateurs',
    userRolesCount: '{{count}} rôle utilisateur',
    role: 'Rôle',
    typeOfRole: 'Type de rôle utilisateur',
    selectUserRole: 'Sélectionnez un rôle utilisateur',
    users: 'Utilisateurs',
    connectDepartment: "Connecter le département à l'utilisateur",
    unassignedShipments: 'Livraisons non attribuées',
    filterCustomers: 'Filtrer les clients',
    filterServices: 'Filtrer les services',
    autoRoute: 'Routage automatique',
    secondTab: 'Deuxième volet',
    saved: 'Enregistré',
    showInGoogleMaps: "Afficher l'itinéraire dans Google Maps",
    removeDepartment: 'Supprimer le département {{name}}',
    youMustProvideName: "Vous devez fournir le nom de l'utilisateur",
    youMustProvidePhonenumber: 'Vous devez fournir le numéro de téléphone',
    autoRouteModal: {
      selectRoutes: 'Selectionner les tournées de livraison',
      selectRoutesText:
        "Sélectionnez les tournées à inclure dans le routage automatique. Seules les tournées au statut Créé ou Affecté sont disponibles. Pour les tournées déjà en cours, utilisez Ajouter à l'itinéraire pour dispatcher les envois.",
      routesStartedRemoved: '{{routes}} a démarré et a été retirée de la sélection',
      routesStartedRemoved_other: '{{routes}} ont démarré et ont été retirées de la sélection',
      lockAllToSlot: 'Bloquer toutes les livraisons attribuées à ce créneau',
      useMapAreaRestrictions: 'Utiliser les restrictions de zone sur la carte',
      usePostalCodeRestrictions: 'Utiliser les restrictions de code postal',
      useGraphHopper: 'Utiliser GraphHopper',
      usePtv: "Utiliser PTV pour l'optimisation",
      usePtvPilot: 'Optimisation premium',
      useKardinal: 'Utiliser Kardinal',
      useHere: 'Utiliser HERE',
      useHexaly: 'Utiliser Hexaly',
      useHexalyCloud: 'Utiliser Hexaly Cloud',
      timeLimitInSeconds: 'Durée maximale en secondes',
      timeLimitByStops: 'Vide : selon la taille du plan',
      timeLimitAsMinutes: '= {{minutes}} min {{seconds}} s',
      timeLimitOutOfRange: 'Saisissez un nombre entier de secondes entre 10 et 2700 (45 minutes)',
      timeLimitExample: 'ex. 60',
      useNoEngine: "N'utiliser aucun moteur d'optimisation pour cette tournée",
      optimizeOn: 'Optimiser sur',
      noRelevantRoutes: 'Tournées appropriées non trouvées',
      startAutomaticRouting: 'Commencer le routage automatique',
      selectOptimizingEngine: "Sélectionner le moteur d'optimisation",
      useFlexAndForceFromPrevious: "Utiliser la flexibilité et l'ordre imposé des optimisations précédentes"
    },
    wait: "Temps d'attente",
    trips: 'Trajets',
    searchSlotCourierName: 'Rechercher un créneau/un livreur',
    createdBy: 'Crée par',
    allUserRoles: "Tous les rôles d'utilisateurs",
    createNewUser: 'Créer un utilisateur',
    noPlannersFound: 'Planificateur non trouvé',
    searchForNameOrNumber: 'Trouver le nom ou le numéro de téléphone',
    banner: {
      tryNewRoutePlanner:
        'À partir du 1er mai, <0>Planification d’itinéraire 2.0</0> sera le seul planificateur d’itinéraires disponible. Si vous n’avez pas encore utilisé ce planificateur d’itinéraires, nous vous encourageons à le faire dès maintenant. <1>Lisez des informations sur Zendesk</1> ainsi que d’autres articles associés pour avoir une idée de ses fonctionnalités.'
    },
    totalTitle: 'Colis',
    pickList: "Liste d'articles à prélever",
    export: 'Exporter pour la facturation',
    deleteSlot: 'Supprimer',
    editSlot: 'Modifier',
    deleteSlotConfirmDialogText: 'Voulez-vous vraiment supprimer cette tournée ?',
    deleteFilteredSlots: 'Supprimer tous les emplacements',
    deleteAllSlotsConfirmDialogText: 'Êtes-vous sûr de vouloir supprimer tous les emplacements?',
    created: 'Un planificateur a été créé',
    updated: 'Un planificateur a été mis à jour',
    live: 'En direct',
    routePlanning: "Planification d'itinéraire",
    vehicles: 'Véhicules',
    routePlanningConsignmentsAssigned: 'affecté(e)',
    routePlanningRangeDescription: 'Filtrer les expéditions par heure de livraison',
    unresolvedConsignments: 'Non résolu(e)',
    consignments: 'Rechercher',
    couriers: 'Coursiers',
    units: 'Unités',
    invoicing: 'Facturation',
    planner: 'Planificateur',
    planners: 'Planificateurs',
    noPlanners: 'Aucun planificateur',
    missingId: "L'identité est manquante",
    missingName: 'Le nom est manquant',
    search: 'Rechercher',
    searchForPlanner: 'Rechercher des planificateurs',
    name: 'Nom',
    phoneNumber: 'Numéro de téléphone',
    canLogIn: 'Peut se connecter',
    selectDepartments: 'Sélectionner les départements',
    createSlot: 'Créer une tournée',
    editSlotForm: 'Modifier une tournée',
    routeUpdated: 'Les détails de tournée ont été mis à jour',
    createSlotFormName: 'Nom de tournée',
    createSlotFormUnit: 'Unité',
    createSlotFormCourier: 'Coursier',
    createSlotFormSlotMode: 'Mode de tournée',
    createSlotFormSlotModePickup: "Dessiner la zone d'enlèvement sur la carte",
    createSlotFormSlotModeDelivery: 'Dessiner la zone de livraison sur la carte',
    createSlotFormSlotModeManual: 'Sélectionner manuellement les expéditions',
    createSlotFormSlotModeSelected: 'Expéditions sélectionnées',
    createSlotFormTimeRange: "Fourchette d'heures",
    createSlotFormStartLocation: 'Lieu de départ',
    createSlotFormEndTime: 'Heure de fin',
    createSlotFormEndLocation: "Lieu d'arrêt",
    createSlotFormSlotColor: 'Couleur de tournée',
    createSlotFormTimeRangeTooBig: 'La période de temps est trop large. Ne peut dépasser {{hours}} heures.',
    createSlotFormFilterCustomers: 'Filtrer les clients',
    createSlotFormFilterServices: "Filtrer les services (l'absence de coche signifie tous les services)",
    slotFilterInfo:
      "Cette tournée a fait l'objet d'un filtrage, c'est-à-dire que seules les expéditions appartenant au(x) client(s) choisi(s) et service(s) choisi(s) peuvent être reliées à la tournée.",
    slotFilteredCustomer: 'Cette tournée inclut UNIQUEMENT les commandes des clients suivants',
    slotFilteredService: 'Cette tournée inclut UNIQUEMENT les commandes avec les services suivants',
    onlyShowApplicable:
      "N'afficher que les commandes applicables à cette tournée en fonction du filtrage client/service",
    optimizeButtonLabel: 'Optimiser et affecter les itinéraires',
    optimizeSlotButtonLabel: 'Réoptimiser la tournée',
    reversedOptimizeSlotButtonLabel: "Inverser l'ordre de livraison",
    optimizingSince: 'Optimisation en cours, lancée à {{startTime}}',
    addToRoute: "Ajouter à l'itinéraire...",
    pickup: 'Enlèvement',
    delivery: 'Livraison',
    depot_call: 'Arrêt planifié',
    slot: 'Tournée',
    notAssigned: 'Non affecté(e)',
    readOnly: 'En lecture seule',
    partner: 'Partenaire',
    readOnlyAccessPlannersWithCount: '{{count}} planneurs avec accès en lecture seule',
    plusPlannersWithCount: '{{count}} planificateurs plus',
    normalPlannersWithCount: '{{count}} planificateurs normaux',
    saveTemplate: 'Enregistrer comme modèle',
    loadTemplate: 'Charger à partir du modèle',
    routeListForFilteredSlots: 'Liste des signatures (imprimer tout)',
    loadListForFilteredSlots: 'Liste de chargement (imprimer tout)',
    sendPrePickupSmsesToAll: 'Pré envoyer le sms de suivi',
    alertBeforeSendingPrePickupSms:
      "Êtes-vous sûr de vouloir pré-envoyer des SMS de suivi pour tous les créneaux pour aujourd'hui?",
    newTemplate: 'Créer un nouveau modèle',
    selectTemplate: 'Sélectionner un modèle',
    deleteTemplate: 'Supprimer',
    templateDeleteConfirm: 'Voulez-vous vraiment supprimer ce modèle ?',
    missingDeliveryMarker: 'Lieu ou adresse de livraison non valide',
    missingPickupMarker: "Lieu ou adresse d'enlèvement non valide",
    assignConsignmentFromSlot: "Affecter l'expédition à {{routeName}} ?",
    unassignConsignmentFromSlot: 'Supprimer {{count}} expédition de la tournée ?',
    unassignConsignmentFromSlot_other: 'Supprimer {{count}} expéditions de la tournée ?',
    unassignBulkConsignmentsFromSlotsAlert: 'Supprimer les expéditions de leurs tournées respectives',
    unassignedFromSlot: "L'affectation de l'expédition a maintenant été supprimée de la tournée",
    unassignBulkConsignmentsFromSlots:
      "L'affectation des expéditions a maintenant été supprimée de leurs tournées respectives",
    unassignButton: "Supprimer l'affectation à la tournée",
    forceUnassignButton: "Forcer la suppression de l'affectation à la tournée",
    driverName: 'Livreur',
    deliveries: 'Livraisons',
    returns: 'Retours',
    installations: 'Installations',
    curbside: 'Trottoir',
    filters: { assigned: 'Affecté(e)', unassigned: 'Non affecté(e)', pickups: 'Enlèvements', deliveries: 'Livraisons' },
    saveSelected: 'Enregistrer les éléments sélectionnés ({{count}})',
    showSaved: 'Afficher les éléments sélectionnées ({{count}})',
    showAll: 'Afficher tout',
    clearSaved: 'Supprimer les éléments enregistrés',
    sendPrePickupSms: 'Pré-envoyer un SMS de suivi au destinataire',
    sendSms: 'Envoyer SMS',
    sendingSmsText: 'Pré-envoi de {{count}} SMS de suivi en cours',
    prePickupSmsSent: '{{sentCount}} sur {{totalCount}} des SMS de suivi ont été pré-envoyés',
    manualDelaySms: {
      smsSent: '{{count}} SMS de retard manuel(s) envoyé(s)',
      heading: 'SMS de retard manuel',
      sendingSmsText: 'Envoi de {{count}} SMS de retard manuel',
      selectSmsDescription:
        "Le SMS commencera par « Bonjour, Votre livraison en provenance de l'expéditeur est malheureusement en retard. » Sélectionner la formule de fin de SMS ci-dessous.",
      selectSmsEnding: 'Sélectionner la façon dont le SMS doit se terminer',
      selectSmsBeginning: 'Sélectionner la façon dont le SMS doit commencer',
      previewLabel: 'Aperçu du SMS',
      buttonTitle: 'Envoyer',
      beginningType: {
        hi: '« Bonjour ! »',
        none: 'Aucun',
        fromSender: '« Votre livraison de l’expéditeur est malheureusement en retard. »',
        highDemand: '« En raison d’une forte demande, votre livraison est malheureusement en retard. »'
      },
      endingType: {
        none: 'Aucun',
        soon: '« Nous nous efforcerons de vous livrer le plus tôt possible. »',
        tomorrow: '« Nous nous efforcerons de vous livrer le jour ouvrable suivant. »',
        whenShipmentHasArrived:
          '« Une nouvelle date et un nouvel horaire de livraison vous seront communiqués lorsque l’expédition atteindra le terminal. »',
        newDeliveryTime: '« Nous vous livrerons ceci le prochain jour de livraison disponible. »',
        newDeliveryTimeFullEnding:
          '« Une nouvelle livraison est prévue pour le [DATE] [TIMESLOT]. Vous pouvez modifier l’heure de livraison via [TRACKINGLINK]. Cordialement, Bring »'
      },
      disabledTooltip: 'Les commandes ne peuvent pas être dans l’état Livrée'
    },
    delayedShipmentNotification: {
      description:
        'Le destinataire recevra un SMS indiquant que l’expédition est retardée et qu’une nouvelle date et un nouvel horaire de livraison seront envoyés lorsque l’expédition atteindra le terminal.',
      resetDescription:
        'Lorsque vous confirmez, les expéditions sélectionnées seront réinitialisées et retirées de la tournée si elles sont affectées.',
      gScanDescription:
        'Une fois l’arrivée au terminal enregistrée, le destinataire sera notifié à nouveau selon les règles de préavis.',
      successMessage: 'Le flux des expéditions retardées a démarré avec succès'
    },
    rescheduledShipmentNotification: {
      description: 'La livraison sera déplacée à une nouvelle date et heure.',
      autoUpdateDescription:
        'Le destinataire recevra un SMS indiquant que la livraison n’arrivera pas aujourd’hui comme prévu. Le message inclut également la nouvelle date et heure, ainsi qu’un lien pour modifier la livraison si nécessaire.'
    },
    h2: { booking: 'Réservation H2', vasHelperText: 'Utiliser SVA 1158 pour MBH' },
    loadList: {
      address: 'Adresse',
      customerRef: 'Référence client',
      deliveries: 'Livraisons',
      estimatedTotalTime: 'Heure est.',
      header: "Résumé de l'itinéraire",
      instructions: 'Instructions de livraison, /ntéléphone, /nréf. destinataire',
      instructionsPhone: 'Tél. :',
      instructionsRef: 'Réf. destinataire :',
      listName: 'Liste de chargement',
      name: 'Nom',
      qty: 'Qté',
      routeName: 'Itinéraire',
      service: 'Service\n(SVA)',
      stopOrder: 'Arrêter commande',
      timeWindow: 'Créneau horaire\n (ETA-ETD)',
      tripNumber: 'Tournée',
      unit: 'Unité',
      weight: 'Poids\nkg',
      zipArea: 'Région',
      zipCode: 'Code postal',
      unknownRouteName: "Nom d'itinéraire inconnu",
      unknownUnitName: "Nom d'unité inconnu",
      noDataText: "Il n'y a rien à voir ici pour le moment."
    },
    locationList: { listName: 'Liste des lieux' },
    assignedUnits: 'Unités affectées',
    unassignedUnits: 'Unités non affectées',
    noUnitSelected: 'Aucune unité sélectionnée',
    unitAssignmentCount: 'Unités affectées à {{count}} itinéraires',
    favouriteDepartments: 'Favoris',
    addFavouriteDepartment: 'Ajouter aux favoris : {{department}}',
    removeFavouriteDepartment: 'Retirer des favoris : {{department}}',
    largeDepartmentGuard: {
      validationMessage:
        'Le groupe de départements sélectionné {{departmentGroup}} contient trop de tournées et ne peut pas être utilisé sur {{page}}. Veuillez sélectionner un autre groupe de départements ou un département.'
    }
  },

  updateServiceLevel: {
    menuItem: 'Modifier le niveau de service',
    selectOption: 'Sélectionner le niveau de service',
    heading: 'Modifier le niveau de service',
    confirmation: 'Le niveau de service a été mis à jour',
    subtext: 'Modifier le niveau de service pour {{count}} expédition',
    subtext_other: 'Modifier le niveau de service pour {{count}} expéditions',
    failed: {
      title: "Nous n'avons pas pu modifier le niveau de service",
      message: "Nous n'avons pas pu modifier le niveau de service pour {{count}} expédition",
      message_other: "Nous n'avons pas pu modifier le niveau de service pour {{count}} expéditions"
    }
  },
  manualPreAdvice: {
    menuItem: 'Préavis manuel',
    heading: 'Préavis manuel',
    subtext: 'Change service level for {{count}} shipment',
    subtext_other: 'Change service level for {{count}} shipments'
  },
  setPickupDeliveryDuration: {
    menuItem: "Définir les temps d'enlèvement/de livraison",
    heading: "Définir les temps d'enlèvement et de livraison",
    subtext: "Définir les temps d'enlèvement et de livraison pour {{count}} expédition",
    subtext_other: "Définir les temps d'enlèvement et de livraison pour {{count}} expéditions",
    pickupPreparation: "Préparation de l'enlèvement",
    pickupDuration: "Durée d'enlèvement",
    deliveryPreparation: 'Préparation de la livraison',
    deliveryDuration: 'Durée de livraison',
    confirmation: "Temps d'enlèvement et de livraison mis à jour",
    validationError: 'Heure non valide. Le nombre maximal de minutes et de secondes est de 59',
    description:
      'Indiquez la préparation et la durée pour l’enlèvement et la livraison des commandes sélectionnées. Le nombre maximal de minutes et de secondes est de 59.'
  },
  importExportOrders: {
    importOrdersHeading: 'Importer la commande',
    importStatus:
      "Il y a actuellement {{imports}} importations en file d'attente avec un nombre total de {{orders}} commandes",
    exportForInvoice: 'Exporter pour la facturation',
    fileTemplateLink: 'Télécharger le modèle Excel',
    uploadFile: 'Importer la commande',
    uploadingMessage: 'Téléchargement du fichier et importation des commandes...',
    testDataWarning: "Ne pas utiliser d'informations personnelles dans l'environnement de test",
    testDataInfo:
      "Il s'agit d'un environnement qatest, et vous n'êtes pas autorisé à utiliser les données de production dans les tests sans le consentement explicite des utilisateurs concernés.",
    fromDate: 'À partir de la date',
    toDate: "Jusqu'à la date",
    fromDateNotAfterToDate: "Ne peut pas être plus tard que 'Jusuq'à la date'",
    toDateNotBeforeFromDate: "Ne peut pas être plus tôt que 'À partir de la date'",
    removeControlColumns: 'Supprimer les colonnes de contrôle',
    importResults: 'Importer les résultats',
    fileName: 'Fichier importé',
    processedAt: 'Traité',
    createdShipmentId: "Identifiant d'expédition créé",
    exportShipments: 'Exporter des navires',
    createLabels: 'Créer des étiquettes',
    selectSlot: "Sélectionner l'itinéraire",
    selectExportLabel: 'Sélectionnez ce que vous souhaitez exporter',
    allOrders: 'Toutes les commandes',
    deviatedOrders: 'Commande avec écart',
    all: 'Tous',
    selectFile: 'Sélectionner un fichier',
    jobList: {
      title: 'Exportations précédentes',
      content: 'Contenu',
      created: 'Créé',
      user: 'Utilisateur',
      dates: 'Date',
      download: 'Téléchargé',
      exporting: 'Exportation...',
      inQueue: "Dans la file d'attente d'exportation",
      exportFailed: "Échec de l'exportation",
      updated: 'Updated',
      previousImports: 'Importations précédentes',
      fileName: 'Nom du fichier',
      numberOfOrders: 'Nombre de commandes',
      imported: 'Importé',
      viewOrders: 'Voir les commandes',
      lastImports: 'Affichage des {{count}} dernières importations'
    },
    exportStartedNotification: "L'exportation a commencé",
    exportStartedNotificationMessage: 'Votre signalement sera disponible dès son traitement.',
    exportFailedNotification: "Échec de l'exportation, réessayez plus tard",
    refreshData: 'Mettre à jour les données dans le rapport existant',
    refreshDataDescription:
      'Choisissez cette option si vous avez déjà créé un rapport existant pour les dates spécifiques',
    types: {
      SHIPMENT_EXPORT: 'Expéditions',
      COURIER_WORK_REPORT: 'Rapport de travail du conducteur',
      END_OF_DAY_REPORT: 'Rapport de fin de journée',
      SOCIAL_CONTROL: 'Contrôle social',
      LOCATION_LIST: "Liste d'emplacements",
      ORDER_EXPORT: 'Exportation de la commande',
      ORDER_DEVIATION_EXPORT: 'Commande (déviation)',
      ORDER_EXPORT_ANONYMOUS: 'Commande (données anonymes)',
      ORDER_PARTNER_EXPORT: 'Commande (pour les partenaires)',
      DEVIATION_EVENTS: 'Événements de déviation',
      OPTIMIZATION_RESULTS: "Résultats d'optimisation",
      FINANCIAL_REPORT: 'Rapport financier'
    },
    exportTitles: {
      SHIPMENT_EXPORT: 'Exporter des envois',
      COURIER_WORK_REPORT: 'Rapport de travail du conducteur',
      END_OF_DAY_REPORT: 'Rapport de fin de journée',
      SOCIAL_CONTROL: 'Exporter le contrôle social',
      LOCATION_LIST: 'Exporter la liste des emplacements',
      ORDER_EXPORT: 'Exporter la commande',
      ORDER_DEVIATION_EXPORT: 'Exporter la commande avec écart',
      ORDER_EXPORT_ANONYMOUS: "Commande d'exportation anonymisée",
      ORDER_PARTNER_EXPORT: 'Exporter la commande du partenaire',
      DEVIATION_EVENTS: "Exporter les événements d'écart",
      OPTIMIZATION_RESULTS: 'Exporter les optimointitulokset',
      FINANCIAL_REPORT: 'Exporter rapport financier'
    },
    exportDescriptions: {
      ORDER_EXPORT:
        'Si vous souhaitez utiliser des données dans des environnements de test, nous vous recommandons d\'utiliser l\'option "Commander (données anonymisées)"',
      ORDER_DEVIATION_EXPORT:
        'Si vous souhaitez utiliser des données dans des environnements de test, nous vous recommandons d\'utiliser l\'option "Commander (données anonymisées)"',
      ORDER_EXPORT_ANONYMOUS: 'Peut être utilisé si les données doivent être importées dans un environnement de test',
      ORDER_PARTNER_EXPORT: 'Fichier Excel personnalisé pouvant être utilisé pour importer dans Opter',
      OPTIMIZATION_RESULTS: '',
      FINANCIAL_REPORT:
        'Contient une feuille supplémentaire avec les commandes ventilées par lignes de débit, le cas échéant'
    }
  },
  unit: {
    clearSearch: 'Effacer la recherche',
    unitWithCount: '{{count}} unité',
    unitWithCount_other: '{{count}} unités',
    new: 'Nouvelle unité',
    edit: "Modifier l'unité",
    addCourier: 'Ajouter un coursier',
    hideAddCourier: 'Masquer Ajouter un coursier',
    requiresCourierUsers: 'Doit comporter au moins un coursier',
    created: "L'unité a été créée",
    updated: "L'unité a été mise à jour",
    search: "Rechercher les unités d'autres départements...",
    unitsInCurrentDepartment: 'Les unités du département actuel',
    unitsInOtherDepartments: 'Les unités des autres départements',
    saveUnit: "Enregistrer l'unité",
    addCourierToUnit: "Enregistrer le livreur sur l'unité",
    noCouriersFound: 'Aucun coursier trouvé',
    addCourierToUnitSearch: 'Vous ne pouvez rechercher des coursiers que dans les services auxquels vous avez accès.',
    addedCouriers: 'Coursiers ajoutés ({{count}})',
    newCourier: 'Créer un nouveau coursier',
    name: 'Nom',
    unitId: "ID de l'unité",
    couriers: 'Coursiers',
    active: 'Actif',
    vehicle: 'Véhicule',
    deleteQuestion: "Supprimer l'unité du service actuel",
    deleteDescription: "L'unité peut être reconnectée plus tard si elle est toujours connectée à d'autres services.",
    unassigned: "L'unité a été supprimée avec succès du service.",
    setDefaultVehicle: {
      add: 'Ajouter un véhicule',
      change: 'Changer de véhicule',
      title: 'Ajouter un véhicule à {{unit}}',
      selectVehicle: 'Sélectionner un véhicule',
      addSuccess: 'Le véhicule a été ajouté avec succès à {{unit}}.',
      changeSuccess: 'Le véhicule a été changé avec succès sur {{unit}}.'
    }
  },
  courier: {
    isActive: 'Est actif(ve)',
    canLogIn: 'Peut se connecter',
    secureLoginEnabled: 'Connection par BankID',
    recipientName: 'Nom du destinataire',
    created: 'Un coursier a été créé',
    updated: 'Un coursier a été mis à jour',
    courier: 'Coursier',
    couriers: 'Coursiers',
    noCouriers: 'Aucun coursier',
    courierWithCount: '{{count}} coursier',
    courierWithCount_other: '{{count}} coursiers',
    numberOfCouriers: '{{number}} coursiers ont été trouvés',
    multipleDrivers: 'Plusieurs coursiers',
    missingId: "L'identité est manquante",
    missingName: 'Le nom est manquant',
    search: 'Rechercher des coursiers',
    new: 'Nouveau coursier',
    edit: 'Modifier le coursier',
    name: 'Nom',
    phoneNumber: 'Numéro de téléphone',
    driverId: 'ID livreur',
    capacity: 'Capacité',
    capacityLabel: 'Capacité (quantité)',
    weightCapacity: 'Capacité de poids (kg)',
    volumeCapacity: 'Capacité de volume (m³)',
    maxRangeKm: 'Distance maxi (km)',
    color: 'Couleur',
    resetColor: 'Rétablir la couleur',
    speedFactor: 'Facteur de vitesse',
    speedFactorExplanation: 'plus bas = plus lent',
    serviceTimeFactor: 'Facteur de temps du service',
    serviceTimeFactorExplanation: 'plus bas = plus rapide',
    defaultStopLocation: "Lieu d'arrêt par défaut",
    defaultStartLocation: 'Lieu de départ par défaut',
    slotNumDeliveries: '{{count}} livraison',
    slotNumDeliveries_other: '{{count}} livraisons',
    slotNumPickups: '{{count}} enlèvement',
    slotNumPickups_other: '{{count}} enlèvements',
    deliverPerformButtonLabel: 'Livrer',
    handoverPerformButtonLabel: 'Remettre',
    deviationPerformButtonLabel: 'Echec',
    deliverWithoutSignatureButtonLabel: 'Sans signature',
    deviateNotAtHomeButtonLabel: 'Pas à la maison',
    deviateLocNotFoundButtonLabel: "Impossible de trouver l'emplacement",
    deviateRecipientDeclinedButtonLabel: "Le destinataire n'en a pas voulu",
    deviateTimeWindow: 'Impossible de livrer dans le créneau horaire',
    addressNotFound: 'Adresse introuvable',
    deliverySpotUnavailable: "Le lieu de livraison convenu n'existe pas",
    deliveryAttemptNotPickedUp: 'Tentative de livraison - Non retiré',
    deviation: {
      'H-12': "Une tentative de livraison de l'expédition a été effectuée, mais le destinataire était absent",
      'H-11': "Nous avons tenté de livrer le colis, mais le destinataire n'était pas sur place",
      'H-10': "Nous avons tenté de livrer le colis, mais nous n'avons pas trouvé l'adresse indiquée",
      'H-13': "Une tentative de livraison de l'expédition a été effectuée, mais la livraison a été refusée",
      '7-10': "Les marchandises n'ont pas pu être enlevées en raison d'une adresse incomplète",
      '7-12': "L'expéditeur n'était pas disponible. Les marchandises n'ont pas été enlevées",
      '7-82': "Les marchandises n'étaient pas prêtes à être enlevées",
      'V-41-K': "L'expédition est retardée et sera effectuée le plus tôt possible",
      'V-OL2': 'Pas assez de place dans le camion',
      'V-OL4': 'Envoi introuvable',
      'V-OL5': 'Prévu plus tard sur la même tournée',
      '9-91': 'Annulé par le client',
      'H-07-R': 'Echec du contrôle social',
      'H-07-Z': 'Echec du contrôle social',
      'H-08-Z': "Echec du contrôle d'âge",
      'H-09-Z': "Echec du contrôle d'identité",
      'VI-16-X': 'Impossible de livrer dans le créneau horaire',
      'H-11-Z': 'Adresse introuvable',
      'H-BL-A': "Le lieu de livraison convenu n'existe pas",
      'V-100-CA': 'Aucune boîte à colis disponible. Le colis sera livré à domicile.',
      'V-100-CI': 'Pas de trappe disponible',
      'V-80-CI': 'Le colis dépasse les dimensions/poids autorisés',
      'V-99-CI': 'Autre inconnu',
      'V-AO-CI': 'La machine est en panne',
      'H-49-Q': '$t(courier.deliveryAttemptNotPickedUp)',
      'V-X-Y': 'Commande récupérée par un autre livreur'
    },
    completionProgressCounter: '{{numCompleted}}/{{numTotal}} terminée(s).',
    lockCode: 'Digicode',
    flexDelivery: 'Livraison simplifiée',
    fuelType: 'Type de carburant',
    fuelTypes: {
      gasoline: 'Essence',
      natural_gas: 'Gaz naturel',
      rme: 'RME',
      ethanol: 'Éthanol',
      bio_gas: 'Biogaz',
      electric: 'Électricité',
      bicycle: 'Bicyclette',
      hydrogen: 'Hydrogène',
      diesel: 'Diesel',
      hvo: 'HVO'
    },
    fuelCategory: 'Catégorie de carburant',
    fuelCategories: {
      fossil: 'Combustible fossile',
      fossil_free: 'Sans combustible fossile',
      zero_emissions: 'Zéro émission'
    },
    latestLogin: 'Dernière connexion',
    latestVersion: 'Dernière version',
    failedSocialControl: 'Echec du contrôle social',
    failedIdControl: "Echec du contrôle d'identité",
    failedAgeControl: "Echec du contrôle d'âge",
    incompletePickupAddress: "Adresse d'enlèvement incomplète",
    custNotAvailableAtPickupAddress: "Le client n'était pas disponible à l'adresse d'enlèvement",
    goodsNotReadyAtPickupForCust: "Les marchandises n'étaient pas prêtes pour l'enlèvement chez le client",
    shipmentNotAvailableAtTerminal: "L'envoi n'était pas disponible au terminal",
    registrationNumber: "Numéro d'immatriculation",
    commercialTrafficEligibility: 'Véhicule utilitaire autorisé',
    vehicleBrand: 'Marque du véhicule',
    vehicleModel: 'Modèle du véhicule',
    vehicleControl: 'Contrôle du véhicule',
    vehicleControlComment: 'Commentaires sur le contrôle du véhicule',
    euroClass: 'Classe Euro',
    alcoholDeliveryEducation: "Formation de livraison d'alcool",
    alcoholDeliveryEducationDate: 'Formation suivie',
    alcoholDeliveryEducationDateMissing: 'Date manquante',
    alcoholDeliveryEducationDateRequired: "Indiquez la date à laquelle la formation de livraison d'alcool a été suivie",
    alcoholDeliveryEducationValidToDate: "Valide jusqu'au {{date}}",
    alcoholDeliveryEducationExpiresDate: 'Expire le {{date}}',
    alcoholDeliveryEducationExpiredDate: 'Expirée le {{date}}',
    alcoholDeliveryEducationValidTo: "Valide jusqu'au",
    alcoholDeliveryEducationValidToRequired: "Indiquez la date jusqu'à laquelle la formation est valide",
    alcoholDeliveryEducationValidToAfterEducationDate:
      'La date de validité doit être postérieure à la date de formation suivie',
    approved: 'Approuvée',
    notApproved: 'Non approuvée',
    couriersInCurrentDepartment: 'Coursiers du département actuel',
    editCourier: 'Modifier un coursier :',
    courierUserUpdated: 'Le coursier a été mis à jour avec succès.',
    dateOfBirth: 'Date de naissance',
    dateOfBirthWithFormat: 'Date de naissance (aaaa-mm-jj)',
    occupationalInjuryInsurance: 'Assurance contre les accidents du travail',
    courierScanEnabled: 'Scanner',
    breakTime: 'Temps de pause',
    breakDuration: 'Durée de la pause (min)',
    timeWindow: 'Début de la pause (le plus tôt et le plus tard)',
    breakTimeDescription:
      "Dans les champs de saisie <i>Début de la pause (le plus tôt et le plus tard)</i>, vous définissez l'heure la plus tôt et la plus tardive à laquelle la pause doit commencer. Par exemple, définir 11:00 - 17:00 signifie que l'heure la plus tardive pour commencer la pause est 17:00.",
    breakOptimizingSupportDescription:
      "Veuillez noter que les pauses sont uniquement prises en charge lors de l'optimisation des itinéraires avec GraphHopper. Cette fonctionnalité n'est pas disponible lors de l'utilisation de PTV.",
    between: 'Entre',
    editBreakTime: 'Modifier le temps de pause',
    updateBreakTime: 'Mettre à jour le temps de pause',
    latestBreakStart: 'Dernier début de la pause',
    radioButtons: {
      noBreakTime: 'Aucun temps de pause',
      timeWindow: 'Fenêtre temporelle',
      workingTime: 'Temps de travail'
    },
    workingTimeDescription:
      'Vous définissez le temps de travail maximal avant que le conducteur ne doive prendre une pause. Par exemple, après 8 heures, le conducteur doit prendre une pause de 30 minutes.',
    maxWorkingTime: 'Temps de travail maximum',
    selectMaxWorkingTime: 'Sélectionner le temps de travail maximum',
    hours: '{{hours}} heures',
    breakTooltip: "Vous ne pouvez avoir qu'un seul type de pause par unité.",
    noCouriersExplain: "Nous n'avons trouvé aucun résultat. Veuillez essayer de rechercher avec un autre terme.",
    unitId: "Identifiant d'unité",
    minShipmentWeightKg: "Poids minimum d'une expédition sur ce véhicule (kg)",
    maxShipmentWeightKg: "Poids maximum d'une expédition sur ce véhicule (kg)",
    canCarryPallets: 'Peut transporter des palettes',
    noAvailableHatchInParcelBoxMachine: 'Pas de trappe disponible',
    packageDoesNotFitInParcelBox: 'Le colis dépasse les dimensions/poids autorisés',
    unknownErrorForParcelBoxDelivery: 'Autre inconnu',
    errorInParcelBoxMachine: 'La machine est en panne',
    euroClassTypes: { euroEL: 'Euro EL', euro5: 'Euro 5', euro6: 'Euro 6' },
    co2: 'CO2',
    inCurrentDepartment: 'Service actuel',
    couriersInOtherDepartments: "Coursiers dans d'autres services",
    inOtherDepartments: 'Différents services',
    confirmConnect: 'Associer un coursier au service actuel',
    searchForCouriers: 'Rechercher des coursiers',
    dateNotValid: 'Date non valide'
  },
  slot: {
    minutesDelay: 'minutes de retard',
    minutesAhead: "minutes d'avance",
    time: 'Heure',
    created: 'Créé',
    assigned: 'Affecté',
    lock: 'Verrouiller',
    lockDescription:
      "Lorsque la tournée est verrouillée, elle ne fera pas partie des optimisations d'itinéraire futures et ne peut pas être modifiée.",
    toggleVisibleSlotDescription: 'Masquer la tournée.',
    inProgress: 'En cours',
    onHold: 'En attente',
    complete: 'Terminé',
    unknownState: 'État inconnu',
    courierSelect: 'Sélectionner un coursier',
    unitSelect: "Sélectionner l'unité",
    printableSlotList: 'Liste de tournées imprimable',
    followsRoute: 'Suit',
    doesNotFollowRoute: 'Ajouter un échec',
    hasNoLocation: 'Non visible',
    showActiveSlots: 'Tournées en cours',
    showSlotNotStarted: 'Tournées non commencées',
    showLoggedInRoutes: 'Connecté - non démarré',
    showCompletedSlot: 'Tournées terminées',
    showPerfectSlot: 'Tournées parfaites',
    filterSlots: 'Filtrer les tournées',
    planningCompleted: 'Terminé',
    completeWithLastSent: '{{label}} (dernier envoi : {{time}})',
    addMapArea: 'Ajouter la zone de la carte',
    editMapArea: 'Modifier la zone de la carte'
  },
  login: {
    heading: 'Connexion',
    phone:
      "Entrez votre numéro de téléphone enregistré auprès de Glow avec l'indicateur pays (p. ex. +47...), et nous vous enverrons un jeton SMS",
    code: 'Jeton envoyé, si vous avez un utilisateur enregistré avec ce numéro. Il est valide pendant 5 minutes. Entrer le jeton.',
    requestNewCode: 'Demander un autre code',
    verifyFailed:
      'Le jeton ou le numéro de téléphone est incorrect, ou vous avez fait un nombre excessif de tentatives. Réessayez ou demandez un autre code',
    requestFailed: "Impossible d'envoyer un jeton. Réessayez plus tard.",
    verifyTokenButton: 'Vérifier le jeton',
    requestTokenButton: 'Demander un jeton',
    privacyLink: 'Politique de confidentialité',
    passwordWrong: 'Mot de passe incorrect',
    customer: 'Je suis un(e) client(e)',
    forgotPassword: 'Oublié votre mot de passe ?',
    tryApp: 'Essayez la nouvelle appli !',
    appDownload: "Téléchargez l'appli de coursier ici et profitez d'un nombre de fonctions encore plus grand !",
    appInfo:
      "Êtes-vous un coursier possédant un smartphone Android ? Téléchargez l'appli de pilotes <1>ici</1> et profitez d'un nombre de fonctions encore plus grand !",
    webApp: 'Application Web',
    note: "Remarque ! Utilisez uniquement la version Web de l'appli de coursier si, pour une raison quelconque, vous ne pouvez pas utiliser les applis pour iOS et Android",
    resendToken: 'Envoyer à nouveau le jeton',
    submitPassword: 'Soumettre le mot de passe',
    loginAsCustomer: 'Se connecter en tant que client',
    loginAsPlanner: 'Se connecter en tant que planificateur',
    loginAsPartnerOrPhoneNumber: 'Connectez-vous en tant que partenaire',
    loginWithPhoneNumber: 'Connectez-vous avec un numéro de téléphone',
    loginUsingSSO: 'Se connecter avec un compte Posten',
    partnerLoginTitle: 'Phone number sign-in is for partners',
    partnerLoginBody:
      'Only partner users can sign in using a phone number. As a Glow & Bring employee, please use <pageLink>this page</pageLink>.',
    ssoLoginFailed:
      'La connexion a échoué. Veuillez contacter le service desk de Posten et Bring si le problème persiste.',
    token: 'Code',
    password: 'Mot de passe',
    tokenRequired: 'Le code est requis',
    forgotPasswordDescription:
      'Pour continuer, vous devez définir un mot de passe. Nous vous enverrons un e-mail avec un lien pour le définir. Si votre adresse e-mail a changé, vous devez contacter un administrateur pour la modifier.',
    sendEmailDescription:
      "Pour continuer, nous avons besoin de votre adresse e-mail. Nous vous enverrons un lien de confirmation à l'adresse fournie. Avec ce lien, vous pouvez définir votre mot de passe à deux facteurs.",
    emailFormatValidation: "L'e-mail doit être dans un format valide",
    sendEmailSuccess: "L'e-mail devrait arriver sous peu",
    sendEmailFailed: 'L’envoi de l’e-mail a échoué, réessayez',
    setYourPassword: 'Définir votre mot de passe',
    sendEmail: "Envoyer l'e-mail",
    passwordsDontMatch: 'Les mots de passe ne correspondent pas',
    passwordNotMeetRequirements: 'Le mot de passe ne répond pas aux exigences',
    passwordRequired: 'Le mot de passe est obligatoire',
    newPassword: 'Nouveau mot de passe',
    repeatPassword: 'Répétez votre mot de passe',
    lowercaseLetter: 'Une lettre minuscule',
    uppercaseLetter: 'Une lettre majuscule',
    numberCharacter: 'Un chiffre',
    minimumCharacters: 'Minimum 15 caractères',
    passwordDescription: 'Vous pouvez maintenant définir votre mot de passe, il doit contenir les éléments suivants'
  },
  error: {
    '404Title': 'Page introuvable',
    '404Message': 'Impossible de trouver la page que vous recherchez',
    '500Message': '{{error}} - Désolé, impossible de trouver vos données... nous réessayerons dans une minute...',
    title: "Une erreur s'est produite !",
    dateRequiredWhenSecureLogin: '*Champ obligatoire si l’identifiant bancaire est active',
    dateNotValid: 'Date non valide',
    dateCannotBeInFuture: 'La date ne peut pas être dans le futur',
    dateCannotBeInThePast: 'La date ne peut pas être dans le passé',
    dateCannotBeOlderThanMonths: 'La date ne peut pas avoir plus de {{months}} mois',
    dateOutsideRange: 'Date en dehors de la plage valide',
    errorMessage:
      "Nous sommes désolés ! Cela n'a pas fonctionné comme prévu, mais les développeurs ont été avisés de cette erreur.",
    errorClickToReload: 'Cliquez ici pour recharger la page',
    phoneNumber: 'Vous devez préciser numéro de téléphone valide, p. ex. +47 12345678',
    phoneNumberPrefix: "Vous devez préciser l'indicateur pays, p. ex. +47...",
    somethingWentWrong: "Une erreur s'est produite.",
    andMoreErrors_one: 'et {{count}} autre erreur',
    andMoreErrors_other: 'et {{count}} autres erreurs',
    notAValidNumber: 'Numéro non valide',
    notAValidAlphaNumeric: 'Doit contenir des chiffres, les lettres sont optionnelles',
    notAValidDate: 'Doit être une date valide (aaaa-mm-jj)',
    notAValidTime: 'Doit être une heure valide (hh:mm)',
    notAValidDuration: 'Doit être une durée valide (mm:ss)',
    notAValidZipCode: 'Doit être un code postal valide',
    notAValidPostalCodeRange: 'Le « Code postal de début » doit être inférieur ou égal au « Code postal de fin »',
    notAValidTimezone: 'Doit être un fuseau horaire valide. Essayez « Europe/Oslo » ou une entrée similaire',
    somethingWentWrongOnTheServer: "Une erreur s'est produite sur le serveur...",
    somethingWentWrongWithTheRequest: "Une erreur s'est produite avec la requête...",
    somethingWentWrongWithTheResponse: "Une erreur s'est produite avec la réponse...",
    selectAtLeastOne: 'Vous devez sélectionner au moins une option',
    invalidEmail: 'Vous devez fournir une adresse e-mail valide, ex. name@gmail.com',
    requiredBreakDuration: 'Vous devez entrer la durée de la pause',
    notAValidTimeWindow: 'Le début de la pause la plus tôt doit être avant la plus tardive',
    requiredEarliestStartBreak: 'Vous devez entrer l’heure de début de pause la plus tôt',
    requiredLatestStartBreak: 'Vous devez entrer l’heure de début de pause la plus tardive',
    requiredIfWorkingTimeDuration: 'Vous devez entrer la durée maximale de travail',
    invalidUrlParameterCombination:
      'Cette combinaison de paramètres d’URL est invalide et la page ne peut pas être affichée',
    numberCannotContainDecimals: 'Le nombre ne peut pas contenir de décimales',
    selectAtLeastOneItem: 'Au moins un élément doit être sélectionné',
    mustSelectDepartment: 'Vous devez sélectionner un département',
    mustSelectRoute: 'Vous devez sélectionner un itinéraire',
    mustProvideLabel: 'Vous devez fournir {{label}}',
    sizeMustBeAnIntegerGreaterThanZero: 'La taille doit être un nombre sans décimales supérieur ou égal à 1'
  },
  loading: 'Extraction de vos données en cours...',
  newAppVersion: "Glow s'est encore amélioré, nous allons maintenant extraire la nouvelle version.",
  loadingReceiptList: 'Les listes de signatures sont en cours de création...',
  invoicing: { departmentInvoicingInProgress: 'La facturation est en cours...' },
  months: {
    january: 'Janvier',
    february: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Août',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Décembre'
  },
  weekdays: {
    monday: 'Lundi',
    tuesday: 'Mardi',
    wednesday: 'Mercredi',
    thursday: 'Jeudi',
    friday: 'Vendredi',
    saturday: 'Samedi',
    sunday: 'Dimanche'
  },
  weekdaysShort: {
    sunday: 'Dim',
    monday: 'Lun',
    tuesday: 'Mar',
    wednesday: 'Mer',
    thursday: 'Jeu',
    friday: 'Ven',
    saturday: 'Sam'
  },
  notifications: {
    dismiss: 'Rejeter',
    dismissAll: 'Rejeter tout',
    error: 'Erreur',
    reload: 'Rafraîchir',
    reloadCourier: 'Appuyer ici pour recharger',
    navigate: 'Accéder à la page',
    networkError:
      "Il semble qu'il y ait des problèmes de réseau, ils sont peut-être temporaires. Toutefois, la page doit être rechargée.",
    networkErrorCourier: 'Vous avez été hors ligne, veuillez recharger.',
    liveUpdatesPaused: 'Mises à jour en direct en pause',
    liveUpdatesDescription:
      'Les mises à jour en direct ont été mises en pause pendant que l’onglet était inactif. Cliquez pour recharger et appliquer les dernières mises à jour.'
  },
  modals: {
    preplan: {
      create: "Préplanifier l'expédition",
      change: 'Changer le livreur prévu',
      shipmentInfo: "Préplanifier l'expédition {{shipmentId}} (de {{pickupName}} à {{deliveryName}})",
      pickDriver: 'Choisir un livreur.',
      unpreplan: 'Annuler une préplanification',
      preplan: 'Préplanifier',
      error: "Impossible de préplanifier l'expédition",
      notification: {
        preplanned: 'Préplanifiée',
        unpreplanned: 'Non préplanifiée',
        preplannedMessage: "L'expédition était préplanifiée pour {{courierId}}",
        unpreplannedMessage: "L'expédition n'était pas préplanifiée"
      }
    },
    maps: {
      save: 'Enregistrer les modifications',
      cancel: 'Annuler',
      delete: 'Supprimer',
      editMode: 'Modifier le mode',
      mapArea: 'Zone de la carte {{routeName}}',
      saved: 'Enregistré(e)',
      deleted: 'Supprimé(e)'
    }
  },
  grid: {
    columns: {
      addressWashRecipientId: 'ID du destinataire',
      addressWashAddressId: "ID de l'adresse",
      department: 'Département',
      deadline: 'Délai limite',
      failedReason: "Message d'erreur",
      dispatchAsGroup: 'Expédier comme groupe',
      name: 'Nom',
      senderName: "Nom de l'expéditeur",
      puearly: 'ENL',
      pulate: 'ENL',
      delearly: 'LIV',
      dellate: 'LIV',
      vas: 'SAV',
      zip: 'Code postal',
      estimated: 'Heure estimée',
      adjusted: 'Ajusté(e)',
      timeWindow: 'Créneau horaire',
      onCar: 'Dans la voiture',
      frequency: 'Fréquence',
      startDate: 'Date de début',
      endDate: 'Date de fin (facultatif)',
      from: 'De',
      to: 'A',
      days: 'Jours',
      holidays: 'Jours fériés',
      startdate: 'Date de début',
      enddate: 'Date de fin',
      orders: 'Commandes',
      id: 'ID',
      shipmentId: 'ID expédition',
      packageId: 'ID colis',
      errorMessage: "Message d'erreur",
      customer: 'Client',
      pickup: 'Enlèvement',
      delivery: 'Livraison',
      address: 'Adresse',
      zipcode: 'Code postal',
      area: 'Région',
      weight: 'Poids{{unit}}',
      bookedWeight: 'Poids réservé{{unit}}',
      bookedVolume: 'Volume réservé{{unit}}',
      qty: 'Qté',
      preplanned: 'Préplanifié(e)',
      preplannedRouteTemplate: 'Itinéraire',
      group: 'Groupe',
      totalOrders: 'Total des commandes',
      ordersFailed: 'Commandes non abouties',
      date: 'Date',
      finished: 'Terminée',
      failed: 'Non aboutie',
      ordersInvoiced: 'Commandes facturées',
      start: 'Départ',
      stop: 'Arrêt',
      pickupContactPerson: "Personne de contact pour l'enlèvement",
      pickupPhone: "Téléphone pour l'enlèvement",
      deliveryContactPerson: 'Personne de contact pour la livraison',
      deliveryPhone: 'Téléphone pour la livraison',
      contactPerson: 'Personne de contact',
      phone: 'Téléphone',
      deliveryReferencePlaceholder: 'Référence du destinataire',
      specificationDescriptionPlaceholder: 'Informations sur les marchandises',
      multileg: 'Plusieurs étapes',
      groupName: 'Nom du groupe',
      customerNumber: 'Client no',
      orderNote: 'Note interne',
      returned: 'Retourné(e)',
      price: 'Prix',
      slotName: 'Tournée',
      waitingTime: "Temps d'attente",
      timeOfDelivery: 'HdL',
      timeOfPickup: 'HdE',
      deliveryEtaSmsSentAt: "Liv. Un SMS d'ETA e a été envoyé",
      trip: 'Tournée',
      addresses: {
        title: 'Adresses',
        search: "Recherche d'adresses",
        searchAddresses: 'Rechercher des adresses',
        filterAddresses: 'Filtrer les adresses',
        deleteConfirmation: 'Voulez-vous vraiment supprimer cette adresse ?',
        deleteMultipleConfirmation: 'Voulez-vous vraiment supprimer toutes les adresses sélectionnées ?',
        deleteSuccess: "L'adresse a été supprimée avec succès",
        deleteMultipleSuccess: 'Les adresses ont été supprimées avec succès',
        delete: 'Supprimer',
        name: 'Nom',
        phone: 'Numéro de téléphone',
        address: 'Adresse',
        zipArea: 'Région',
        zipCode: 'Code postal',
        country: 'Pays',
        contactPerson: 'Personne de contact',
        deleteAddress: "Supprimer l'adresse",
        deleteMultipleAddresses: 'Supprimer les adresses ({{count}})',
        loc: 'Empl',
        locTitle: 'Emplacement'
      },
      orderGrid: { vehicleType: 'Véhicule', extraInfo: 'Autres infos' },
      dispatch: {
        adjusted: 'Ajusté(e)',
        customerName: 'Nom du client'
      },
      goodsType: 'Type de marchandise',
      orderSource: 'Source de la commande',
      postalCodes: 'Codes postaux #',
      displayEndCustomerPriceShd: 'Afficher le prix client',
      courier: 'Coursier',
      createdBy: 'Créé(e) par',
      plannedDeliveryDate: 'Date prévue',
      orderedDeliveryDate: 'Date commandée',
      lastUpdatedAt: 'Dernière mise à jour à',
      route: 'Itinéraire',
      pickupDuration: 'Durée enlèvement',
      deliveryDuration: 'Durée livraison',
      pickupPreparation: 'Préparation enlèvement',
      deliveryPreparation: 'Préparation livraison',
      originalPickupAddress: "Adresse d'expéditeur d'origine",
      originalPickupZipCode: "Code postal d'expéditeur d'origine",
      originalPickupZipArea: "Ville d'expéditeur d'origine",
      originalPickupCountry: "Pays d'expéditeur d'origine",
      originalDeliveryAddress: "Adresse de livraison d'origine",
      originalDeliveryZipCode: "Code postal de livraison d'origine",
      originalDeliveryZipArea: "Ville de livraison d'origine",
      originalDeliveryCountry: "Pays de livraison d'origine",
      packagesArrivedAtDip: 'Arrivé(e)',
      packagesCollected: 'Enlèvement effectué',
      packagesDelivered: 'Livraison effectuée',
      originalDeliveryEarliest: "LIV d'origine",
      originalDeliveryLatest: "LIV d'origine",
      loadCarrier: 'Transporteur',
      pickupZipCode: 'Code postal de collecte',
      pickupArea: 'Zone de collecte',
      deliveryZipCode: 'Code postal de livraison',
      deliveryArea: 'Zone de livraison',
      plannedStops: 'Arrêts planifiés'
    }
  },
  openBooking: {
    error: {
      pickupTimeBeforeEarliestServicePickupTime: 'Erreur',
      pickupNotAvailableForWeekend: "Le service d'enlèvement n'est pas disponibles les weekends",
      invalidOrganisationNumber: "Numéro d'organisation non valable"
    }
  },
  instant: {
    title: 'Dispatch',
    openMap: 'Ouvrir la carte',
    group: 'Groupe sélectionné',
    editGroup: 'Modifier le groupe',
    groupName: 'Nom du groupe',
    groupOrders: 'Commandes du groupe',
    viewGroup: 'Voir le groupe',
    ordersToGroup: 'Commandes pour le groupe',
    fixedOrder: "L'ordre de livraison fixe",
    saveFixedOrder: "Enregistrer les modifications de l'ordre",
    paidTogether: 'Paiement regroupé',
    saveGroup: 'Enregistrer le groupe',
    ungroup: 'Dégrouper',
    removeSelected: 'Supprimer la sélection',
    split: 'Diviser la sélection',
    noCourierSelected: 'Aucun coursier sélectionné',
    noOrderSelected: 'Aucune commande sélectionnée',
    workingHours: 'Heures de travail',
    chatButton: 'Tchatter avec le livreur',
    offeredShipments: 'Expéditions offertes',
    rejectedShipments: 'Expéditions refusées',
    rejectedShipmentsSnackbar: '{{count}} expédition refusée par "{{name}}"',
    rejectedShipmentsSnackbar_other: '{{count}} expéditions refusées par "{{name}}"',
    toBeDone: 'Enlèvements et livraisons à effectuer',
    finishedRoutePoints: 'Enlèvements et livraisons terminés',
    suggestedRouteApplied: "L'itinéraire suggéré a été appliqué",
    suggestedRouteCancelled: "L'itinéraire suggéré a été annulé",
    reorderValidationError: "L'ordre de l'itinéraire suggéré est invalide",
    planSlot: "Plan d'itinéraire",
    columnSettings: {
      reset: 'Rétablir',
      settings: 'Paramètres',
      hideColumns: 'Afficher les colonnes',
      saveAndClose: 'Enregistrer et fermer'
    },
    routePoint: { pickup: 'E', delivery: 'L' },
    confirmation: {
      heading: 'Confirmation de commande',
      from: 'De',
      to: 'A',
      pickup: 'Enlèvement',
      delivery: 'Livraison',
      shipmentNumber: "Numéro d'expédition",
      printLabel: "Imprimer l'étiquette",
      copyOrder: 'Copier la commande',
      editOrder: 'Modifier la commande'
    },
    goods: {
      custom: 'Personnaliser',
      letter: 'Lettre',
      bag: 'Poche',
      smallbox: 'Boîte petit format',
      mediumbox: 'Boîte moyen format',
      largebox: 'Boîte grand format',
      halfpallet: 'Demi-palette',
      quarterpallet: 'Quart de palette',
      fullpallet: 'Palette complète',
      suitcase: 'Valise',
      movingbox: 'Carton de déménagement',
      trolley: 'Chariot',
      parcel: 'Colis'
    },
    instantGrid: {
      editColumnTooltip: 'Cliquez pour modifier',
      deleteColumnTooltip: 'Cliquez pour supprimer',
      unassignColumnTooltip: "Cliquez pour annuler l'affectation d'une expédition",
      dragColumnTooltip: 'Cliquez et faites glisser pour affecter à un coursier',
      filtersActive: 'Les filtres sont actifs',
      clearFilters: 'Supprimer tous les filtres',
      filterPlaceholder: 'filtre <entrer>',
      assignColumnTooltip: "Cliquez pour affecter l'envoi"
    },
    booking: {
      numberOfCopies: 'Nombre de copies',
      numberOfCopiesPlaceholder: 'Entrez un nombre entre {{min}} et {{max}}',
      numberOfCopiesError: 'Vous devez entrer un nombre entre {{min}} et {{max}}',
      afterCutoffWarning:
        "Livraison indisponible - l'heure limite de {{cutoffTime}} aujourd'hui est dépassée. Veuillez choisir un autre service ou jour de livraison.",
      standaloneInvoiceCheckbox: 'Marquer comme facture indépendante',
      standaloneInvoiceDescription:
        "En sélectionnant cette option, cette commande sera traitée individuellement et ne sera pas regroupée avec d'autres commandes pour la facturation.",
      addPackage: 'Ajouter un nouveau forfait',
      removePackageRow: 'Supprimer le paquet',
      cannotRemoveLastPackageRow: 'Impossible de supprimer le dernier paquet',
      copyPackageRow: 'Copier le paquet',
      title: 'Réservation',
      header: 'Réservation',
      headerCreate: 'Nouvelle réservation',
      headerEdit: 'Modifier la réservation',
      headerCopy: 'Copier la réservation',
      headerRestore: 'Restaurer la réservation',
      customer: 'Client',
      customerPlaceholder: 'ID Client',
      priceDetails: 'Détails des prix',
      subcustomerPlaceholder: 'Client ultérieur',
      invalidSubcustomer: 'Le nom du sous-client est invalide',
      invoiceSplitPlaceholder: 'Division de les factures',
      invoiceSplitPlaceholderLegend: 'Sélectionner la division de les factures',
      shipmentOrPackageId: 'ID expédition ou ID colis',
      creditBlockedCustomer: 'Client au crédit bloqué',
      sender: 'Expéditeur',
      setAsDefaultAddress: 'Définir comme adresse par défaut',
      defaultAddressUpdated: 'Adresse par défaut mise à jour',
      recipient: 'Destinataire',
      pickupNamePlaceholder: 'Nom',
      pickupAddressPlaceholder: 'Adresse',
      pickupZipCodePlaceholder: 'Code postal',
      pickupZipAreaPlaceholder: 'Ville',
      pickupCountryPlaceholder: '-- Sélectionner le pays--',
      pickupPhoneNumberPlaceholder: 'Téléphone',
      pickupContactPerson: 'Personne de contact',
      customerReference: 'Référence client',
      pickupReferencePlaceholder: 'Référence client – Ce champ est visible sur la facture du client',
      pickupInformationPlaceholder: "Information d'enlèvement",
      customerContact: 'Contact client',
      customerContactPlaceholder: '$t(instant.booking.customerContact) – Ce champ est visible sur la facture du client',
      customerInfoPlaceholder: 'Informations générales propres au client',
      customerInfoHelper:
        'Ces informations se rapportent au client. Les modifications apportées seront visibles dans toutes les commandes liées à ce client.<br><br>Pour ajouter des informations propres à une commande, utilisez le champ de saisie « Remarque » ci-dessous.',
      deliveryNamePlaceholder: 'Nom',
      letterBoxPrefix: 'Boîte aux lettres',
      letterBoxAlt: 'Boîte aux lettres {{operator}}',
      deliveryAddressPlaceholder: 'Adresse',
      deliveryZipCodePlaceholder: 'Code postal',
      deliveryZipAreaPlaceholder: 'Ville',
      deliveryCountryPlaceholder: '-- Sélectionner le pays--',
      deliveryPhoneNumberPlaceholder: 'Téléphone',
      deliveryReferencePlaceholder: 'Référence du destinataire',
      deliveryInformationPlaceholder: 'Informations de livraison',
      orderNote: 'Note interne',
      invalidInvoiceSplit: 'Texte de fractionnement de facture non valide',
      clearData: 'Effacer les données',
      dimensions: 'Marchandises',
      weightPlaceholder: 'Poids (kg)',
      lengthPlaceholder: 'Longueur (cm)',
      widthPlaceholder: 'Largeur (cm)',
      heightPlaceholder: 'Hauteur (cm)',
      serviceCode: 'Code de service',
      servicePlaceholder: 'Code de service',
      serviceSelect: 'Sélectionner le service',
      serviceSelectDisabled: 'Toute modification des services sur les commandes HD doit être effectuée dans HappyFlow',
      goodsEditDisabled: 'Toute modification des Marchandises sur les commandes HD doit être effectuée dans HappyFlow',
      standardServices: '-- SERVICES STANDARD --',
      customizedServices: '-- SERVICES UNIQUES CLIENT --',
      specificationDescription: 'Marchandises',
      specificationDescriptionPlaceholder: 'Informations sur les marchandises',
      invoiceInfo: 'Informations de facturation',
      invoiceInfoPlaceholder: 'Informations de facturation – Ce champ est visible sur la facture du client',
      manualInvoiceInfoPlaceholder:
        'Gestion manuelle des factures (si ce champ est renseigné avec des instructions de facturation, la commande ne sera pas automatiquement facturée)',
      pickup: 'Enlèvement',
      delivery: 'Livraison',
      pickupDatePlaceholder: "Date d'enlèvement",
      pickupTimePlaceholder: "Heure d'enlèvement",
      deliveryDatePlaceholder: 'Date de livraison',
      deliveryTimePlaceholder: 'Heure de livraison',
      deliveryContactPerson: 'Personne de contact',
      restoreButton: 'Restaurer',
      orderButton: 'Commander',
      editButton: 'Mettre à jour',
      copyButton: 'Copier',
      created: 'La commande a été enregistrée',
      edited: 'La commande a été mise à jour',
      quickSelect: 'Sélection rapide',
      totalVolume: 'Volume total {{volume}}',
      totalWeight: 'Poids total {{weight}}',
      removeItem: 'Supprimer',
      copyItem: 'Copier',
      addItem: 'Ajouter',
      calculatePrice: 'Calculer le prix',
      priceExplanations: {
        header: 'Explication du prix',
        priceListName: 'Liste de prix:: {{pricelist}}',
        explanations: 'Explications',
        noInfo: 'Aucune information de prix disponible',
        details: 'Détails',
        notFound: 'Aucune explication de prix disponible.'
      },
      approveIncompletePrice: "J'approuve toutes les lignes avec un prix zéro",
      muteBomArticles: 'Exclure {{bomArticle}} de la facturation',
      prePlan: 'Préplanifier',
      prePlannedToCourier: 'Sélectionner un coursier',
      prePlannedToRouteTemplate: "Sélectionnez le modèle d'itinéraire",
      prePlannedToRouteText:
        "L'itinéraire disponible dépend des modèles enregistrés dans le département. Pour que la planification préétablie fonctionne correctement, vous devez configurer les paramètres d'itinéraire au <0>niveau du département</0> dans les pages d'administration.",
      automaticDepartment: 'Automatique',
      departmentLabel: 'Département',
      notifications: 'Notifications',
      emailNotifications: 'Notifications par e-mail',
      eventRegistered: 'Enregistrer',
      eventPickup: 'Enlèvement',
      eventDelivery: 'Livraison',
      emailAddress: 'Adresse électronique',
      emailRecipientText: 'Des notifications seront envoyées aux adresses e-mail suivantes :',
      invalidEmail: 'Adresse e-mail invalide',
      editIndicator: 'Modifier',
      updateIndicator: 'Mettre à jour',
      copyIndicator: 'Copier',
      quantity: 'Quantité',
      additionalServices: 'Services additionnels',
      paymentInformation: 'Informations de paiement',
      paidTogetherLabel: 'Paiement regroupé ?',
      groupingLabel: 'Regroupement des expéditions',
      groupIdPlaceholder: 'ID de groupe unique',
      groupOrderPlaceholder: "Commande d'expédition de groupe",
      addRecipient: 'Ajouter un destinataire supplémentaire',
      addPickup: 'Ajouter un expéditeur supplémentaire',
      vehicleType: 'Type de véhicule',
      vehicleTypeUpdated: 'Type de véhicule mis à jour',
      selectVehicleType: 'Sélectionner le type de véhicule',
      customerPrice: 'Prix client',
      resourcePrice: 'Prix unitaire',
      priceList: 'Liste de prix',
      manualPrice: 'Manuel',
      vehicleTypes: {
        car: 'Voiture',
        bicycle: 'Bicyclette',
        truck: 'Camion',
        van: 'Camionnette',
        motorcycle: 'Moto',
        cargobike: 'Vélo cargo'
      },
      unNumber: 'No ONU',
      hazardous: 'Classe',
      group: 'Groupe',
      netWeight: 'Poids net',
      name: 'Nom',
      totalPoints: 'Points totaux',
      serviceMessage: "N'oubliez pas d'ajouter un client pour voir les services disponibles",
      pickupTimeEarliest: "Première heure d'enlèvement",
      pickupTimeLatest: "Dernière heure d'enlèvement",
      deliveryTimeEarliest: 'Première heure de livraison',
      deliveryTimeLatest: 'Dernière heure de livraison',
      henteordre: {
        availableTimeSlots: 'Créneaux horaires disponibles',
        setCustomTimes: 'Définir des horaires personnalisés',
        selectAvailableTimes: 'Sélectionner les horaires disponibles',
        enterPickupZipCode: 'Entrez le code postal de collecte pour voir les créneaux disponibles'
      },
      hazardousGoods: 'Marchandises dangereuses'
    },
    courierSorting: { title: 'Tri par', alystraId: 'Numéro de livreur', empty: 'Vide', full: 'Plein' },
    courierFilter: {
      title: 'Filtrer les coursiers par',
      all: 'Afficher tout',
      inactive: 'Masquer les éléments inactifs',
      offline: 'Masquer les éléments hors ligne',
      both: 'Masquer les éléments inactifs et hors ligne'
    },
    invoicingFilter: {
      ALL: 'Afficher tout',
      INVOICED_OK: 'Déjà facturé(e)',
      TO_BE_INVOICED: 'À facturer',
      ORDER_CORRECTION: 'Avec correction de commande',
      INVOICED_FAILED: 'Echec de facturation'
    },
    shipmentFilter: {
      title: 'Filtrer les expéditions',
      showAll: 'Afficher tout',
      notCollected: 'Enlèvement non effectué',
      hideAll: 'Masquer tout'
    },
    offer: {
      carEmpty: 'Voiture actuellement vide',
      suggestedDelivery: 'Ordre de livraison suggéré',
      newShipments: 'Nouvelles expéditions',
      manualRoute: 'Itinéraire manuel',
      confirmRoute: "Confirmer l'itinéraire",
      assigning: 'Affectation en cours',
      replanning: "Replanification de l'itinéraire pour",
      shipmentsTo: 'les expéditions à',
      shipmentTo: "l'expédition à"
    },
    useFlexible: 'Utiliser des horaires flexibles',
    forceOptimizing: "Forcer l'optimisation de la commande",
    replanRoute: "Replanifier l'itinéraire",
    recurring: {
      exceptionsUpdated: 'Exceptions mises à jour',
      recurringOrderSaved: 'Commande récurrente enregistrée',
      executeDate: "Date d'exécution",
      confirmExecuteOrders: 'Êtes-vous sûr de vouloir exécuter toutes les commandes récurrentes pour {{date}}?',
      editRecurringOrder: 'Modifier la commande récurrente',
      createRecurringOrder: 'Créer une commande récurrente',
      title: 'Récurrent(e)',
      successMessage: '{{number}} expédition(s) a(ont) été ajoutée(s) aux groupes récurrents sélectionnés',
      recurringOrders: 'Commandes récurrentes',
      includedOrders: 'Commandes incluses dans la tournée',
      details: 'Détails',
      editOriginal: "Modifier l'original",
      copyOriginal: "Copier l'original",
      notStarted: 'Non commencé(e)',
      executing: 'Exécution en cours...',
      ended: 'Terminé(e)',
      status: 'Statut',
      pending: 'En attente',
      failedOrders: 'Echec des commandes',
      exceptionsHeading: 'Exceptions pour les commandes',
      addExceptionHeading: "Nouvelle période d'exception",
      exceptionStart: 'Départ',
      exceptionEnd: 'Fin',
      editExceptions: 'Modifier les exceptions',
      addRecurring: 'Récurrent(e)',
      addToGroup: 'Sélectionner le groupe récurrent',
      recurringOrderAddedConfirmation: 'Commande ajoutée au groupe récurrent',
      dispatchAsGroup: 'Expédier comme groupe',
      name: 'Nom',
      frequency: 'Fréquence',
      frequencies: {
        weekly: 'Toutes les semaines',
        second_week: 'Toutes les deux semaines',
        third_week: 'Toutes les trois semaines',
        monthly: 'Chaque mois'
      },
      daysOfWeek: 'Jours de la semaine',
      includeHolidays: 'Y compris jours fériés',
      endsNextDay: 'Se termine le jour suivant',
      endsNextDayExplanation:
        "Uniquement pour les tournées qui passent minuit. L'heure de début est le premier jour et l'heure de fin le jour suivant.",
      endsNextDayRequiredByShipments:
        "Décochez l'enlèvement ou la livraison le jour suivant sur les envois avant de retirer ceci",
      pickupNextDay: 'Enlèvement le jour suivant',
      deliveryNextDay: 'Livraison le jour suivant',
      nextDayExplanation:
        "La plage commence le premier jour de la tournée. Seule l'heure la plus tardive passe au jour suivant.",
      createBillingOrder: 'Créer une commande de facturation',
      customerForBillingOrder: 'Client pour la commande de facturation',
      errorBeforeToday: "Ne peut pas être antérieure à aujourd'hui",
      errorEndBeforeStart: 'Ne peut pas être antérieure à la date de début',
      excludedDateRanges: {
        title: 'Dates exclues',
        add: 'Ajouter à la liste',
        savedWithRoute: 'Les dates exclues sont enregistrées lorsque vous enregistrez la tournée',
        ongoing: 'en cours'
      },
      startDate: 'Date de début',
      endDate: 'Date de fin (facultatif)',
      save: 'Enregistrer',
      fromDate: 'Date de début',
      confirmDelete: 'Voulez-vous vraiment supprimer la ou les commandes récurrentes ?',
      numSelectedRoutes: '{{count}} sélectionné(e)(s)',
      deleteTemplateRoute: {
        title: "Supprimer l'itinéraire modèle",
        description: 'Cette action ne peut pas être annulée.'
      },
      deleteTemplateRoutes: {
        title: 'Voulez-vous vraiment supprimer {{count}} itinéraires ?',
        description: 'Cette action ne peut pas être annulée.'
      },
      rolloutTemplateRoutes: {
        title: 'Voulez-vous vraiment déployer {{count}} itinéraires ?',
        description: 'Les itinéraires seront déployés pour le {{date}}.',
        alreadyRolledOut: '{{count}} des itinéraires sont déjà déployés pour le {{date}} :',
        replaceWarning:
          "Leurs itinéraires et commandes seront supprimés puis redéployés. Les commandes reçoivent de nouveaux numéros d'expédition."
      },
      from: 'De',
      createOrders: 'Créer des commandes',
      showResult: 'Afficher le résultat',
      showRolloutResult: 'Afficher le résultat du déploiement',
      rolloutProblems: 'Problèmes de déploiement',
      rolloutProblemsFrom: 'Depuis le déploiement précédent, {{date}}',
      rolloutProblemsHandled: 'Problèmes de déploiement traités',
      noRolloutProblems: 'Aucun problème de déploiement sur cette période',
      noOutstandingRolloutProblems: 'Tous les problèmes de déploiement ont été traités',
      dealtWith: 'Traité',
      problems: 'Problèmes',
      problemType: 'Problème',
      severityCritical: 'Critique',
      severityWarning: 'Avertissement',
      rangeReversed: 'La date de début ne peut pas être postérieure à la date de fin',
      rangeTooLong: 'La période ne peut pas dépasser {{days}} jours',
      rangeNeedsEnd: 'Pour remonter au-delà de {{days}} jours, indiquez aussi une date de fin',
      problemRolloutFailed: 'Le déploiement a échoué',
      problemOrderNotCreated: 'Commande non créée',
      problemOrderNotOnRoute: 'Commande absente de la tournée',
      problemStopNotOnRoute: 'Arrêt planifié absent de la tournée',
      startdate: 'Date de début',
      enddate: 'Date de fin',
      orders: 'Commandes',
      executionSummary: "Résumé d'exécution",
      executions: 'Exécutions',
      executionStatus: "Statut d'exécution",
      executionId: 'Exécution',
      templateShipment: 'Expédition modèle',
      createdOrderId: 'ID commande créée',
      packageIds: 'ID colis',
      sentAt: 'Envoyé le',
      lastAttemptAt: 'Dernière tentative le',
      routeConnected: 'Connecté à l’itinéraire',
      optimizationRequestId: 'ID de requête d’optimisation',
      failedOptimizationRequestIds: 'ID de requêtes d’optimisation échouées',
      routeConnectedSummary: 'Connecté à l’itinéraire',
      onlyWithErrors: 'Uniquement avec erreurs',
      rolloutResult: {
        newView: 'Nouvelle vue',
        oldViewNotice:
          'Cette vue sera bientôt supprimée. La nouvelle vue affiche les problèmes à partir de cette date, regroupés par cause.',
        switchToNewView: 'Passer à la nouvelle vue',
        earlierProblems_one: 'Il reste {{count}} problème non traité du déploiement du {{date}}.',
        earlierProblems_other: 'Il reste {{count}} problèmes non traités des déploiements à partir du {{date}}.',
        showEarlierProblems: 'Les afficher',
        crumb: 'Résultat du déploiement',
        title: 'Résultat du déploiement - {{date}}',
        nothingRolledOut: "Rien n'a été déployé à partir de cette date",
        progress: 'Avancement du déploiement',
        showProgress: "Afficher l'avancement du déploiement",
        processing: 'Déploiement en cours',
        processingCount: 'Avancement · {{processed}} sur {{total}} itinéraires',
        done: 'Déploiement terminé',
        doneCount: '{{processed}} sur {{total}} itinéraires',
        routes: 'Itinéraires créés',
        createdOrders: 'Commandes créées',
        stops: 'Arrêts',
        failedStops: 'Arrêts en échec',
        orderStatus: {
          PENDING: 'En attente',
          SENT: 'Envoyée',
          CREATED: 'Créée',
          FAILED: 'En échec',
          MISSING: 'Manquante'
        },
        plannedStopStatus: {
          PENDING: 'En attente',
          CONNECTED: 'Connecté',
          FAILED: 'En échec'
        },
        unhandled: 'Non traités',
        handled: 'Traités',
        handledToggle: 'Afficher les problèmes non traités ou traités',
        unhandledCount: 'Problèmes non traités ({{count}})',
        handledCount: 'Problèmes traités ({{count}})',
        unhandledDescription: 'Corrigez les erreurs pour que le prochain déploiement ne les rencontre pas.',
        handledDescription: 'Problèmes marqués comme traités. Marquez-en un comme non traité pour le faire revenir.',
        unhandledEmpty: 'Aucun problème à traiter',
        handledEmpty: "Aucun problème n'a été marqué comme traité",
        groupDescription:
          'Une fois les informations corrigées, marquez le problème comme traité et il disparaît de la liste.',
        cause: {
          MISSING_CUSTOMER: {
            title: 'Numéro client manquant',
            description: 'Le client est introuvable. Il a peut-être été supprimé ou modifié.'
          },
          ORDER_NOT_CREATED: {
            description: "La commande n'a pas pu être créée. Voir la raison de l'échec."
          },
          TIME_WINDOW: {
            title: 'Créneau horaire',
            description: "La commande n'a pas été ajoutée à l'itinéraire à cause du créneau horaire."
          },
          MISSING_COORDINATES: {
            title: 'Coordonnées manquantes',
            description: "L'adresse n'a pas de coordonnées."
          },
          CAPACITY: {
            title: 'Capacité du véhicule insuffisante',
            description: "La commande n'a pas pu être chargée faute de capacité."
          },
          OPTIMIZATION_FAILED: {
            title: "Échec de l'optimisation",
            description: "L'optimisation de l'itinéraire a échoué après plusieurs tentatives."
          },
          ORDER_NOT_ON_ROUTE: {
            description: "La commande a été créée mais pas ajoutée à l'itinéraire. La cause n'est pas encore connue."
          },
          STOP_NOT_ON_ROUTE: {
            description:
              "L'arrêt n'a pas pu être ajouté à l'itinéraire, généralement à cause de son créneau horaire ou de son emplacement. Corrigez-le sur l'itinéraire modèle."
          }
        },
        filterRoutes: 'Filtrer les itinéraires',
        allRoutes: 'Tous les itinéraires',
        routeName: "Nom de l'itinéraire",
        templateRoute: 'Itinéraire modèle',
        rolledOutAt: 'Déployé',
        handledBy: 'Marquée comme traitée par',
        selectRow: 'Sélectionner {{route}} {{id}}',
        markAsHandled: 'Marquer comme traitée',
        markAsHandledHint: 'Il disparaîtra de la liste',
        markAsUnhandled: 'Marquer comme non traitée'
      },
      rolloutView: {
        label: 'Déploiements',
        current: 'Actuels',
        all: 'Tous, y compris remplacés',
        replaced: 'Remplacés uniquement'
      },
      replaced: 'remplacé',
      replacedAt: 'Remplacé le',
      replacedBy: 'Remplacé par',
      replacesExecution: "Remplace l'exécution",
      templateRouteId: 'ID itinéraire du modèle',
      templateRouteName: 'Nom de l’itinéraire modèle',
      createdAt: 'Créé le',
      updatedAt: 'Mis à jour le',
      date: 'Date',
      createdSlotId: 'ID itinéraire créé',
      createdBy: 'Créé par',
      failed: 'Non aboutie',
      by: 'Par',
      on: 'le',
      reset: 'rétablir',
      confirmReset: 'Voulez-vous vraiment rétablir les commandes récurrentes pour le {{date}} ?',
      startDateExplanation: 'Les commandes seront créées le même jour que la date de début',
      noOrderSelected: 'Aucune commande sélectionnée',
      noOrdersFound: 'Aucune commande trouvée',
      groups: 'Groupes',
      routes: 'Itinéraires',
      newRoute: 'Créer un nouvel itinéraire récurrent',
      recurringRoute: 'Itinéraire récurrent',
      tabFrequency: 'Fréquence',
      tabRoute: 'Itinéraire',
      tabTemplateShipments: 'Expéditions modèles',
      timeQuestion: 'À quelle heure l’itinéraire doit-il commencer et finir ?',
      frequencyQuestion: 'À quelle fréquence voulez-vous déployer les itinéraires ?',
      holidayRollout: 'Déploiement les jours fériés',
      holidayRolloutDescription:
        'Par défaut, les itinéraires ne sont pas déployés les jours fériés. Cochez cette option pour inclure les jours fériés dans le déploiement.',
      weekdaysQuestion: 'Quels jours de la semaine l’itinéraire doit-il livrer ?',
      periodQuestion: 'Quand voulez-vous que l’itinéraire commence et se termine ?',
      routeDetails: 'Détails de l’itinéraire',
      searchShipments: 'Rechercher des expéditions',
      editShipment: "Modifier l'expédition modèle",
      newTemplateShipment: 'Nouvelle expédition modèle',
      addShipments: 'Ajouter des expéditions',
      saveShipment: 'Enregistrer l’expédition',
      onRoute: "Sur l'itinéraire",
      findYourShipmentsDescription: 'Saisissez ce que vous recherchez dans le champ de recherche ci-dessus',
      saveFrequency: 'Enregistrer les paramètres de fréquence',
      saveRoute: 'Enregistrer les paramètres de l’itinéraire',
      saveShipments: 'Enregistrer les envois sur l’itinéraire',
      shipmentsAddedToRoute: 'Expéditions ajoutées à l’itinéraire',
      shipmentCopied: 'Expédition modèle copiée',
      routeCreated: 'Itinéraire récurrent créé',
      routeUpdated: 'Itinéraire récurrent mis à jour',
      editRoute: 'Modifier {{route}}',
      recurringRoutes: 'Itinéraires récurrents',
      selectRouteWithId: "Sélectionner l'itinéraire avec l'ID {{id}}",
      rolloutInfoConfigured:
        'Le déploiement automatique utilise l’heure récurrente automatique du département {{time}} et déploie les itinéraires pour la date suivante.',
      rolloutInfoMissing:
        "Le déploiement automatique n'est pas configuré pour ce département car l’heure récurrente automatique est vide. Demandez à un administrateur de le configurer.",
      addStop: 'Ajouter un arrêt',
      days: 'Jours',
      dates: 'Dates',
      addException: 'Ajouter une exception',
      addedExceptions: 'Exceptions ajoutées',
      selectedOrders: 'Commandes sélectionnées',
      moveShipment: "Déplacer l'expédition",
      moveShipmentModal: {
        errorMessage: "Expéditions : {{shipmentIds}}, message d'erreur : {{error}}",
        shipmentsMovedText:
          "Les expéditions {{shipmentIds}}, {{stopIds}} ont été déplacées vers l'itinéraire {{route}}",
        partialSuccessMessage: '{{count}} sur {{fullCount}} expéditions ont été déplacées',
        title: 'Déplacer les expéditions sélectionnées vers un autre itinéraire'
      },
      changeRoute: "Changer d'itinéraire",
      viewRoute: 'Vers la tournée',
      plannedStops: 'Arrêts planifiés',
      templatePlannedStopId: 'Modèle arrêt planifié',
      createdPlannedStopId: 'Arrêt planifié créé',
      notRouteConnected: 'Pas sur itinéraire'
    },
    corrections: {
      headline: 'Corrections de commande pour le {{date}}',
      accepted: 'Corrections de commande acceptées',
      rejected: 'Corrections de commande refusées ',
      approve: 'APPROUVER',
      decline: 'REFUSER',
      shipmentId: 'ID expédition',
      courier: 'Coursier',
      from: 'De',
      to: 'A',
      details: 'Détails',
      pickupWaitingTime: "Temps d'attente enlèv. (min)",
      deliveryWaitingTime: "Temps d'attente livr. (min)",
      pickupLoadingTime: 'Temps de chargement enlèv. (min)',
      deliveryLoadingTime: 'Temps de chargement livr. (min)',
      comment: 'Commentaires',
      weight: 'Poids',
      packages: 'Colis',
      serviceCode: 'Code de service',
      noOrderCorrections: 'Aucune correction de commande',
      minutesOutOfRangeError: 'Vous devez saisir un nombre entre {{min}} et {{max}}',
      timeInMinutesWarning: 'Valeur de temps invalide, vérifiez si elle est correcte'
    },
    dispatch: {
      assigningMultilegDelivery: 'Affectation de {{count}} livraison à plusieurs escales en cours',
      assigningMultilegDelivery_other: 'Affectation de {{count}} livraisons à plusieurs escales en cours',
      turningThisOnExplanation: '(Activer cela vous permet de remplacer le plan de la tournée de livraison)'
    },
    suggestedUnits: {
      unitName: "Nom de l'appareil",
      driverName: 'Nom du conducteur',
      slotName: 'Itinéraire',
      timeAtLocation: 'Temps en place',
      distanceFromLocation: 'Distance du lieu',
      shipmentInformation: 'Informations sur les transmissions',
      suggestedVehicles: 'Véhicules suggérés',
      suggestedVehiclesOnPickup: 'Véhicules suggérés pour le ramassage',
      suggestedVehiclesOnDelivery: 'Véhicules suggérés pour la livraison',
      suggestedUnits: 'Unités suggérées',
      noSuggestionsAvailable: 'Aucune suggestion disponible',
      pickupTime: 'Heure de ramassage',
      deliveryTime: 'Heure de livraison',
      filterBy: 'Filtrer par'
    }
  },
  errors: {
    DIP_DESTINATION_ALREADY_MAPPED:
      'Ce point de collecte est déjà associé à un autre DIP. Rechargez la page pour voir les associations actuelles.',
    ALREADY_ENQUEUED_FOR_INVOICING: "Déjà en file d'attente pour facturation",
    DUPLICATE: 'Données dupliquées',
    MISSING_DEPARTMENT_DETAILS:
      'Le département ne dispose pas d’informations sur la zone et le code postal. Veuillez les ajouter avant de continuer.',
    DEPARTMENT_INVALID_ALYSTRA_ID: 'ID de département invalide',
    EXPORT_DEPARTMENT_GROUP_TOO_LARGE:
      "Veuillez sélectionner un groupe de départements plus petit ou une période d'exportation plus courte",
    ENTITY_DOES_NOT_EXIST: "L'entité n'existe pas",
    RECURRING_ROUTE_REROLL_OUT_DATE_NOT_IN_FUTURE:
      "Les itinéraires récurrents ne peuvent être redéployés que pour une date postérieure à aujourd'hui",
    RECURRING_ROUTE_NOT_ROLLED_OUT:
      "Un itinéraire sélectionné n'est pas déployé pour cette date. Rechargez la page et réessayez",
    RECURRING_ROUTE_ROLLOUT_IN_PROGRESS:
      'Un itinéraire sélectionné est encore en cours de déploiement. Attendez quelques minutes et réessayez',
    ROUTE_ALREADY_CONNECTED_TO_ANOTHER_RULE:
      'Le trajet est déjà associé à une autre règle, veuillez actualiser la page et réessayer',
    INVALID_DATE_RANGE: 'Plage de dates invalide',
    INVALID_DELIVERY_LATITUDE: 'Latitude de livraison invalide',
    INVALID_DELIVERY_LONGITUDE: 'Longitude de livraison invalide',
    INVALID_LATITUDE: 'Latitude invalide',
    INVALID_LONGITUDE: 'Longitude invalide',
    INVALID_OR_MISSING_TIME: 'Heure invalide ou manquante',
    INVALID_PHONE_NUMBER: 'Numéro de téléphone invalide',
    DUPLICATE_PHONE_NUMBER: 'Numéro de téléphone dupliquée !',
    DUPLICATE_PHONE_NUMBER_COURIER: 'Un conducteur est déjà enregistré avec ce numéro de téléphone',
    INVALID_PICKUP_LATITUDE: "Latitude d'enlèvement invalide",
    INVALID_PICKUP_LONGITUDE: "Longitude d'enlèvement invalide",
    INVALID_SLOT_TYPE: 'Type de tournée invalide',
    MISSING_ADDRESS: 'Adresse manquante',
    MISSING_ALYSTRA_ID: 'ID manquante',
    MISSING_AREA: 'Région manquante',
    MISSING_CAPACITY: 'Capacité manquante',
    MISSING_COLOR: 'Couleur manquante',
    MISSING_CONSIGNMENT_INPUTS: "Données d'expédition manquantes",
    MISSING_CONSIGNMENT: 'Expédition manquante',
    MISSING_CONSIGNMENTS: 'Expéditions manquantes',
    MISSING_COURIER_ID: 'ID coursier manquante',
    MISSING_COURIER: 'Vous devez sélectionner un coursier',
    MISSING_CREATED_AT: 'Champ Créé à manquant',
    MISSING_CUSTOMER_ID: 'ID client manquante',
    MISSING_CUSTOMER_REF: 'Réf. client manquante',
    MISSING_DATE: 'Date manquante',
    MISSING_DAYS: 'Jours manquants',
    MISSING_DEPARTMENT: 'Département manquant',
    MISSING_DESCRIPTION: 'Description manquante',
    MISSING_DEVIATION_TEXT: "Texte d'échec manquant",
    MISSING_END_LOCATION_LATITUDE: "Latitude du lieu d'arrivée manquante",
    MISSING_END_LOCATION_LONGITUDE: "Longitude du lieu d'arrivée manquante",
    MISSING_EVENT_DATA: "Données d'événement manquantes",
    MISSING_EVENT_TYPE: "Type d'événement manquant",
    MISSING_FILE_NAME: 'Nom de fichier manquant',
    MISSING_FROM_DATE: 'Champ Date de début manquant',
    MISSING_ID: 'ID manquante',
    MISSING_LOCATION_LATITUDE: 'Latitude du lieu manquante',
    MISSING_LOCATION_LONGITUDE: 'Longitude du lieu manquante',
    MISSING_LOCATION_POSITION: 'Position du lieu manquante',
    MISSING_LOCATION_TIME: 'Heure du lieu manquante',
    MISSING_NAME: 'Nom manquant',
    MISSING_GROUP: 'Groupement manquant',
    MISSING_PACKAGE_ID: 'ID colis manquante',
    MISSING_PHONE: 'No de téléphone manquant',
    MISSING_PLANNER_ID: 'ID planificateur manquante',
    MISSING_SERVICE_CODE: 'Code de service manquant',
    MISSING_SHIPMENT_ID: 'ID expédition manquante',
    MISSING_SLOT_ID: 'ID tournée manquante',
    MISSING_SLOT_TYPE: 'Type de tournée manquant',
    MISSING_SMS_TOKEN: 'Jeton SMS manquant',
    MISSING_START_LOCATION_LATITUDE: 'Latitude du lieu de départ manquante',
    MISSING_START_LOCATION_LONGITUDE: 'Longitude du lieu de départ manquante',
    MISSING_TO_DATE: 'Champ Date de fin manquante',
    MISSING_ZIP_AREA: 'Code régional manquant',
    MISSING_ZIP_CODE: 'Code postal manquant',
    MISSING_COUNTRY_CODE: 'Code pays manquant',
    NO_SUCH_USER: "L'utilisateur n'existe pas",
    PARAM_NOT_OF_EXPECTED_TYPE: 'Param pas du type prévu',
    PARAM_NULL_NOT_ALLOWED: 'Param nul non autorisé',
    PTW_ALREADY_EXISTS: 'Une fenêtre de temps de production existe déjà pour l’ID destinataire {{recipientId}}.',
    QUERY_NAME_MISSING: 'Nom de requête manquant',
    QUERY_PARAMS_MISSING: 'Param de requête manquants',
    USER_NOT_EXIST_OR_INCORRECT_ROLE: "L'utilisateur n'existe pas ou rôle incorrect",
    USER_EXIST_BUT_INCOMPATIBLE_ROLE: "L'utilisateur existe déjà et a un autre rôle",
    SLOT_CANNOT_BE_STARTED: 'Impossible de commencer la tournée',
    SLOT_CANNOT_BE_DELETED: 'Impossible de supprimer la tournée',
    COURIER_NOT_PART_OF_DEPARTMENT: 'Le coursier ne fait pas partie du département',
    CONSIGNMENT_IN_INCORRECT_STATE_CANNOT_UPDATE: 'Marchandises dans un état incorrect, impossible de mettre à jour',
    ORDER_DOES_NOT_EXISTS: "La commande n'existe pas",
    OPTIMIZE_ALREADY_RUNNING: 'Optimisation déjà en cours',
    CANNOT_CHANGE_ORDER: 'Impossible de modifier la commande',
    NO_ACCESS: "Pas d'accès",
    NO_RELEVANT_CONSIGNMENTS_OR_SLOTS: 'Aucune expédition pertinente pour les tournées données',
    NO_RELEVANT_CONSIGNMENTS: 'Aucune expédition pertinente pour les tournées données',
    NO_RELEVANT_SLOTS:
      'Seuls les la tournée de livraisons non encore commencés ou en attente peuvent être optimisés en utilisant cette fonctionnalité',
    NOT_EQUAL_PICKUP_ADDRESSES:
      'Toutes les adresses de collecte doivent être identiques pour restreindre toutes les commandes à un seul conducteur',
    NO_SUGGESTIONS_FOUND_FOR_ORDERS: 'Aucun conducteur éligible pour les commandes.',
    NO_SUCH_QUERY: "La requête n'existe pas",
    EXCEL_MISSING_SHIPMENT_ID: 'ID expédition manquante à la cellule {{col}} ligne {{row}}',
    EXCEL_MISSING_CUSTOMER_REF: 'Réf. client manquante à la cellule {{col}} ligne {{row}}',
    EXCEL_MISSING_CUSTOMER_ID: 'ID client manquante à la cellule {{col}} ligne {{row}}',
    EXCEL_MISSING_DEPARTMENT: 'Département manquant à la cellule {{col}} ligne {{row}}',
    EXCEL_MISSING_PACKAGE_ID: 'ID colis manquante à la cellule {{col}} ligne {{row}}',
    EXCEL_MISSING_NAME: 'Nom manquant à la cellule {{col}} ligne {{row}}',
    EXCEL_INVALID_PHONE: 'Numéro de téléphone invalide à la cellule{{col}} ligne {{row}}',
    EXCEL_MISSING_ADDRESS: 'Adresse manquante à la cellule {{col}} ligne {{row}}',
    EXCEL_MISSING_ZIP_AREA: 'Code postal manquant à la cellule {{col}} ligne {{row}}',
    EXCEL_MISSING_ZIP_CODE: 'Ville manquante à la cellule {{col}} ligne {{row}}',
    EXCEL_MISSING_FROM_DATE: 'Date de début manquante à la cellule {{col}} ligne {{row}}',
    EXCEL_MISSING_TO_DATE: 'Date de fin manquante à la cellule {{col}} ligne {{row}}',
    EXCEL_INVALID_FROM_DATE:
      "La date de début ne peut être antérieure à la date d'aujourd'hui. Trouvée à la cellule {{col}} ligne {{row}}",
    EXCEL_INVALID_TO_DATE:
      "La date de fin ne peut être antérieure à la date d'aujourd'hui. Trouvée à la cellule {{col}} ligne {{row}}",
    EXCEL_MISSING_NOTIFICATION_SMS: 'Notification SMS manquante à la cellule {{col}} ligne {{row}}',
    EXCEL_MISSING_SIZE: 'Dimensions manquantes à la cellule {{col}} ligne {{row}}',
    EXCEL_MISSING_ORDERS: 'Pas de commande trouvée dans la feuille de calcul.',
    EXCEL_MISSING_COUNTRY: 'Code ou nom du pays manquant à la cellule {{col}} ligne {{row}}',
    EXCEL_NO_ACCESS_DEPARTMENT: 'Pas d\'accès au département "{{dept_ref}}" tel que trouvé à ligne {{row}}',
    EXCEL_MISSING_DESCRIPTION: 'Description manquante dans "{{cell}}" ligne {{row}}',
    EXCEL_MISSING_PICKUP_INSTRUCTIONS: 'Description enlèvement manquante dans "{{cell}}" ligne {{row}}',
    EXCEL_MISSING_DELIVERY_INSTRUCTIONS: 'Description livraison manquante dans "{{cell}}" ligne {{row}}',
    EXCEL_TOO_MUCH_DATA:
      "Le rapport est trop volumineux. Veuillez envisager de l'exporter pour une période plus courte ou pour un nombre réduit de services.",
    MISSING_PICKUP_LOCATION_AND_TIME: "Lieu et heure d'enlèvement manquants",
    MISSING_EARLIEST_PICKUP_DATE: "Première date d'enlèvement manquante",
    MISSING_LATEST_PICKUP_DATE: "Dernière date d'enlèvement manquante",
    MISSING_EARLIEST_DELIVERY_DATE: 'Première date de livraison manquante',
    MISSING_LATEST_DELIVERY_DATE: 'Dernière date de livraison manquante',
    INVALID_EARLIEST_PICKUP_DATE: "Date d'enlèvement invalide",
    INVALID_LATEST_PICKUP_DATE: "Date d'enlèvement invalide",
    INVALID_EARLIEST_DELIVERY_DATE: 'Date de livraison invalide',
    INVALID_LATEST_DELIVERY_DATE: 'Date de livraison invalide',
    CANNOT_MODIFY_ORDERS_FROM_DIFFERENT_SOURCE: 'Impossible de modifier les commandes API dans Excel',
    PICKUP_EARLIEST_SHOULD_BE_BEFORE_DELIVERY_LATEST:
      "L'heure d'enlèvement doit être antérieure à l'heure de livraison",
    DELIVERY_EARLIEST_SHOULD_BE_BEFORE_DELIVERY_LATEST:
      'La première livraison doit être antérieure à la dernière livraison',
    CANNOT_DELIVER_ON_A_HOLIDAY: 'Impossible de livrer un jour férié',
    MISSING_TEMPLATE_ID: 'ID modèle manquante',
    TEMPLATE_DOES_NOT_EXIST: "Le modèle n'existe pas",
    TEMPLATE_CANNOT_BE_DELETED: 'Le modèle ne peut pas être supprimé',
    MISSING_TEMPLATE_SLOTS: 'Il manque des tournées dans le modèle',
    TEMPLATE_NAME_ALREADY_EXISTS: 'Il existe déjà un modèle de ce nom',
    COURIER_ALREADY_EXISTS: 'Il existe déjà un autre coursier avec ce numéro de téléphone',
    ORDER_EXIST_FOR_SERVICE: 'Impossible de supprimer le service car il existe des commandes pour ce service',
    NO_SERVICE_FOUND: "Ajouter un service avant d'ajouter le profil client",
    CANNOT_DELETE_AS_SERVICE_EXIST: 'Supprimer le profil de service client avant de supprimer le service',
    SLOT_IN_INCORRECT_STATE_CANNOT_UPDATE: "La tournée n'est pas dans un état valide pour cette mise à jour",
    GRAPHHOPPER_UNASSIGNED:
      "Impossible d'affecter toutes les expéditions (en raison du facteur temps, capacité ou autre), détails : {{details}}",
    GRAPHHOPPER_REQUEST_FAILED: "Echec de la demande d'optimisation de l'itinéraire",
    GRAPHHOPPER_LATEST_ARRIVAL_AT_DELIVERY_AFTER_EARLIEST_DEPARTURE:
      "La dernière arrivée au lieu de livraison ne peut pas être postérieure au premier départ – le créneau horaire d'enlèvement est-il dans le passé ?",
    GRAPHHOPPER_EARLIEST_GREATER_THAN_LATEST:
      'La première heure ne peut pas être postérieure à la dernière – certaines des heures sont-elles dans le passé ?',
    GRAPHHOPPER_PICKUP_EARLIEST_AFTER_LATEST:
      "Le créneau horaire d'enlèvement {{shipmentId}} ne peut pas être dans le passé ({{pickupEarliest}} - {{pickupLatest}})",
    GRAPHHOPPER_DELIVERY_EARLIEST_AFTER_LATEST:
      'Le créneau horaire de livraison {{shipmentId}} ne peut pas être dans le passé ({{deliveryEarliest}} - {{deliveryLatest}})',
    GRAPHHOPPER_INVALID_PICKUP_LOCATION:
      "Coordonnées de ramassage manquantes pour l'envoi {{shipmentId}}. Veuillez corriger l'adresse via la page 'Définir les coordonnées'.",
    GRAPHHOPPER_INVALID_DELIVERY_LOCATION:
      "Coordonnées de livraison manquantes pour l'envoi {{shipmentId}}. Veuillez corriger l'adresse via la page 'Définir les coordonnées'.",
    GRAPHHOPPER_REQUEST_LIMIT_VIOLATED:
      'La limite du nombre de requêtes vers Graphhopper a été atteinte, veuillez réessayer dans une minute',
    SLOT_CANNOT_BE_EDITED: "La tournée n'est pas dans un état valide pour cette mise à jour",
    INVALID_POSTCODE_AND_COUNTRY_CODE_CANNOT_BE_HANDLED: 'Code postal et code pays invalides',
    INVALID_BASIC_SERVICE_CODE: 'Code de service de base invalide',
    INVALID_PICKUP_DATE_EARLIEST_FORMAT: "Format de première date d'enlèvement invalide",
    INVALID_PICKUP_DATE_LATEST_FORMAT: "Format de dernière date d'enlèvement invalide",
    INVALID_DELIVERY_DATE_LATEST_FORMAT: 'Format de dernière date de livraison invalide',
    INVALID_DELIVERY_DATE_EARLIEST_FORMAT: 'Format de première date de livraison invalide',
    INVALID_POSTAL_CODE: 'Code postal invalide',
    INVALID_MEASUREMENT_UNIT: 'Unité de mesure invalide',
    MISSING_CONSIGNMENT_SET: 'Jeu de données des colis manquant',
    MISSING_UPDATE_INDICATOR: 'Indicateur de mise à jour manquant',
    MISSING_CONSIGNMENT_ID: 'ID expédition manquante',
    MISSING_REFERENCE_NO: 'ID référence manquante',
    MISSING_PACKAGE: 'Colis manquant',
    MISSING_DELIVERY_DATE_EARLIEST: 'Première date de livraison manquante',
    MISSING_DELIVERY_DATE_LATEST: 'Dernière date de livraison manquante',
    MISSING_CONSIGNEE: 'Destinataire manquant',
    MISSING_CONSIGNOR: 'Expéditeur manquant',
    MISSING_POSTAL_CODE: 'Code postal manquant',
    MISSING_CITY: 'Code régional manquant',
    MISSING_PICKUP_DATE_LATEST: "Dernière date d'enlèvement manquante",
    MISSING_PICKUP_DATE_EARLIEST: "Première date d'enlèvement manquante",
    MISSING_CONSIGNOR_PARTY_ID: 'ID partie destinataire manquante',
    INVALID_CUSTOMER_NO_MAPPING: 'Profil numéro de client invalide',
    INVALID_ROUTING: 'Acheminement invalide',
    NO_SERVICE_MATCHING_SERVICE_CODE: 'Aucun service ne correspond au code de service',
    NO_SERVICE_MATCHING_DAY_OF_WEEK: 'Aucun service ne correspond au jour de la semaine',
    NO_SERVICE_MATCHING_PICKUP_AND_DELIVERY_TIMES:
      "Aucun service ne correspond aux heures d'enlèvement et de livraison",
    ORDER_WAS_AFTER_CUTOFF_TIME: "La commande était après l'heure limite",
    OPTIMUS_SERVICE_MUST_HAVE_PICKUP_AND_DELIVERY_TIMES: "Heures d'enlèvement et de livraison obligatoires",
    ORDER_CANNOT_BE_MOVED: 'Impossible de déplacer la commande, elle ne doit pas être affectée à une tournée',
    MISSING_DESTINATION_DEPARTMENT_ID: 'Département de destination manquant',
    SHIPMENT_NOT_FOUND: 'Expédition non trouvée',
    SHIPMENT_IN_INCORRECT_STATE: "L'expédition est déjà affectée à un itinéraire",
    DUPLICATE_EXCEL_IMPORT:
      "Le même nom de fichier a déjà été importé dans ce département aujourd'hui. Vous pouvez voir les résultats de cette importation <0>ici</0>. Veuillez modifier le nom de fichier si vous souhaitez le réimporter.",
    noOrdersForDateAndCourier: 'Aucune commande présente pour la date et l’unité sélectionnées.',
    SHIPMENT_INVALID_QUERY:
      'Toute recherche couvrant les heures de pointe sera limitée pour optimiser la performance. Vous pouvez rechercher toutes les commandes pour une journée particulière ou ajouter un paramètre de recherche.',
    DURATION_IS_MORE: 'Merci de limiter votre recherche à une période de {{maxDuration}} jours.',
    ADDRESS_CANNOT_BE_DELETED: "L'adresse sert d'adresse par défaut et ne peut pas être supprimée.",
    MISSING_ORDER_BILLING_TYPE: 'Type de facturation de commande manquant.',
    UNKOWN_ERROR: 'Impossible d’enregistrer les modifications',
    INCORRECT_STATES_OR_ASSIGNED_TO_SLOT: 'État incorrect ou Affectée à la tournée',
    CANNOT_MOVE_ORDERS: 'Impossible de déplacer les commandes',
    DEPARTMENT_MISSING_ADDRESS_DETAILS: "Le département ne comporte pas de détails d'adresse",
    MISSING_DELIVERY_PHONE_NUMBER: 'Le numéro de téléphone est manquant pour',
    INVALID_DELIVERY_PHONE_NUMBER: 'Le numéro de téléphone n’est pas valide pour',
    SMS_SERVICE_NOT_ORDERED: "Le service SMS n'est pas commandé pour.",
    SLOT_ROUTED_IN_HAPPY_FLOW: 'Le créneau est routé dans Happy Flow pour.',
    SERVICE_LEVEL_SHOULD_NOT_BE_NONE: 'Le niveau de service est aucun pour.',
    SLOT_NAME_ALREADY_CREATED: 'Le nom de l’itinéraire existe déjà.',
    ORDER_IN_INCORRECT_STATE: 'La commande est dans un état incorrect.',
    ORDER_IN_INCORRECT_STATE_other: 'Les commandes sont dans un état incorrect.',
    ROLE_IN_USE: "Le rôle ne peut pas être supprimé car il est en cours d'utilisation.",
    INVALID_NAME: 'Le nom du rôle doit être unique. Un rôle avec ce nom existe déjà.',
    BANNER_ALREADY_EXISTS: 'Le nom de la bannière doit être unique. Une bannière portant ce nom existe déjà.',
    BANNER_NAME_TOO_BIG: 'Le nom de la bannière est trop long. Il doit comporter au maximum 200 caractères.',
    TEXT_CANNOT_BE_DELETED:
      'Le texte est utilisé dans un service et ne peut pas être supprimé. Déconnectez le texte du service pour le supprimer.',
    INVALID_INVOICING_STATUS: 'La commande a un statut non valide pour la facturation',
    ORDER_NOT_READY_FOR_INVOICING: "La commande n'est pas prête pour la facturation",
    ORDER_IS_PAUSED_FROM_INVOICING: 'La commande est suspendue de la facturation',
    ORDER_IS_EXCLUDED_FROM_INVOICING: 'La commande est exclue de la facturation',
    MISSING_ORDER_CORRECTION: 'La commande manque une correction',
    INVALID_MULTILEG_STATE_FOR_INVOICING:
      'Il y a des commandes dans le groupe multileg qui ne sont pas prêtes pour la facturation',
    INVALID_BANNER_NAME: 'Nom de bannière invalide.',
    INVALID_WHATS_THIS_NAME: "Nom invalide de la fenêtre Qu'est-ce que c'est.",
    INVALID_CREDIT_ORDER: 'Impossible de créditer une commande qui n’a pas été facturée ou qui a déjà été créditée.',
    OVERLAPPING_BANNERS: 'L’URL chevauche une bannière existante.',
    OVERLAPPING_WHATS_THIS_MODALS: "L’URL chevauche une fenêtre Qu'est-ce que c'est existante.",
    INVALID_ORDER_BILLING_CUSTOMER_NUMBER:
      'Le numéro client de facturation de la commande pour le type {{orderBillingType}} est soit nul, soit invalide.',
    INVALID_ORDER_BILLING_TYPE:
      "Le type de facturation de commande doit être l'un des suivants : {{orderBillingTypes}}, mais était - {{orderBillingType}}.",
    INVALID_ORDER_BILLING_INFO: 'Informations de facturation de commande invalides.',
    CANNOT_SEND_SMS_FOR_MESTER_GRONN_FUNERAL: 'Les funérailles Mester Grønn sont commandées pour.',
    INVALID_PARAMETERS: 'Paramètres invalides, {{description}}.',
    FAILED_DELETING_WEBHOOK_SUBSCRIPTION: 'L’abonnement Webhook n’a pas pu être supprimé. Réessayez plus tard.',
    DEFAULT_ROLE_ALREADY_EXISTS: "Un autre rôle {{name}} est déjà défini par défaut pour le même type d'utilisateur.",
    VEHICLE_IN_USE:
      "Le véhicule est connecté à l'unité {{units}} et ne peut pas être supprimé. Retirez le véhicule de l'unité puis réessayez.",
    DEPARTMENT_MATRIX_ALREADY_EXISTS: 'Une seule matrice de département est prise en charge',
    CUTOFF_MATRIX_ALREADY_EXISTS: 'Une seule matrice de cutoff est prise en charge',
    MISSING_ACCESS_TO_DEPARTMENTS: "Vous n'avez pas accès aux départements {{missingDepartments}}",
    DUPLICATE_PLANNED_STOP_LOCATION_NAME:
      "Il ne peut pas y avoir plusieurs emplacements d'arrêt planifiés portant le même nom dans un service. Veuillez utiliser des noms uniques pour chaque emplacement d'arrêt planifié.",
    AREA_PINS_TOO_CLOSE:
      'Les points de l’itinéraire doivent être espacés d’au moins {{minDistanceInMeters}} mètres. Éloignez-les les uns des autres.',
    DUPLICATE_TEMPLATE_ROUTE_NAME:
      'Un autre itinéraire récurrent de ce service porte le même nom. Les itinéraires portant le même nom sont fusionnés en un seul lors du déploiement, veuillez donc choisir un autre nom.',
    PLANNED_STOP_LOCATION_IN_USE:
      "Impossible de modifier ou de supprimer les emplacements d'arrêt planifiés - [{{locations}}] qui sont déjà utilisés.",
    TEMPLATE_IS_DEFAULT_FOR_DEPARTMENT:
      'Le modèle ne peut pas être supprimé car il est défini par défaut pour un département. Veuillez modifier le modèle par défaut du département avant de supprimer ce modèle.'
  },
  customer: {
    useTerminalAddressModalHeading: "Utiliser l'adresse du terminal",
    settings: {
      webhook: {
        overviewTitle: 'Configuration du webhook',
        count: '{{count}} abonnement',
        count_other: '{{count}} abonnements',
        noSubscriptions: "Vous n'avez aucun abonnement pour le moment",
        create: 'Cliquez sur le bouton pour créer une configuration Webhook'
      }
    },
    invoiceSplit: { title: 'Fractionnement de la facture', NotSet: 'Non défini' },
    customer: 'Client',
    groups: {
      titleWithCount: '{{count}} groupes de clients',
      name: 'Nom du groupe',
      numberOfCustomers: 'Nombre de clients',
      none: 'Aucun groupe de clients',
      new: 'Nouveau groupe de clients',
      edit: 'Modifier le groupe de clients',
      searchCustomer: 'Rechercher un client',
      members: 'Clients du groupe',
      save: 'Enregistrer',
      deleteConfirm: 'Supprimer {{name}} ?',
      deleteDescription: 'Vous ne pourrez pas annuler cette action',
      deleted: 'Le groupe de clients a été supprimé',
      mustProvideName: 'Vous devez indiquer un nom de groupe',
      cannotDelete:
        "Impossible de supprimer le groupe de clients car il est utilisé dans une règle d'avis préliminaire."
    },
    customerTitle: 'Clients',
    customerNo: 'Client no',
    name: 'Nom',
    emailToSender: "E-mail à l'expéditeur",
    deviations: 'Echecs',
    add: 'Ajouter',
    noOrders: 'Pas de commandes dans Glow',
    noOrdersDescription: "Les clients auxquels vous avez accès n'ont pas de commandes dans Glow",
    choose: 'Veuillez sélectionner un client',
    findCustomer: 'Trouver un client',
    searchAndSelect: 'Rechercher et sélectionner le client',
    customerPlaceHolder: 'Rechercher des clients',
    emailRecipients: "Destinataires d'e-mail",
    smsRecipients: 'Destinataires de SMS',
    addEditEmails: 'Ajouter/modifier les adresses e-mail',
    addEditSms: 'Ajouter/modifier les SMS',
    addEditDeviations: 'Ajouter/modifier les échecs',
    live: 'En direct',
    search: 'Rechercher',
    startTypingPlaceHolder: 'Commencez à taper',
    AddEdit: 'Ajouter/Modifier',
    searchHint:
      "Rechercher les expéditions en fonction de l'ID expédition, de la réf. client, de l'ID colis, du nom ou de l'adresse de livraison",
    senderName: "Nom de l'expéditeur",
    addSenderName: "Ajouter un nom d'expéditeur",
    senderNameAdded: "Nom de l'expéditeur ajouté",
    addInvoiceHDOrdersFromDate: 'Ajouter une date de début pour la facturation de commandes HD via Glow',
    invoiceHDOrdersFromDate: 'Facturer les commandes HD dans Glow à partir de la date',
    invoiceHDOrdersFromDateAdded: 'La date de début pour la facturation de commandes HD dans Glow a été modifiée',
    addNPSFromDate: 'Ajouter la date de début du NPS',
    activateNPSFromDate: 'Activer NPS à partir de la date',
    accountingType: 'Type de compte',
    accountingTags: 'Étiquettes comptables',
    isDeleted: 'Supprimé(e)',
    deletedCannotBeUsed: 'Le client est supprimé et ne peut pas être utilisé. Sélectionnez un autre client.',
    scanToCreatePackages: {
      title: 'Scanner pour créer des colis',
      label: 'Utiliser le scanneur pour créer des colis',
      details:
        "Lors de l'activation de la numérisation pour créer des colis, le livreuer est obligé de scanner les colis lors de l'enlèvement. Les colis scannés seront automatiquement mis à jour sur l'expédition.",
      success: 'Numéro de scan pour créer des colis mis à jour.',
      enabled: 'Activé',
      disabled: 'Désactivé'
    },
    billingCustomerNumber: 'Numéro client de facturation',
    addBillingCustomerNumber: 'Ajouter le numéro client de facturation',
    billingCustomerNumberAdded: 'Numéro client de facturation ajouté',
    searchPage: {
      fromDate: 'Date de début',
      toDate: 'Date de fin',
      today: "Aujourd'hui",
      tomorrow: 'Demain',
      yesterday: 'Hier',
      last30days: 'Les 30 derniers jours',
      plusMinus15Days: '+/- 15 jours',
      plusMinus30Days: '+/- 30 jours'
    },
    smsText: {
      title: 'Remplacer les SMS de notification',
      addEditSmsText: 'Ajouter/modifier les SMS',
      smsTextUpdated: 'SMS ajouté/mis à jour',
      en: 'ANG',
      se: 'SUE',
      dk: 'DAN',
      description: 'Description',
      smsType: 'Type de notification',
      smsTypeTexts: {
        preadvice: 'Avis préliminaire',
        pickup: 'SMS de suivi',
        pre_pickup: 'SMS de suivi préliminaire',
        manual_delay: 'SMS de retard manuel',
        eta_pickup: "SMS ETA d'enlèvement",
        eta_delivery: 'SMS ETA de livraison',
        flex_delivery_confirmation: 'SMS de confirmation de livraison flex.',
        advise: "SMS d'avis",
        delivery_confirmation: 'SMS de confirmation de livraison',
        pre_advice_push: 'SMS Push',
        pre_advice_push_return: 'SMS Push Return',
        pre_advice_push_email: 'E-mail Push',
        pre_advice_push_2nd: 'SMS Push 2nd avis préliminaire',
        pre_advice_push_2nd_email: 'E-mail Push 2nd avis préliminaire',
        pre_advice_push_return_to_sender_email: "E-mail Push de retour à l'expéditeur",
        pre_advice_pull: 'SMS Pull',
        pre_advice_pull_email: 'E-mail Pull',
        pre_advice_pull_reminder: 'SMS Pull de rappel',
        pre_advice_pull_reminder_email: 'E-mail Pull de rappel',
        pre_advice_pull_reminder_to_sender_email: "E-mail Pull de rappel à l'expéditeur",
        pre_advice_pull_return_to_sender_email: "E-mail Pull de retour à l'expéditeur",
        pre_advice_return: 'SMS de retour de livraison',
        pre_advice_return_email: 'SMS de retour de livraison',
        pre_advice_return_2nd: 'SMS de 2nd avis préliminaire de retour de livraison',
        pre_advice_return_2nd_email: 'E-mail de 2nd avis préliminaire de retour de livraison',
        pre_advice_return_return_to_sender_email: "E-mail retour à l'expéditeur pour retour de livraison",
        pre_advice_pup: 'SMS PUP',
        pre_advice_pup_email: 'E-mail PUP',
        pre_advice_pup_reminder: 'SMS PUP de rappel',
        pre_advice_pup_reminder_email: 'E-mail PUP de rappel',
        pre_advice_pup_reminder_to_sender_email: "E-mail PUP de rappel à l'expéditeur",
        pre_advice_pup_return_to_sender_email: "E-mail PUP de retour à l'expéditeur",
        delivery: 'SMS de livraison'
      }
    },
    showNotCollected: 'Enlèvement non effectué',
    booking: {
      pickupReady: "Articles prêts à l'enlèvement",
      pickup: 'Enlèvement',
      delivery: 'Livraison',
      deliveryAvailable: 'Livraison disponible',
      priceComment:
        'Vous serez facturé en fonction de votre contrat client avec Bring. Les frais ne sont pas inclus dans ce prix.',
      serviceUnavailable: "Le service sélectionné n'est pas disponibles pour le code postal {{postalCode}}",
      recipientPrice: 'Prix du destinataire :',
      customerContactPlaceholder: 'Commandé par – Ce champ est visible sur la facture du client'
    },
    email: {
      emailTitle: 'E-mail au client',
      getNotificationsFor: 'Recevez des notifications pour',
      emailAddress: 'Adresse e-mail',
      createdEvent: 'Enregistré(e)',
      collectedEvent: 'Enlèvement',
      deliveredEvent: 'Livraison',
      save: 'Enregistrer',
      edit: 'Modifier',
      delete: 'Supprimer',
      emailExists: "L'e-mail existe déjà",
      invalidEmail: 'E-mail invalide',
      true: 'Oui',
      false: 'Non',
      notificationType: { standard: 'Informations standard' },
      informationToCustomer: 'Informations au client',
      returnToCustomer: 'Retour au client',
      addEmailToList: "Ajouter l'email à la liste",
      registeredEmailSubscription: 'Abonnement email enregistré',
      updateEmail: "Mettre à jour l'email",
      noRegisteredEmails: 'Aucun e-mail enregistré',
      detailsSavedSuccessfully: "L'email à l'expéditeur a été enregistré avec succès"
    },
    customerDeviations: {
      new: 'Ajouter un nouvel échec',
      deviationTitle: 'Echecs pour le client',
      addDeviation: 'Ajouter un nouvel échec',
      editDeviation: "Modifier l'échec",
      en: 'ANG',
      sv: 'SUE',
      dk: 'DAN',
      event: 'Événement',
      reason: 'Raison',
      submit: 'Soumettre',
      deviationCode: "Code d'échec",
      deviationCodesLabel: "Codes d'échec",
      deviation: 'Echec',
      deviationType: "Type d'échec",
      description: 'Description',
      edit: 'Modifier',
      delete: 'Supprimer',
      deviationAdded: 'Echec ajouté',
      deviationEdited: 'Echec modifié',
      deviationExists: "L'échec existe déjà",
      deviationDeleted: 'Echec supprimé'
    },
    customerNumber: 'Numéro de client',
    customerInfo: 'Informations concernant le client',
    customerName: 'Nom du client',
    invoicingAddress: 'Adresse de facturation',
    organisationNumber: "Numéro d'organisation",
    visitingAddress: 'Adresse de visite',
    creditBlockedFrom: 'Crédit bloqué à partir de la date',
    creditBlockedFromInfo: "Bloquer le crédit pour ce client à partir d'une date sélectionnée",
    from: 'De',
    address: 'Adresse',
    zipCode: 'Code postal',
    zipArea: 'Ville',
    country: 'Pays',
    edit: 'Éditer {{name}}',
    selectCountry: 'Choisissez le pays',
    settingsInGlow: 'Paramètres dans Glow',
    addNewCustomer: 'Ajouter un nouveau client',
    bookingPage: 'Page de réservation',
    bookingPageModalHeading: 'Réservation dans le portail client.',
    bookingPageModalDescription:
      'Le client doit pouvoir réserver des commandes sous ce numéro de client dans le portail client Glow',
    bookingPageAvailable: 'Oui',
    bookingPageHidden: 'Non',
    returnAddressUpdated: 'Adresse de retour mise à jour',
    returnAddressRemoved: 'Adresse de retour supprimée',
    returnAddressModalHeading: 'Adresse de retour des marchandises',
    removeReturnAddressModalHeading: 'Supprimer l’adresse de retour actuelle',
    removeReturnAddressConfirm: 'Êtes-vous sûr de vouloir supprimer l’adresse de retour actuelle des marchandises ?',
    returnAddressModalDescription:
      'Saisissez l’adresse de retour à utiliser lorsque les marchandises sont retournées depuis le terminal',
    brandedTrackingModalHeading: 'Facturation du suivi de marque',
    brandedTrackingModalDescription: 'Activez pour activer la facturation pour le suivi personnalisé.',
    bookingActive: 'Activé',
    bookingInactive: 'Désactivé',
    brandedTrackingActive: 'Activé',
    customerBookingPageAccessUpdated: 'Accès à la page de réservation mis à jour',
    brandedTrackingAccessUpdated: 'Statut de facturation avec suivi de marque mis à jour',
    connectMatrices: 'Connecter les matrices',
    returnLastLegUpdated: 'Statut du dernier segment de retour mis à jour',
    returnLastLegModalHeading: 'Créer le tronçon retour',
    returnLastLegModalDescription:
      'Choisir "oui" signifie que nous divisons la commande en deux étapes et ajoutons un tronçon de retour. "Non" signifie qu\'aucun tronçon de retour n\'a besoin d\'être créé. "Non défini" signifie que la règle de gestion des retours n\'est pas définie pour un client spécifique.',
    token: {
      warningDark: 'Ce client est bloqué et ne peut pas créer de réservations. Débloquez-le pour activer le client.',
      warningLight: 'Assurez-vous de copier la clé API maintenant. Vous ne pourrez plus la voir après !',
      success: 'Vous avez déjà généré une clé API pour ce client',
      allowApiKey: 'Autoriser la clé API pour le client',
      allowApiKeyDescription: "Avant de générer une clé API, vous devez d'abord autoriser cette action.",
      allowApiKeyButtonText: 'Autoriser la clé API',
      apiKeyCopied: 'La clé API a été copiée',
      generateApiKeyDescription:
        'La clé API est unique pour chaque client. Elle est utilisée lorsque votre client crée une réservation dans le portail client. En savoir plus sur notre API <0>ici</0>.',
      generateApiKey: 'Générer la clé API'
    },
    nonInvoiceable: 'Pas de facture',
    internalNonInvoiceable: 'Interne / Le client ne sera pas facturé.'
  },
  texts: {
    title: 'Texte',
    update: 'Mettre à jour le texte',
    name: 'Nom du texte',
    group: 'Regroupement en cours',
    edit: 'Modifier',
    delete: 'Supprimer',
    add: 'Ajouter texte',
    reset: 'Rétablir',
    confirmDelete: 'Voulez-vous vraiment supprimer ce texte ?',
    added: 'Texte ajouté',
    deleted: 'Texte supprimé',
    updated: 'Texte mis à jour',
    tabTitle: 'Textes et traductions',
    successfullyAdded: 'Le texte a été ajouté avec succès à la liste',
    successfullyUpdated: 'Le texte a été mis à jour avec succès',
    allTextsAndVases: 'Liste de tous les textes et traductions',
    searchText: 'Rechercher un texte',
    createNewText: 'Créer un nouveau texte',
    nameToolTip: "Le nom s'affiche lorsque le texte est lié au service"
  },
  billingType: { day: 'jour', evening: 'soir', weekend: 'week-end (week-end)', weekendEvening: 'soir le week-end' },
  importExport: {
    dropText: 'Déposez le fichier ici pour le chargement',
    export: 'Exporter',
    exportAddresses: 'Exporter des adresses client dans Excel',
    importExcel: 'Importer depuis Excel',
    imported: 'adresses importées avec succès',
    or: 'ou',
    selectFile: 'Sélectionner un fichier',
    uploadingFile: 'Téléchargement en cours...'
  },
  customMeasurements: {
    name: 'Nom',
    weight: 'Poids',
    height: 'Hauteur',
    length: 'Longueur',
    width: 'Largeur',
    heading: 'Types de marchandises personnalisées',
    error: "Erreur d'enregistrement du type de marchandise : ",
    confirmDelete: 'Voulez-vous vraiment supprimer ce type de marchandise ?',
    new: 'Créer nouveau',
    customGoodsTypes: 'Types de marchandises personnalisées',
    defaultGoodsTypes: 'Types de marchandises par défaut',
    invalidName: 'Le nom doit comporter au moins une lettre'
  },
  unresolved: {
    unresolvedAddresses: 'Adresses non résolues',
    allResolved: 'Toutes les adresses sont résolues !',
    address: 'Adresse',
    noOfShipments: "Nbre d'expéditions",
    shipment: 'expédition',
    shipment_other: 'expéditions',
    shipmentNumber: "Numéro d'expédition",
    customerRef: 'Réf. client',
    senderName: "Nom de l'expéditeur",
    senderPhone: "Numéro de téléphone de l'expéditeur",
    recipientName: 'Nom du destinataire',
    recipientPhone: 'Téléphone du destinataire',
    searchAndSetLocation: "Rechercher et définir l'emplacement",
    setALocationToContinue: 'Définir un emplacement pour continuer',
    resolveAddress: "Résoudre l'adresse",
    suggestedAddressFound: 'Adresse suggérée trouvée',
    thereIsOneUnresolvedAddress: 'Il y a {{count}} adresse non résolue',
    thereIsOneUnresolvedAddress_other: 'Il y a {{count}} adresses non résolues'
  },
  optimizing: {
    title: 'Optimisation en cours',
    reqTime: 'Heure de requête',
    respTime: 'Heure de réponse',
    showOnlyErrors: 'Afficher uniquement les erreurs',
    department: 'Département',
    userName: 'Utilisateur',
    graphID: 'ID',
    request: 'Requête',
    response: 'Réponse',
    error: 'Erreur',
    viewReqResp: 'Afficher',
    status: 'Statut',
    totalTime: 'Heure',
    selectOptimizingObjective: "Veuillez sélectionner Optimisation de l'objectif",
    objectives: {
      completion_time: 'Temps total minimum de livraison (par défaut)',
      min_vehicles: 'Nombre total minimum de véhicules',
      work_time: 'Temps de livraison identique',
      number_of_deliveries: 'Nombre de livraisons identique',
      deliveries_and_work_time: 'Temps de travail identique et nombre de livraisons identique'
    },
    kbSize: 'Taille de la demande (KB)',
    numberOfShipments: 'Nombre de colis',
    numberOfVehicles: 'Nombre de véhicules',
    processingTime: 'Temps de traitement',
    type: 'Type'
  },
  date: {
    today: "Aujourd'hui",
    tomorrow: 'Demain',
    yesterday: 'Hier',
    from: 'De',
    fromDate: 'Date de début',
    to: 'À',
    toDate: 'Date de fin',
    dateAndTime: 'Date et heures',
    rangeOptions: {
      '15d': '+/- 15 jours',
      '30d': '+/- 30 jours',
      custom: 'Dates personnalisées',
      last30d: 'Les 30 derniers jours',
      last7d: 'Les 7 derniers jours',
      month: 'Mois',
      months: 'Mois',
      today: 'Aujourd’hui',
      tomorrow: 'Demain',
      yesterday: 'Hier',
      thisMonth: 'Ce mois-ci',
      lastMonth: 'Le mois dernier'
    }
  },
  areaSequence: {
    title: 'Zone de séquence',
    description:
      'Ajoutez jusqu’à {{max}} points sur la carte pour guider l’ordre de livraison. La livraison la plus proche de chaque point est priorisée dans l’ordre choisi, tandis que les livraisons entre les points sont optimisées pour l’itinéraire le plus efficace. Cela guide la séquence, sans imposer des zones entières.',
    order: 'Ordre des zones',
    orderWhileEditing: 'Ordre des zones - faites glisser les cartes pour changer l’ordre',
    added: '{{count}} zones sur {{max}} ajoutées',
    save: 'Enregistrer la zone',
    unsaved: 'Enregistrez ou annulez les modifications des zones avant d’enregistrer l’itinéraire.',
    pin: 'Zone {{number}}',
    overlap: 'La zone {{number}} chevauche la zone {{other}}. Éloignez l’une des deux.',
    maxReached: 'Vous pouvez ajouter jusqu’à {{max}} points.',
    tool: {
      add: 'Ajouter une zone',
      move: 'Déplacer les zones',
      delete: 'Supprimer des zones'
    },
    hint: {
      add: 'Cliquez sur la carte pour ajouter une zone',
      move: 'Faites glisser le marqueur pour déplacer la zone. Enregistrer garde les modifications, Annuler les abandonne.',
      delete: 'Cliquez sur un marqueur pour supprimer la zone'
    }
  },
  routeReceipt: {
    printRouteReceiptList: 'Imprimer la liste des signatures',
    noRoutesInfoAvailable: "Aucune information d'itinéraire n'est encore disponible"
  },
  homeDeliveryRouteList: {
    receiptList: 'Liste des signatures',
    shipments: 'Expéditions',
    weight: 'Poids',
    bookedWeight: 'Poids réservé{{unit}}',
    bookedVolume: 'Volume réservé{{unit}}',
    sender: 'Expéditeur',
    package: 'Colis',
    shipmentNo: 'Expédition no',
    ref: 'Réf.',
    recipient: 'Destinataire',
    time: 'Heure',
    mobile: 'Smartphone',
    other: 'Autre',
    attemptedDelivery: 'Tentative de livraison',
    receipt: 'Réception',
    dateOfBirth: 'Date de naissance',
    nameClarification: 'Clarification de nom',
    goodsLine1: "N'oubliez pas d'inspecter les marchandises pour repérer tout dommage visible avant de signer.",
    goodsLine2:
      "En cas de dommage visible, le livreur doit l'enregistrer devant vous lors de la signature de la livraison des marchandises.",
    damage: 'Dommage',
    missing: 'Manquant(e)',
    packageNumber: 'Nombre de colis',
    comments: 'Commentaires'
  },
  invoicingStatus: {
    TO_BE_INVOICED: 'Non facturé',
    INVOICING_FAILED: 'Échec de facturation',
    CORRECTION_PENDING: 'Correction en attente',
    INVOICING_PAUSED: 'Facturation suspendue',
    EXCLUDED_FROM_INVOICING: 'Exclu',
    NOT_READY_FOR_INVOICING: 'Non prêt',
    INVOICED_OK: 'Facturé OK',
    ZERO_PRICE: 'Prix ​​incomplet',
    AWAITING_ACKNOWLEDGEMENT: 'En attente de confirmation',
    disallowedStatusLegend:
      'Les commandes dont le statut est "Facturé OK" et "En attente de confirmation" ne peuvent pas être marquées comme "Non facturé" ou "Exclu".'
  },
  invoice: {
    allOrdersInvoice: 'Toutes les commandes sont facturées',
    allOrdersInvoiceDescription: 'Nous n’avons trouvé aucune commande non facturée.',
    handledBy: 'Effectué par',
    invoicing: 'Facturation',
    searchShipmentIdOrCustomerRef: 'Rechercher l’ID d’expédition ou la référence client',
    state: '{{count}} statut',
    state_other: '{{count}} statuts',
    quantity: 'Quantité',
    perUnitCustomer: 'Prix unitaire client',
    carrierPerUnitPrice: 'Prix unitaire transporteur',
    enableCalculator: "Activer l'aide à la multiplication du prix unitaire au prix total",
    mustBeNegative: 'doit être < 0',
    mustBePositive: 'doit être > 0',
    description: 'Description',
    customerAmount: 'Montant client',
    carrierAmount: "Montant pour l'unité",
    failedPriceListLink: 'Liste de prix qui a échoué dans Moteur de tarification',
    failedPriceList: 'Liste de prix échouée',
    priceFailureDetail: "Détails de l'erreur",
    priceFailureReason: "Raison de l'échec",
    priceFailureReasons: {
      missingAttributeValue: "Valeur d'attribut manquante",
      matrixLookupMiss: 'Absence de correspondance dans la matrice',
      invalidExpression: 'Expression non valide',
      scriptError: 'Erreur de script'
    },
    invoiceFailureDetail: "Détails de l'échec de facturation",
    text: 'Texte de la facture',
    invoiceDepartment: 'Département de facturation',
    invoiceDepartments: 'Service(s) de facturation',
    invoicingJobsSummary: 'Récapitulatif des tâches de facturation',
    invoicingStatus: 'Statut de facturation',
    invoicingStatusDescription: 'Affichage des commandes des {{months}} derniers mois.',
    ordersOnPage: 'Affichage de {{count}} commandes sur la page',
    ordersFoundCount_other: '{{count}} commandes trouvées',
    ordersNotInvoiced: 'Commandes non encore facturées',
    invoicingFailedDescription: 'Commandes traitées sans succès',
    correctionPendingDescription: 'Commandes avec corrections en attente',
    ordersPausedFromInvoiced: 'Commandes dont la facturation est suspendue',
    invoicingZeroPriceDescription: 'Commandes avec des lignes zéro non approuvées',
    confirmCancelDialog: {
      title: 'Vous avez des changements non enregistrés',
      question: 'Vous avez des changements non enregistrés. Souhaitez-vous continuer?',
      abort: 'Rester sur cette page',
      confirm: 'Continuer sans sauvegarder'
    },
    download: 'Télécharger la facture',
    downloadVendor: 'La facture du fournisseur',
    articleCode: 'Article',
    credit: 'Crédit',
    invoiceVerb: 'Facturer',
    invoiceOrderAction: 'Commande de facture',
    invoiceOrderAction_other: 'Facturer les commandes',
    invoiceDepartment_other: 'Départements de facturation',
    dashboard: 'Tableau de bord',
    ordersFoundCount: '{{count}} commande trouvée',
    sendInvoices: 'Envoyer des factures',
    sendInvoicesDescription:
      "Vous êtes sur le point de facturer {{departments}}. Veuillez sélectionner la date ou l'interval des dates pour la période de facturation.",
    sendInvoiceDateValidationErrorOneMonth: "La durée maximale de l'intervalle des dates est de 1 mois",
    invoicingInProgress:
      'La facturation de {{departmentName}} est en cours, il reste {{count}} travaux de facturation.',
    invoicingInFinished: 'La facturation de {{departmentName}} est terminée',
    orderEnqueuedForInvoicing: "La commande est mise en file d'attente pour la facturation",
    orderEnqueuedForInvoicing_other: "Les commandes sont mises en file d'attente pour la facturation",
    orderSuccessNotInvoiced: 'La commande a été modifiée avec succès et ne sera plus facturée',
    orderSuccessNotInvoiced_other: 'Les commandes ont été modifiées avec succès pour ne plus être facturées',
    orderSuccessInvoicedOk: 'La commande a été marquée comme facturée OK',
    orderSuccessInvoicedOk_other: 'Les commandes ont été marquées comme facturées OK',
    orderSuccessExcluded: 'La commande a été exclue de la facturation',
    orderSuccessExcluded_other: 'Les commandes ont été exclues de la facturation',
    howManyInvoices: 'Combien de factures seront envoyées',
    fetchAmount: 'Récupérer le montant',
    wantToResend: 'Cette commande a déjà été facturée. Êtes-vous sûr(e) de vouloir la renvoyer?',
    adHocInvoiceOrder: 'Vous êtes sur le point de facturer cette commande. Voulez-vous continuer?',
    adHocInvoiceOrder_other: 'Vous êtes sur le point de facturer ces commandes. Voulez-vous continuer?',
    pauseOrders: 'Suspendre les commandes',
    datePeriod: 'Période',
    ordersWereSuccessfullyPaused: 'La facturation de {{count}} commandes a été suspendue avec succès',
    ordersWereSuccessfullyPaused_other: '{{count}} commandes ont été suspendues avec succès de la facturation',
    releaseOrders: 'Déployer les commandes',
    recalculatePrices: 'Recalculer les prix',
    ordersSentForPriceRecalculation: '{{count}} commande a été placée avec succès dans la file d’attente pour recalcul',
    ordersSentForPriceRecalculation_other:
      '{{count}} commandes ont été placées avec succès dans la file d’attente pour recalcul',
    ordersWereSuccessfullyReleased: '{{count}} commande a été validée avec succès pour la facturation',
    ordersWereSuccessfullyReleased_other: '{{count}} commandes ont été validées pour la facturation',
    addUnit: 'Ajouter une unité',
    overrideUnit: "Remplacer l'unité",
    addUnitDescription:
      'Ajoutez une unité à vos commandes sélectionnées. Cette unité est celle qui sera auto-facturée.',
    addUnitToOrders: 'Ajouter une unité aux commandes',
    addUnitToOrder: '{{unit}} a été ajouté avec succès à la commande {{count}}',
    addUnitToOrder_other: '{{unit}} a été ajouté avec succès à {{count}} commandes',
    addUnitBulkDisabled: "L'unité ne peut être ajoutée qu'aux commandes sans unité",
    approveIncompletePrices: 'Approuver avec des prix incomplets',
    manualOverrideTitle: 'Changer manuellement le statut de facturation',
    selectStatus: 'Sélectionnez le nouveau statut de facturation',
    status: 'Le statut actuel est',
    status_other: 'Les statuts actuels sont',
    manualOverrideLegend:
      "Vous êtes sur le point de modifier le statut de facturation d'une commande sélectionnée. Le statut actuel est: {{statuses}}.",
    manualOverrideLegend_other:
      'Vous êtes sur le point de modifier le statut de facturation de {{count}} commandes sélectionnées. $t(invoice.status, {"count": {{statusCount}} }): {{statuses}}.',
    manualOverrideLegend2: 'Veuillez choisir ci-dessous le statut de facturation souhaité pour cette commande.',
    manualOverrideLegend2_other: 'Veuillez choisir ci-dessous le statut de facturation souhaité pour ces commandes.',
    unitId: "ID de l'unité",
    bannerOldInvoicePage:
      "Le 26 août, <0>la nouvelle page de facturation</0> s'ouvrira par défaut. Nous vous encourageons à commencer à utiliser la nouvelle page. Plus d'infos sur la nouvelle page <1>ici</1>.",
    acceptIncompletePricesTitle: 'Approuver les prix incomplets',
    acceptIncompletePricesModalQuestion:
      "Vous êtes sur le point d'approuver {{count}} commande avec des prix incomplets. Êtes-vous sûr de vouloir continuer ?",
    acceptIncompletePricesModalQuestion_other:
      "Vous êtes sur le point d'approuver {{count}} commandes avec des prix incomplets. Êtes-vous sûr de vouloir continuer ?",
    downloadInvoiceTooltip: "La facture ne peut être affichée qu'une fois émise par le système externe",
    multilegFilter: {
      label: 'Filtrer multileg partiel',
      ALL: 'Afficher tout',
      ONLY_PARTIALLY_READY_MULTILEG: 'Afficher uniquement partiellement prêt',
      EXCLUDE_PARTIALLY_READY_MULTILEG: 'Exclure partiellement prêt'
    },
    invoicingAwaitingAcknowledgementDescription:
      'Commandes facturées en attente de confirmation d’enregistrement du système externe',
    invoicedOn: 'Envoyé le plus récemment',
    filterStates: 'Filtrer les états',
    filterDeliveryDate: 'Date de livraison',
    clearFilters: 'Effacer les filtres'
  },
  columnCategories: {
    aboutTheShipment: 'À propos de la livraison',
    goods: 'Marchandises',
    timeAndDate: 'Date et heure',
    planning: 'Planification',
    pickupInformation: "Informations d'enlèvement",
    customer: 'Client',
    deliveryInformation: 'Informations de livraison',
    originalSender: "Expéditeur d'origine",
    originalDelivery: "Livraison d'origine",
    service: 'Service',
    invoicingInformation: 'Informations de facturation'
  },
  shipment: {
    shipment: 'Expédition',
    multileg: 'Plusieurs étapes',
    customer: 'Client',
    customerContact: 'Contact client',
    customerReference: 'Référence client',
    customerNumber: 'Numéro client',
    route: 'Itinéraire',
    additionalServices: 'Services additionnels',
    quantity: 'Quantité',
    totalWeight: 'Poids total',
    totalVolume: 'Volume total',
    totalPalletFootPrints: 'Espace total des palettes',
    goodsInfo: 'Informations sur les marchandises',
    packages: 'Colis',
    pickupInfo: "Information d'enlèvement",
    pickupDate: "Date d'enlèvement",
    pickupTime: "Heure d'enlèvement",
    pickupInstructions: "Instructions d'enlèvement",
    deliveryInfo: 'Informations de livraison',
    deliveryDate: 'Date de livraison',
    deliveryTime: 'Heure de livraison',
    receiverReference: 'Référence destinataire',
    deliveryInstructions: 'Instructions de livraison',
    trackingPage: 'Page de suivi de destinataire',
    internalNote: 'Note interne',
    name: 'Nom',
    address: 'Adresse',
    zipCode: 'Code postal',
    zipArea: 'Ville',
    phone: 'Téléphone',
    secondPhone: '2nd téléphone',
    email: 'E-mail'
  },
  bookingTimeWindow: {
    week: 'Semaine',
    bookButton: 'Réserver',
    customButton: 'Créneau horaire personnalisé',
    removeBookingButton: 'Retirer la réservation',
    noBookingYet: 'Pas de réservation',
    serverError: "Une erreur s'est produite sur le serveur. Merci de réessayer plus tard.",
    previousButton: 'Précédent',
    nextButton: 'Suivant',
    noAvailableDeliveryTimes: 'Pas de créneaux de livraison disponibles ce mois-ci',
    customTimeTitle: "Définir le créneau horaire personnalisé pour l'expédition",
    errorEarliestNotBeforeLatest:
      'La première heure de livraison doit être antérieure à la dernière heure de livraison',
    arrivedAtTerminal: 'Arrivé(e) au terminal',
    bookCustomTimeSlot: 'Réserver un créneau horaire',
    shipmentBooked: 'Expédition réservée',
    shipmentBookedWithCustomTimeWindow: 'Expédition réservée avec un créneau horaire personnalisé',
    updateBooking: 'Mettre à jour la réservation',
    bookingChanged: 'La réservation a été modifiée',
    bookingSuccessful: 'La réservation a été effectuée',
    customTimeWindowAdded: 'Le créneau horaire personnalisé pour l’expédition a été ajouté',
    timeFrom: 'Première heure',
    timeTo: 'Dernière heure',
    timeFieldError: 'La première heure de livraison doit être antérieure à la dernière',
    availableTimeSlot: 'Créneaux horaires disponibles',
    submitNotSelectedError: 'Vous devez sélectionner un créneau horaire'
  },
  manualOverride: {
    manuallyAddEvents: 'Ajouter des événements manuellement',
    selectEvent: 'Sélectionner un événement',
    shipmentEvent: "Événement d'expédition",
    scannedFormDescription: "Le type de scan d'arrivée est déclenché par le service que vous choisissez.",
    eventType: {
      delivered: 'Livraison effectuée',
      collected: 'Enlèvement effectué',
      returned: 'Retourné(e)',
      deviated: 'Echec',
      scanned: 'Scanné',
      preadvised: 'Tentative de preadvice ',
      'order-sorted': 'Trié',
      'ready-for-pickup': 'Prêt pour le retrait (PUP au terminal)'
    },
    selectEventType: "Sélectionner un type d'événement",
    noEventSelected: "Pas d'événement sélectionné",
    selectManifest: 'Sélectionner un vol',
    noManifestSelected: 'Aucun vol sélectionné',
    disabledEventReason: {
      returned: ' - Echec requis',
      collected: ' - Expédition requise',
      default: ' - Non autorisé',
      'order-sorted': 'Pour les commandes H2 uniquement'
    },
    fillDeliverOrReturnEventInfo: "Remplir le nom, la date et l'heure",
    fillDeviationEventInfo: "Sélectionner échec et remplir la date et l'heure",
    fillGeneralEventInfo: "Remplir la date et l'heure",
    eventMessage: 'Evénement créé',
    allPackagesSelected: 'Tous les colis ont été sélectionnés',
    noActiveDriverError: 'Pas de livreur actif sur cette unité.',
    selectPackages: 'Sélectionner les colis',
    selectDriver: 'Sélectionner le livreur',
    selectUnit: "Sélectionner l'unité",
    selectDepartment: 'Remplacer le département de numérisation'
  },
  live: {
    onlyDeviated: 'Ne montrer que les tournées avec des déviations',
    shipment: 'Expédition',
    shipmentFrom: 'De',
    shipmentTo: 'A',
    confirm: 'Confirmer',
    unconfirm: 'Annuler la confirmation',
    confirmedBy: 'Confirmé par {{name}} à {{time}}',
    theCourier: 'Le coursier',
    activeRoutes: 'Itinéraires actifs',
    routeDeviation: "Ecart d'itinéraire",
    routeDeviations: "Ecarts d'itinéraire",
    multipleDeviations: 'Plusieurs écarts',
    recentDeviations: 'Ecarts récents',
    viewRoute: "Afficher l'itinéraire",
    noRoutesFound: "Aucun itinéraire n'a été trouvé",
    noDeviationsFound: "Aucun échec n'a été trouvé",
    consignmentDamage: 'Dommage des marchandises',
    shipmentDeviation: "Echec d'expédition",
    outsideServiceTime: 'Hors du créneau de service',
    outsideEstimatedTime: "Hors de l'heure estimée",
    deliveryLocationDeviation: 'Emplacement inattendu',
    eventTextDeviationOne: "{{name}} a un échec d'expédition.",
    eventTextDeviationMany: "{{name}} a {{count}} échecs d'expédition.",
    eventTextDamageOne: '{{name}} a des dommages sur {{count}} expéditions.',
    eventTextDamageMany: '{{name}} a des dommages sur une expédition.',
    eventTextServiceTimeWindow: '{{name}} a effectué une livraison hors du créneau horaire de service.',
    eventTextEstimatedTimeWindow: '{{name}} a effectué une livraison hors du créneau horaire estimé.',
    eventTextDeviated: "{{name}} s'est écarté de son itinéraire.",
    eventHelpDeviation: "{{name}} a un échec sur l'expédition numéro {{shipmentId}}.",
    eventHelpDamage: "{{name}} a un dommage sur l'expédition numéro {{shipmentId}}.",
    eventHelpServiceTimeWindow:
      "{{name}} a livré l'expédition numéro {{shipmentId}} à {{actual}}, ce qui est en dehors du créneau horaire de service {{earliest}}-{{latest}}.",
    eventHelpDeliveryLocationDeviation: {
      withShipmentId:
        "{{name}} a livré ou dévié le numéro de l'envoi {{shipmentId}} <4>ici</4>, à {{distance}} mètres de <9>l'emplacement prévu</9>.",
      withoutShipmentId: "{{name}} a livré ou dévié <4>ici</4>, à {{distance}} mètres de <9>l'emplacement prévu</9>."
    },
    eventHelpEstimatedTimeWindow:
      "{{name}} a livr� l'envoi num�ro {{shipmentId}} � {{actual}}, ce qui est en dehors de la fen�tre de temps estim�e {{earliest}}-{{latest}}.",
    eventHelpDriverDeviated: "{{name}} a livré l'expédition numéro {{shipmentId}} dans le mauvais ordre.",
    eventHelpDriverDeviatedAtPickup: "{{name}} a enlevé l'expédition numéro {{shipmentId}} dans le mauvais ordre.",
    eventHelpDriverDeviatedAtPickupBefore:
      "{{name}} a enlevé l'expédition numéro {{shipmentId}} dans le mauvais ordre, s'arrêtant à l'enlèvement #{{actual}} avant l'enlèvement #{{expected}}.",
    eventHelpDriverDeviatedAtPickupAfter:
      "{{name}} a enlevé l'expédition numéro {{shipmentId}} dans le mauvais ordre, s'arrêtant à l'enlèvement #{{actual}} après l'enlèvement #{{expected}}.",
    eventHelpDriverDeviatedBefore:
      "{{name}} a livré l'expédition numéro {{shipmentId}} dans le mauvais ordre, s'arrêtant à la livraison #{{actual}} avant la livraison #{{expected}}.",
    eventHelpDriverDeviatedAfter:
      "{{name}} a livré l'expédition numéro {{shipmentId}} dans le mauvais ordre, s'arrêtant à la livraison #{{actual}} après la livraison #{{expected}}.",
    filterOngoing: 'En cours',
    filterNotStarted: 'Non commencé(e)',
    filterFinished: 'Terminé(e)',
    filterOnlyDeviated: 'Uniquement les échecs',
    filterShipmentDeviations: "Echecs d'expédition",
    filterShipmentDamage: "Dommage d'expédition",
    filterEstimatedTime: 'Heure estimée',
    filterServiceTime: 'Heure de service',
    filterRouteDeviations: "Ecarts d'itinéraire",
    filterDeliveryLocationDeviation: 'Emplacement non conforme',
    filterConfirmed: 'Confirmé(e)',
    routeProgress: 'Réalisation de {{complete}} sur {{total}}',
    routeDuration: 'De {{from}} à {{to}}',
    routeDelayed: 'En retard',
    routeAhead: 'En avance',
    routeOnTime: "À l'heure",
    routeUnknown: 'Inconnu',
    routeDeviationsNone: 'Aucun écart',
    showHandledDeviations: 'Afficher toutes les déviations ({{count}})',
    openRoute: 'Voir itinéraire',
    openShipment: 'Voir expédition',
    allRoutesStates: 'Tous les statuts de la tournée',
    selectedRouteStates_other: '{{count}} statuts de tournées de livraison',
    allDeviationTypes: 'Tous les types de déviations',
    selectedDeviationTypes: '{{count}} type de déviation',
    selectedDeviationTypes_other: '{{count}} types de déviations',
    noSelectedTypes: 'Aucun type sélectionné.',
    viewShipment: "Voir l'expédition",
    selectAllRouteStates: 'Sélectionner tous les statuts  de la tournée de livraison.',
    noRoutesWithDeviations: 'Aucune tournée de livraison disponible',
    selectAllDeviationTypes: 'Sélectionner tous les types de déviations.',
    noDeviationOnRoute: 'Aucune déviation sur la tournée de livraison',
    noDeviationAvailable: 'Aucune déviation disponible',
    noDeviationsOnFilter: 'Aucune déviation disponible pour le filtre sélectionné. Essayez un filtre différent.',
    noRoutesOnFilter:
      "Il n'y a pas d'la tournée de livraisons disponibles pour le filtre sélectionné. Essayez un filtre différent.",
    search: 'Effectuer une recherche par itinéraire, véhicule ou livreur',
    unhandled: 'écarts non',
    deviations: 'gérés',
    mostDeviations: 'La plupart des écarts',
    latestInTime: 'Dernier dans le temps',
    earliestInTime: 'Le plus tôt dans le temps',
    sortOn: 'Trier sur',
    late: 'En retard',
    early: 'En avance',
    stops: 'Arrêts : {{stops}}',
    deviatedFromRoute: "Déviation de l'itinéraire",
    totalTimeMajorDeviations: 'Temps total des déviations majeures (>5 min)',
    totalTimeMinorDeviations: 'Temps total des déviations mineures (<5 min)',
    lateOrEarlyFirstStop: 'En retard ou en avance pour la première livraison',
    showAdjusted: "Afficher l'heure ajustée",
    showAdjustedTooltip: 'Heure ajustée affichée sur la page de suivi du destinataire',
    showDiff: "Afficher la différence d'arrêt",
    diff: "Différence d'arrêt",
    showDiffTooltip: "Différence entre l'heure prévue (ETD) et l'heure réelle entre les arrêts",
    modalTableSummary: "Temps total de l'itinéraire",
    liveModalActualTooltip1: "En comparaison avec l'ETD :",
    liveModalActualTooltip2: 'Vert : Jusqu’à 15 min',
    liveModalActualTooltip3: 'Orange : 15-30 min',
    liveModalActualTooltip4: 'Rouge : Plus de 30 min',
    eventTextDeliveryLocationDeviation:
      "{{name}} a livré/s'est dévié de {{distance}} mètres par rapport à l'emplacement prévu.",
    routeStateFilter: "Filtre d'état de l'itinéraire",
    departmentFilter: 'Filtre de service',
    allDepartments: 'Tous les services',
    deviationTypeFilter: 'Filtre de type de déviation',
    showSummary: 'Afficher le résumé'
  },
  zendesk: {
    email: 'Votre e-mail :',
    confirmEmail: 'Saisir à nouveau votre e-mail :',
    send: 'Enregistrer',
    missingEmail:
      "Pour utiliser le nouveau portail, vous devez enregistrer votre adresse e-mail Posten ou Bring. Vous ne devez le faire qu'une seule fois."
  },
  shipmentFormPage: {
    activeOrders: 'Commandes actives',
    deletedOrders: 'Commandes supprimées',
    deletedOrdersDescription:
      'Les commandes supprimées sont recherchées séparément et peuvent contenir des informations différentes de celles des commandes actives.',
    advancedFilter: 'Filtre avancé',
    advancedSearch: 'Recherche avancée',
    closeAdvancedSearch: 'Fermer la recherche avancée',
    selectTable: 'Sélectionner une table',
    selectCondition: 'Sélectionner une condition',
    searchPhraseError: 'Vous devez fournir au moins 3 caractères',
    selectStateLabel: 'Sélectionnez un état dans la liste déroulante',
    selectDateLabel: 'Sélectionnez une date dans la liste déroulante',
    submit: 'Afficher les résultats',
    inputPlaceholder: 'Rechercher l’ID d’expédition, le numéro de téléphone, l’adresse, la région, le code postal...',
    clearButtonLabel: 'bouton d’effacement de l’expression de recherche',
    allStates: 'Tous les états',
    customDate: 'Personnaliser',
    noDate: 'Aucune restriction de date',
    withoutDeliveryDate: 'Sans date de livraison',
    selectFromDate: 'Sélectionnez la date de début',
    selectToDate: 'Sélectionnez la date de fin',
    include: 'Inclure',
    exclude: 'Exclure',
    tableColumn: 'Colonne de tableau',
    searchTerm: 'Rechercher un terme',
    tableDropdown: 'Sélectionnez un tableau dans la liste déroulante',
    conditionDropdown: 'Sélectionnez une condition dans la liste déroulante',
    typeSearch: 'Taper dans le terme de recherche',
    typeSearchCommaSeparated: 'Saisir les termes de recherche, séparés par une virgule',
    addNewRow: 'Ajouter un nouveau rang',
    deleteRow: 'Effacer le rang actuel',
    goodsDescription: 'Description des marchandises',
    unit: 'Unité',
    deliveryArea: 'Zone de livraison',
    deliveryZipcode: 'Code postal de livraison',
    state: '{{count}} État',
    state_other: '{{count}} États',
    today: "Aujourd'hui",
    tomorrow: 'Demain',
    yesterday: 'Hier',
    last30Days: 'Les 30 derniers jours',
    plusMinus15Days: '+/- 15 jours',
    plusMinus30Days: '+/- 30 jours',
    shipmentIds: 'Plusieurs expéditions',
    orderId: 'Numéro de commande interne',
    allAnd: 'Tous (et)',
    anyOr: "N'importe lequel (ou)",
    customers: {
      placeholder: 'Tous les clients',
      label: 'Sélectionner des clients'
    },
    allOrderSources: 'Toutes les sources de commande internes',
    orderSource: '{{count}} source de commande interne',
    orderSource_other: '{{count}} sources de commande internes',
    vasCodes: '{{count}} code VAS',
    vasCodes_other: '{{count}} codes VAS',
    vasCodesPlaceholder: 'Rechercher par code VAS ou nom',
    orderSourceOption: {
      GLOW: 'GLOW',
      GLOW_CUSTOMER_BOOKING: 'GLOW Réservation client',
      GLOW_EXCEL: 'GLOW Excel'
    }
  },
  shipmentResultPage: {
    deletedOrdersLimitReached:
      'Affichage des {{limit}} dernières commandes supprimées. Envisagez d’affiner votre recherche.',
    noResultTitle: 'Aucun résultat trouvé',
    batchLimitReached: 'Affichage d’un maximum de 2000 expéditions, envisagez d’affiner la recherche',
    withoutDateLimitReached:
      'En cas de recherche sans date, nous afficherons un maximum de {{limit}} expéditions. Envisagez d’affiner votre recherche.',
    withoutDeliveryDateLimitReached:
      'Lorsque vous recherchez des envois sans date de livraison, nous afficherons un maximum de {{limit}} envois. Pensez à affiner votre recherche.',
    findYourShipments: 'Trouvez vos envois',
    findYourShipmentsDescription:
      "Saisissez ce que vous recherchez dans le champ de recherche ci-dessus. Plus d'options sont disponibles dans la recherche avancée.",
    searchByShipmentIdsLimitReached:
      "Lorsque vous recherchez par identifiants d'envoi, nous afficherons un maximum de {{limit}} envois. Pensez à affiner votre recherche.",
    searchError: 'La recherche a échoué. Essayez de recharger la page ou de modifier vos paramètres de recherche.'
  },
  shipmentResultActions: {
    confirmDeleteTitle: 'Supprimer l’expédition ?',
    confirmDeleteTitle_other: 'Supprimer les envois sélectionnés ?',
    confirmDuplicateTitle: 'Dupliquer l’expédition ?',
    confirmDuplicateButton: 'Dupliquer',
    deleteSuccess: 'L’expédition a été supprimée',
    deleteSuccess_other: 'Les envois ont été supprimés avec succès.',
    invoiceActions: 'Actions sur la facture',
    shipmentActions: "Actions sur l'envoi",
    showInvoicePayloadDisableTooltip: 'Les envois doivent être en statut de facturation "échec" ou "OK".'
  },
  shipmentTable: {
    quantity: 'Quantité',
    delEta: 'HAE LIV',
    delDuration: 'D LIV',
    delDurationTitle: 'Durée de livraison',
    delPreparation: 'P LIV',
    delPreparationTitle: 'Préparation de la livraison',
    delDeliveryFrom: 'LIV DE',
    delDeliveryFromTitle: 'Heure de livraison de début',
    delDeliveryTo: 'LIV À',
    delDeliveryToTitle: 'Heure de livraison de fin',
    timeOfDelivery: 'Heure de livraison',
    puDuration: 'D ENL',
    puDurationTitle: 'Délai d’enlèvement',
    puPreparation: 'P ENL',
    puPreparationTitle: 'Préparation de l’enlèvement',
    puPickupFrom: 'ENL DE',
    puPickupFromTitle: 'Heure d’enlèvement de début',
    puPickupTo: 'ENL À',
    puPickupToTitle: 'Heure d’enlèvement de fin',
    timeOfPickup: 'Heure d’enlèvement',
    timeFrom: 'Heure DE',
    timeFromTitle: "Heure d'arrêt de début",
    timeTo: 'Heure À',
    timeToTitle: "Heure d'arrêt de fin",
    delEtaTitle: 'Heure de livraison estimée',
    recipientRef: 'Réf. destinataire',
    loading: 'Chargement en cours...',
    pickupName: 'Nom pour l’enlèvement',
    deliveryName: 'Nom pour la livraison',
    pickupColumn: 'Enlèvement : {{column}}',
    deliveryColumn: 'Livraison : {{column}}',
    selectAllOnPage: 'Sélectionner tout sur page ({{count}})',
    selectAll: 'Sélectionner tout ({{count}})',
    deselectAll: 'Désélectionner tout',
    numSelectedShipments: '{{numSelected}} sélectionné(e)(s)',
    createLabels: 'Créer les étiquettes',
    yourSearchResult: 'Le résultat de votre recherche',
    numberOfShipmentsFound: '{{count}} expéditions trouvées',
    orderedDeliveryDate: 'Date de livraison prévue'
  },
  moveDepartmentModal: {
    errorMessage: 'Commande(s) : {{orderIds}}, erreur : {{error}}',
    errorMessage_other: 'Commande(s) : {{orderIds}}, erreur : {{error}}',
    ordersMovedText: 'La ou les commandes {{orderIds}} ont été déplacées vers le département {{department}}',
    ordersMovedText_other: 'La ou les commandes {{orderIds}} ont été déplacées vers le département {{department}}',
    partialSuccessMessage: '{{count}} expédition(s) sur {{fullCount}} a(ont) été déplacée(s)',
    title: 'Déplacer l’expédition sélectionnée vers un autre département'
  },
  updateDeliveryTimeBulk: {
    menuItem: "Modifier la date et l'heure de livraison",
    heading: "Modifier la date et l'heure de livraison",
    buttonTitle: 'Modifier et notifier les destinataires',
    smsDescription:
      "Les destinataires reçoivent un SMS avec la nouvelle date et le nouveau créneau horaire de livraison, ainsi qu'un lien pour les modifier.",
    successMessage: '{{count}} expédition a été mise à jour',
    successMessage_other: '{{count}} expéditions ont été mises à jour',
    notNotified:
      "Aucun SMS n'a été envoyé pour {{shipmentIds}} - le destinataire n'a pas de numéro de téléphone ou d'adresse e-mail valide",
    notNotified_other:
      "Aucun SMS n'a été envoyé pour {{shipmentIds}} - les destinataires n'ont pas de numéro de téléphone ou d'adresse e-mail valide",
    disabledTooltip:
      "L'heure de livraison ne peut être modifiée qu'avant que l'expédition ne soit affectée à un itinéraire",
    dateInPast: 'La date de livraison ne peut pas être dans le passé',
    invalidDate: 'Date non valide'
  },
  sendManualDelaySmsModal: {
    partialSuccessMessage: '{{count}} SMS sur {{fullCount}} a(ont) été envoyé(s)',
    successMessage: 'Un SMS de retard manuel a été envoyé'
  },
  sendPrePickupSmsModal: {
    'return-order': 'Les commandes ne peuvent pas être des retours',
    'invalid-state': 'Les commandes doivent avoir le statut "Attribué à la plage horaire".'
  },
  multistopModal: {
    title: 'Informations de groupe',
    description: 'Vue de groupe pour les commandes payées ensemble.',
    debitLines: 'Lignes de débit',
    notFound: 'Aucune information de groupe trouvée',
    shipmentId: 'ID expédition',
    deliveryDate: 'Date de livraison',
    stopAddress: "Adresse d'arrêt",
    postalCode: 'Code postal',
    noPrice: 'Aucune information de prix disponible pour le groupe',
    priceUpdated: 'Les prix du groupe ont été mis à jour'
  },
  shipmentDetails: {
    notFoundTitle: 'Expédition introuvable',
    notFoundDescription: 'Elle a peut-être été supprimée.',
    overview: 'Aperçu',
    details: 'Détails',
    orderInformation: 'Informations sur la commande',
    volumeAndWeight: 'Volume et poids',
    references: 'Références',
    goods: 'Marchandises',
    contactInformation: 'Coordonnées',
    pickupContactInformation: 'Coordonnées d’enlèvement',
    deliveryContactInformation: 'Coordonnées de livraison',
    eventWasAdded: 'L’événement a été ajouté',
    issueSaving: 'Un problème est survenu lors de l’enregistrement',
    noSelectedPackages: 'Aucun colis n’a été sélectionné',
    pickupAndDelivery: 'Enlèvement et livraison',
    whereIsTheOrder: 'Où est la commande',
    communicationToRecipient: 'Communication au destinataire',
    yesPremium: 'Oui, premium',
    alerts: 'Alertes',
    pickupDeliveryInfo: 'Informations d’enlèvement et de livraison',
    quickEdit: 'Modification rapide',
    quickEditTitle: 'Modifier les détails d’enlèvement et de livraison',
    aboutShipment: 'À propos de l’expédition',
    mapLinkText: 'Afficher les coordonnées de carte',
    copyShipment: 'Copier l’expédition',
    editShipment: 'Modifier les détails d’expédition',
    location: 'Lieu',
    time: 'Heure',
    selectDate: 'Sélectionner la date',
    manualChangeEvent: 'Modifier manuellement l’événement',
    disabledEventReason: {
      returned: 'Échec requis',
      collected: 'Doit être affectée à un itinéraire',
      default: 'Non autorisé(e)'
    },
    selectDeviation: 'Sélectionner Échec',
    required: 'Obligatoire(s)',
    allPackages: 'Tous les colis',
    packages: 'Colis',
    package: 'Colis',
    changeDepartment: 'Modifier le département',
    moveDepartment: 'Déplacer vers département',
    shipmentMoved: 'Expédition déplacée',
    shipmentMovedText: 'L’expédition {{shipmentId}} a été déplacée vers le département {{department}}',
    shipmentMovedGoBack: 'Retourner à la page de recherche',
    shipmentCouldNotBeMoved: 'L’expédition n’a pas pu être déplacée',
    moveShipmentDescription:
      'Si vous n’avez pas accès au service, vous ne pourrez pas trouver l’expédition après son déplacement',
    moveShipmentConfirmText: 'Déplacer l’expédition vers un autre service ?',
    addShipmentToSlot: 'Ajouter l’expédition à {{slot}} ?',
    changeSlotConfirm: 'Changer la tournée pour l’expédition à {{slot}} ?',
    changeSlot: 'Changer la tournée',
    selectSlot: 'Sélectionner une tournée',
    AddToSlot: 'Ajouter à la tournée',
    optimisationInProgress:
      'Optimisation en cours. Vous ne pouvez pas changer la tournée pendant l’optimisation de l’itinéraire.',
    removeFromSlot: 'Supprimer de la tournée',
    removeShipmentFromSlot: 'Supprimer l’expédition de la tournée',
    removeShipmentFromSlotHeading: 'Supprimer l’expédition de cette tournée ?',
    successRemoveFromSlot: 'L’expédition a été supprimée de la tournée',
    successChangeSlot: 'Expédition affectée à une nouvelle tournée',
    successAddToSlot: 'Expédition ajoutée à la tournée',
    changeSlotDescription: 'Le changement de tournée est fait sans optimisation d’itinéraire.',
    addToSlotDescription: 'La tournée sélectionnée sera optimisée et l’ordre de livraison restera le même',
    pickupOrDeliveryChange: 'L’enlèvement ou la livraison a été changé(e)',
    pickupOrDeliveryChangeDescription:
      'L’adresse d’enlèvement ou de livraison a été changée. Si vous voulez remettre l’adresse précédente, appuyez sur l’un des boutons ci-dessous.',
    addressWasUnresolved: 'Adresse non résolue',
    eventTimeCannotBeInFuture: "L'heure de l'événement ne peut pas être dans le futur.",
    shipmentSuccessfullyUpdated: 'L’expédition a été mise à jour avec succès',
    connectedShipments: 'Expéditions associées',
    goToShipment: 'Aller à l’expédition',
    currentShipment: 'Expédition actuelle',
    duplicate: 'Doublon'
  },
  terminal: 'Dépôt',
  location: 'Emplacement',
  pickupOrders: {
    acceptOrders: 'Accepter les commandes',
    selected: 'sélectionnée(s)',
    handleOrders: 'Gérer les commandes d’enlèvement',
    found: 'trouvé',
    accept: 'Accepter',
    reject: 'Refuser',
    noResultText: 'Nous n’avons pu trouver aucun résultat. Merci d’essayer de faire une recherche avec une autre date.',
    last7d: 'Aujourd’hui + 7 derniers jours',
    rejectOptions: {
      notFound:
        'Expéditeur introuvable sur l’adresse d’enlèvement. Aucune autre tentative possible. Enlèvement clôturé.',
      terminatesPickupOrder:
        'L’expéditeur met fin à la commande d’enlèvement. Aucune autre tentative possible. Clôture de l’enlèvement.',
      handedOver:
        'L’expéditeur a transmis l’enlèvement à un autre transporteur. Aucune autre tentative possible. Enlèvement clôturé.',
      noMoreAttempts: 'L’expéditeur a déménagé. Aucune autre tentative possible. Enlèvement clôturé.',
      pickupCorrected: 'L’expéditeur a déménagé. Enlèvement corrigé et renvoyé au sous-traitant.',
      goodsNotReady:
        'Les marchandises n’étaient pas prêtes à être enlevées. Aucune autre tentative possible. Enlèvement clôturé.',
      incorrectBooking: 'Réservation incorrecte. Mise à fin de l’enlèvement.',
      senderRefuses:
        'L’expéditeur refuse de remettre les marchandises. Aucune autre tentative possible. Enlèvement clôturé.',
      addressCorrected: 'Adresse d’enlèvement incorrecte. Adresse corrigée.',
      incorrectAddressNoMoreAttempts:
        'Adresse d’enlèvement incorrecte. Aucune autre tentative possible. Enlèvement clôturé.',
      senderNotified: 'Adresse d’enlèvement incorrecte. Aucune autre tentative possible. Enlèvement clôturé.',
      forbiddenGoods: 'Marchandises interdites. Aucune autre tentative possible. Enlèvement clôturé.',
      timeFrame:
        'Impossible de faire l’enlèvement dans le délai d’exécution. Commande d’enlèvement renvoyée au bureau de réservation.'
    },
    mustSelectReason: 'Vous devez sélectionner un motif pour le refus',
    selectRejectReason: 'Sélectionnez un motif pour le refus*',
    selectReason: 'Sélectionnez le motif',
    commentPlaceholder: 'Facultatif – fournissez des informations supplémentaires sur le refus',
    acceptedSuccessToast: 'a été acceptée',
    rejectedSuccessToast: 'a été refusée',
    errorToast: 'Une erreur s’est produite',
    rejectOrders: 'Refuser les commandes',
    shipment: '{{count}} expédition',
    shipment_other: '{{count}} expéditions'
  },
  editShipments: {
    pickupShouldBeBeforeDelivery:
      "L'expédition [{{shipmentIds}}] n'était pas éligible car la combinaison des horaires nouveaux et existants n'est pas valide. Veuillez désélectionner la commande en échec et réessayer.",
    pickupEarliestShouldBeBeforeLatest: 'La première heure d’enlèvement doit être antérieure à la dernière',
    deliveryEarliestShouldBeBeforeLatest: 'La première heure de livraison doit être antérieure à la dernière',
    success: 'Les informations d’expédition ont été mises à jour',
    mixedShipmentsSelected:
      'Vous avez sélectionné des expéditions avec et sans date. Les informations de livraison et d’enlèvement sont obligatoires.',
    fieldNotEditable:
      'Impossible de modifier ces informations pour les commandes dans l’état Affectée à la tournée ou Enlèvement effectué',
    bulkActionDisabledReason: 'Impossible de modifier les commandes dans l’état Échec, Livrée, Refusée ou Retournée',
    withoutDateDisabledReason:
      'Impossible de modifier les commandes dans l’état Affectée à la tournée ou Enlèvement effectué qui sont sans date',
    pickupShouldBeBeforeDeliveryForAllShipments_other:
      "{{count}} commandes n'étaient pas éligibles en raison de la combinaison d'horaires nouveaux et existants qui n'est pas valide. Veuillez désélectionner les commandes en échec et réessayer. ID des commandes en échec - {{shipmentIds}}",
    useExistingTimes: 'Utiliser les horaires existants',
    pickupDateTime: 'Enlèvement date et heures',
    deliveryDateTime: 'Livraison date et heures',
    earliestPickupTime: "Première heure d'enlèvement",
    latestPickupTime: "Dernière heure d'enlèvement",
    earliestDeliveryTime: 'Première heure de livraison',
    latestDeliveryTime: 'Dernière heure de livraison',
    pickupName: 'Enlèvement nom',
    pickupPhoneNumber: 'Enlèvement numéro de téléphone',
    deliveryName: 'Livraison nom',
    deliveryPhoneNumber: 'Livraison numéro de téléphone',
    pickupInstructions: "Instructions d'enlèvement",
    deliveryInstructions: 'Instructions de livraison'
  },
  shipmentSelectColumn: {
    titleDeletedOrders: 'Personnaliser le tableau des commandes supprimées',
    title: 'Personnaliser les en-têtes de tableau',
    addColumnHeader: 'Ajouter les en-têtes de colonnes',
    addColumnBody:
      'Sélectionnez les en-têtes que vous souhaitez afficher dans le tableau de données. Nous vous conseillons d’utiliser 10-15 différentes\n...en-têtes afin que les informations ne soient pas coupées. Le montant exact dépend de la taille de\n    l’appareil sur lequel vous travaillez.',
    orderOfTable: 'Ordre des en-têtes de tableau'
  },
  bulkActions: {
    routeReceiptList: { disabledTooltip: 'Les commandes ne peuvent pas être dans l’état Résolue ou Non résolue' },
    unassignShipmentFromSlot: 'Annuler l’affectation des expéditions aux tournées',
    unassignShipmentFromSlotDisabledReason: 'Les commandes doivent être dans l’état Affectée à la tournée ou Offerte',
    forceUnassignShipmentFromSlot: 'Forcer l’annulation de l’affectation des expéditions aux tournées',
    disabledMoveDepartmentTooltip:
      'Les commandes doivent être dans l’état Créée, Résolue, Non résolue ou Refusée avant de pouvoir être déplacées',
    deleteDisableTooltip:
      'Impossible de supprimer une expédition dont l’état est Créée, Non résolue, Résolue, Offerte ou Affectée',
    duplicateDisableTooltip:
      'Les expéditions doivent être dans l’état Échec ou Retournée, et le type de service doit être Coursier',
    viewGroupDisabledTooltip: 'La commande doit être attribuée avant que vous puissiez voir et modifier son groupe'
  },
  dispatchModal: {
    title: 'Enlèvements et livraisons sur la tournée de livraison {{name}}',
    overridePalletRule: {
      question: 'Ignorer la règle des palettes ?',
      description:
        "L'expédition contient des palettes, mais le véhicule de cette tournée n'est pas indiqué comme pouvant transporter des palettes. Voulez-vous quand même l'affecter à cette tournée ?",
      confirm: 'Affecter quand même'
    },
    palletRule: 'Règle des palettes',
    ignorePalletRule: 'Autoriser les palettes sur les véhicules qui ne peuvent pas les transporter',
    partialForcedOrderLabel: 'Définir l’ordre des zones/les commandes sélectionnées',
    partialForcedOrder: 'Ordre sélectionné',
    partialForcedOrderInfo:
      'Vous avez choisi de définir l’ordre de certains arrêts/zones. Les autres arrêts sont optimisés autour de ceux-ci.',
    force: 'Forcer',
    optimizingEngine: "Moteur d'optimisation",
    invalidRouteOrder:
      "Les enlèvements ne peuvent pas précéder les livraisons. Modifiez l'ordre de la tournée de livraison.",
    submitDisabled: 'Replanifier la tournée de livraison pour activer le bouton',
    replanDisabled: "L'ordre de la tournée de livraison doit être valide pour être replanifié",
    noShipments: 'Aucune expédition sur la tournée de livraison',
    noShipmentsDescription:
      ' Vous avez supprimé toutes les commandes de la tournée de livraison, appuyez sur <i>Confirmer la tournée de livraison</i> pour enregistrer les modifications.',
    unassignBreakFromRoute: 'Cliquez pour enlever la pause de la tournée de livraison',
    editBreakOnRoute: 'Cliquez pour modifier la pause sur la tournée de livraison',
    routeEnd: 'Fin de tournée',
    routeStart: 'Début de tournée',
    earliestStartOfBreak: 'Début le plus tôt de la pause',
    latestStartOfBreak: 'Début le plus tardif de la pause',
    overrideOptimizingEngine: "Remplacer le moteur d'optimisation par défaut",
    openRowMenu: 'Ouvrir le menu de la ligne',
    openPlannedStopMenu: 'Ouvrir le menu de l’arrêt planifié',
    newPositionForStop: 'Choisir une nouvelle position pour l’arrêt',
    warning:
      "Vous avez choisi de ne pas utiliser un moteur d'optimisation pour cet itinéraire. Cela affectera l'expérience du destinataire.",
    flexDisabled: "Il n'est pas permis de <strong>flexibiliser</strong> des envois individuels dans un groupe",
    forceDisabled: "Il n'est pas permis de <strong>forcer</strong> des envois individuels dans un groupe",
    removeDisabled: "Il n'est pas permis de <strong>supprimer</strong> des envois individuels dans un groupe",
    orderDisabled: "Il n'est pas permis de <strong>modifier l'ordre</strong> des envois individuels dans un groupe",
    plannedStopRowDisabled:
      "Vous n'êtes pas autorisé à <strong>modifier l'ordre</strong> d'un arrêt planifié pendant la modification",
    showStops: 'Afficher les arrêts',
    viewStopsOnSameAddress: 'Afficher les arrêts regroupés à la même adresse',
    addPlannedStopLocations: "Ajouter des emplacements d'arrêt planifiés",
    selectPlannedStopLocation: 'Sélectionner un arrêt planifié',
    plannedStop: 'Arrêt planifié',
    visitEarliest: 'Visite au plus tôt',
    visitLatest: 'Visite au plus tard',
    serviceTime: 'Durée',
    addPlannedStop: 'Ajouter un arrêt et replanifier',
    updatePlannedStop: "Mettre à jour l'arrêt et replanifier",
    editPlannedStopOnRoute: "Modifier l'arrêt planifié sur l'itinéraire",
    unassignPlannedStopFromRoute: "Dissocier l'arrêt planifié de l'itinéraire",
    settings: 'Paramètres',
    multipleRecipients: 'Destinataires multiples ({{number}})',
    multiplePickups: 'Enlèvements multiples ({{number}})',
    mustProvideStopLocation: "Vous devez fournir un emplacement d'arrêt",
    editingLockBanner: "L'itinéraire est en cours de modification par {{name}} depuis {{time}}.",
    editingLockBannerBody: "Vous devez reprendre le routage pour replanifier l'itinéraire.",
    takeOver: 'Reprendre',
    routeChangedByOtherUser: '{{name}} a terminé la modification. Rechargez pour continuer.',
    reloadRoute: "Recharger l'itinéraire",
    noShipmentsRouteUpdated: "Recharger l'itinéraire pour voir les expéditions",
    duplicateTabBanner: 'Cet itinéraire est ouvert dans un autre onglet (depuis {{time}}).',
    duplicateTabBannerBody: 'Reprenez ici pour modifier dans cet onglet.'
  },
  vehicle: {
    createNewVehicle: 'Créer un nouveau véhicule',
    vehiclesInDepartment: 'Véhicules dans {{departmentName}}',
    listAllVehicle: 'Lister tous les véhicules de ce service',
    weightCapacity: 'Capacité de poids ',
    volumeCapacity: 'Capacité de volume',
    maxRangeKm: 'Distance maxi',
    deleteSuccessMessage: 'Le véhicule a été supprimé avec succès.',
    createdSuccessMessage: 'Le véhicule a été créé avec succès.',
    updatedSuccessMessage: 'Le véhicule a été mis à jour avec succès.',
    deleteVehicle: 'Supprimer le véhicule',
    notRecover: 'Vous ne pourrez pas annuler cette action.',
    createVehicle: 'Créer un véhicule',
    editVehicle: 'Modifier {{name}}',
    vehicleInformation: 'Informations sur le véhicule',
    selectFuelType: 'Sélectionner le type de carburant',
    selectEuroClass: 'Sélectionner la classe Euro',
    settings: 'Paramètres',
    activeDriver: 'Conducteur actif',
    noVehicleControl: 'Aucun contrôle du véhicule',
    slower: 'Plus lent',
    slow: 'Lent',
    faster: 'Plus rapide',
    speedFactorVehicle: 'Facteur de vitesse du véhicule',
    driverSpeed: 'Vitesse du conducteur',
    serviceSpeed: 'Vitesse du service',
    defaultStartLocation: "L'emplacement de départ par défaut est l'adresse du service.",
    specifyEndLocation: "Spécifier l'emplacement d'arrivée",
    earliest: 'Le plus tôt',
    latest: 'Le plus tard',
    normal: 'Normal'
  },
  lmEvents: {
    heading: 'Evènements LM',
    event: 'Evènement ',
    lmEventReasonAction: 'LM Événement-Raison-Action',
    eventTime: "Heure de l'événement",
    eventSentAt: 'Événement envoyé à',
    lmPayload: 'LM Charge utile',
    view: 'Afficher',
    enterShipmentId: 'Vous devez entrer un numéro de livraison',
    searchForShipmentId: "Rechercher l'identifiant de l'envoi"
  },
  cms: {
    scheduleBanner: 'Planifier banner',
    cms: 'CMS',
    publicationDate: 'Date de publication',
    lastEdited: 'Dernière modification',
    dateForUnpublish: 'Date de dépublication',
    createNewBanner: 'Créer une nouvelle bannière',
    createNewWhatsThisModal: "Créer une nouvelle fenêtre d'information",
    publish: 'Publier',
    schedule: 'Planifier',
    unpublish: 'Dépublier',
    savePublish: 'Enregistrer et publier',
    saveAsDraft: 'Enregistrer comme brouillon',
    saveAsDraftUnpublish: 'Enregistrer comme brouillon et dépublier',
    noBannersFound: 'Aucune bannière trouvée',
    noModalsFound: 'Aucune fenêtre trouvée',
    DRAFT: 'Brouillon',
    PUBLISHED: 'Publié',
    SCHEDULED: 'Planifié',
    content: 'Contenu',
    nameOfBanner: 'Nom de la bannière',
    placementOfBanner: 'Emplacement de la bannière',
    placementOfBannerDescription:
      'Collez l\'URL X sur laquelle vous souhaitez ajouter une bannière. Si vous voulez publier une bannière pour toutes les sections ou endast certaines, vous pouvez soit appuyer sur le bouton "Ajouter une URL", soit modifier le lien vous-même.',
    urlToPageInGlow: 'URL vers la page dans Glow',
    addUrl: 'Ajouter une URL',
    typeOfBanner: 'Type de bannière',
    typeOfBannerDescription: 'Choisissez entre Avertissement (orange), Neutre (gris) ou Erreur (rouge).',
    bannerNeutral: 'Neutre (gris)',
    bannerWarning: 'Avertissement (orange)',
    bannerError: 'Erreur (rouge)',
    links: 'Liens',
    linksDescription:
      "Le lien de l'article est placé après le texte principal. Si vous ajoutez un lien vers l'ancienne page, il sera placé avant le texte principal.",
    goBackToOldPageLink: "Lien vers l'ancienne page",
    messageInBanner: 'Message dans la bannière',
    messageInBannerDescription:
      "L'anglais est obligatoire. Si aucune autre langue n'est sélectionnée, l'anglais sera utilisé par défaut sur toutes les pages.",
    addAdditionalLanguages: "Ajouter d'autres langues",
    bannerText: 'Texte',
    nameOfLink: 'Nom du lien',
    englishText: 'Texte en anglais',
    englishLinkText: 'Nom du lien (anglais)',
    selectLanguage: 'Choisir la langue',
    addNewLanguage: 'Ajouter une nouvelle langue',
    deleteBanner: 'Supprimer la bannière {{name}}',
    bannerWasSaved: 'La bannière {{name}} a été enregistrée',
    bannerWasPublished: 'La bannière {{name}} a été publiée',
    bannerWasScheduled: 'La bannière {{name}} a été planifiée',
    articleLink: "Lien de l'article",
    goBackToOldPage: "Retour à l'ancienne page",
    previousPageNote: 'Remarque : utilisez les caractères génériques department-id et date dans ce champ',
    selectTime: "Choisir l'heure",
    setStartDate: 'Définir la date de début de la bannière',
    setEndDate: 'Définir la date de fin de la bannière',
    endTimeIsBeforeStartTime: "L'heure de fin ne peut pas être antérieure à l'heure de début",
    endDateIsBeforeStartDate: 'La date de fin ne peut pas être antérieure à la date de début',
    oneBannerPerPageError:
      "Une seule bannière par page est autorisée. L'URL chevauche une bannière existante : {{banners}}",
    mustProvideUrl: 'Vous devez fournir une URL',
    mustProvideNameOfBanner: 'Vous devez fournir un nom de bannière',
    mustProvideNameOfModal: 'Vous devez fournir un nom de fenêtre',
    mustProvideEnglishText: 'Vous devez fournir un texte en anglais',
    mustProvideArticleLink: "Vous devez fournir un lien d'article",
    mustProvideNameOfArticleLink: "Vous devez fournir un nom pour le lien de l'article",
    mustProvideDate: 'Vous devez fournir une date',
    invalidArticleLink: "Vous devez fournir un lien d'article valide, par exemple : https://example.com",
    errorDuplicateBanner: 'Le nom de la bannière doit être unique. Une bannière avec ce nom existe déjà.',
    draftScheduleTooltip: 'Supprimez la planification pour enregistrer comme brouillon',
    banner: 'Bannière',
    listOfBanners: 'Liste des bannières',
    whatsThisModal: "Fenêtre d'information",
    whatsThis: "Qu'est-ce que c'est",
    listOfWhatsThisModals: "Liste des fenêtres d'information",
    nameOfWhatsThisModal: "Nom de la fenêtre d'information",
    descriptionWhatsThisModal:
      "Le nom doit être unique. Conseil : nommez la fenêtre selon son emplacement, par exemple 'Admin Pre-advice' ou 'Planner Live.'",
    nameOfModal: 'Nom de la fenêtre',
    pageLinkOfModal: 'Page où la fenêtre doit apparaître',
    pageLinkOfModalDescription:
      "Collez l'URL Glow à l'endroit souhaité. Remplacez l'ID du département par * pour publier la fenêtre sur tous les départements.",
    linkToPageGlow: 'Lien vers la page dans Glow',
    modalPreviewEmptyTitle: 'Aucune information pour le moment',
    modalPreviewEmptyDescription: 'Vous devez ajouter des informations pour obtenir un aperçu de la fenêtre',
    addTextForModal: 'Ajouter du texte pour la fenêtre',
    addTextForModalDescription:
      "L'anglais est obligatoire et sera utilisé par défaut si aucune autre langue n'est renseignée. Cliquez sur le lien 'Qu'est-ce que c'est' pour obtenir des conseils.",
    searchBannerPlaceholder: 'Rechercher une bannière',
    searchModalPlaceholder: 'Rechercher une fenêtre',
    cmsNews: 'Actualité',
    cmsNewsLabel: 'Actualités',
    listOfCMSNews: 'Liste des actualités',
    noCMSNewsFound: 'Aucune actualité trouvée',
    searchCMSNewsPlaceholder: 'Rechercher une actualité',
    cMSNewsSettingsTitle: "Emplacement de l'actualité",
    cMSNewsSettingsDescription:
      "Votre actualité apparaîtra sur la page d'accueil et sera visible par tous les utilisateurs lors de leur connexion à Glow.",
    nameOfCMSNews: "Nom de l'actualité",
    descriptionOfCMSNewsName:
      'Donnez un nom à votre mise à jour afin de la retrouver facilement. Le nom doit être unique.',
    typeOfCMSNews: "Type d'actualité",
    typeOfCMSNewsDescription: 'Choisissez entre Statut du service, Nouvelle fonctionnalité ou Information.',
    selectTypeOfCMSNews: "Choisir le type d'actualité",
    newFeatureCMSNews: 'Nouvelle fonctionnalité',
    serviceStatusCMSNews: 'Statut du service',
    informationCMSNews: 'Information',
    NEW_FEATURE: 'Nouvelle fonctionnalité',
    SERVICE_STATUS: 'Statut du service',
    INFORMATION: 'Information',
    scheduleCMSNews: "Planifier l'actualité",
    scheduleCMSNewsDescription: 'Une actualité planifiée ne peut pas être enregistrée comme brouillon.',
    setStartDateForCMSNews: "Définir la date de début de l'actualité",
    setEndDateForCMSNews: "Définir la date de fin de l'actualité",
    cMSNewsPreviewEmptyTitle: 'Aucune information pour le moment',
    cMSNewsPreviewEmptyDescription: "Vous devez ajouter des informations pour obtenir un aperçu de l'actualité",
    addTextForCMSNews: "Ajouter du texte pour l'actualité",
    addTextForCMSNewsDescription:
      "L'anglais est obligatoire et sera utilisé par défaut si aucune autre langue n'est renseignée. Cliquez sur le lien 'Qu'est-ce que c'est' pour obtenir des conseils.",
    mustProvideNameOfCMSNews: "Vous devez fournir un nom pour l'actualité",
    createNewCMSNews: 'Créer une nouvelle actualité',
    continueToYourPage: 'Continuer vers votre page',
    clearSelection: 'Effacer la sélection'
  },
  userRolesAdmin: {
    price: 'Prix',
    searchPlaceholder: 'Rechercher un rôle utilisateur',
    userRoles: "Rôles d'utilisateur",
    successCreateMessage: '{{name}} a été créé avec succès',
    successUpdateMessage: '{{name}} a été mis à jour avec succès',
    saveRole: 'Enregistrer le rôle',
    editRole: 'Modifier {{name}}',
    createNewRole: 'Créer un nouveau rôle',
    nameOfRole: 'Nom du rôle',
    nameRequired: 'Le nom est requis',
    descriptionRequired: 'La description est requise',
    descriptionLabel: 'Description (max 240 caractères)',
    iconLabel: "Sélectionnez l'icône que vous souhaitez pour le rôle utilisateur",
    selectRoleTitle: "Sélectionner le droit d'accès pour le rôle",
    emptyState: 'Aucun rôle trouvé pour la phrase recherchée',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer {{name}}?',
    deleteSuccess: 'Le rôle {{name}} a été supprimé avec succès',
    settings: 'Paramètres',
    accessRights: "Droits d'accès",
    settingsTitle: 'Paramètres du rôle',
    settingsDescription:
      "L'anglais est requis. Si aucune autre langue n'est sélectionnée, l'anglais sera la langue de secours.",
    additionalLanguagesTitle: 'Ajouter des langues supplémentaires',
    customerPortalAccess: 'Accès au portail client',
    defaultForUserRole: 'Utiliser comme rôle par défaut (facultatif)',
    event: 'Événement',
    financialAccess: 'Droits financiers',
    invoiceActions: 'Actions de facture',
    orderAttributes: 'Attributs de commande',
    findApiOrder: 'Trouver une commande API',
    optimus: 'Optimus',
    noAccessToApiOrder: "Pas d'accès à Trouver une commande API",
    noAccessToOptimus: "Pas d'accès à Optimus",
    optimusViewDescription:
      "L'utilisateur peut afficher les services des départements et des clients, mais ne peut pas apporter de modifications",
    optimusFullDescription: "L'utilisateur peut ajouter et modifier des services pour les départements et les clients",
    ordersApiSearchRestrictedDescription:
      "L'utilisateur peut rechercher des commandes des départements ou des clients auxquels il a accès",
    ordersApiSearchFullDescription: "L'utilisateur peut rechercher des commandes de tous les départements et clients",
    addRole: 'Ajouter un rôle',
    addedRole: 'Rôle ajouté',
    removeRole: 'Supprimer un rôle',
    importExport: 'Importer / Exporter',
    importExportExtendedDescription: "Inclut l'accès au rapport étendu des coursiers.",
    importExportExtendedSaaSDescription: "Inclut l'accès au rapport de fin de journée.",
    billingOrdersDescription: 'Peut créer et modifier les commandes de facturation',
    billingOrdersReadOnlyDescription: 'Accès en lecture seule aux commandes de facturation'
  },
  validationError: {
    provideEmail: 'Vous devez fournir un e-mail',
    provideValidEmail: 'Vous devez fournir un e-mail valide',
    youMustSelectCustomer: 'Vous devez sélectionner un client'
  },
  roles: {
    PLANNER_BILLING_ORDERS: 'Ordres de facturation',
    PLANNER_BILLING_ORDERS_READ: 'Ordres de facturation (lecture seule)',
    PLANNER_UNITS_REMOVE: "Retirer des unités d'un département",
    FINANCIAL_INVOICE_ACTIONS: 'Actions de facturation sur les envois'
  },
  manageReturns: {
    title: 'Gérer les retours',
    typesOfReturns: 'Types de retours',
    ordersOverAPeriod: 'Affichage des commandes du dernier mois.',
    ordersOverAPeriod_other: 'Affichage des commandes des {{count}} derniers mois.',
    pickedUpByCustomer: 'Retiré par le client',
    pickedUpByCustomerDescription: 'Retours à retirer par le client',
    transferToDifferentTerminal: 'Transfert vers un autre terminal',
    transferToDifferentTerminalDescription: 'Retours à envoyer vers un autre terminal',
    environmentalReturns: 'Retours environnementaux',
    environmentalReturnsDescription: 'Retours pour recyclage, collectés dans un conteneur',
    returnForDelivery: 'Retour pour livraison',
    returnForDeliveryDescription: 'Retours à acheminer et livrer',
    MANUAL_RETURNS: 'Retours manuels',
    manualReturnsDescription: "Commande dont la phase de retour n'est pas encore créée",
    returnToSenderTitle: "Souhaitez-vous retourner les envois à l'expéditeur",
    manuallyMarkAsHandled: 'Marquer manuellement comme traité',
    manuallyMarkAsHandledTooltip: "Lorsque l'envoi est marqué comme traité, il disparaît de la liste",
    ordersFoundCount: '{{count}} commande trouvée',
    ordersFoundCount_other: '{{count}} commandes trouvées',
    PICKED_UP_BY_CUSTOMER: 'Retiré par le client',
    TRANSFER_TO_DIFFERENT_TERMINAL: 'Transfert vers un autre terminal',
    ENVIRONMENTAL_RETURNS: 'Retours environnementaux',
    RETURN_FOR_DELIVERY: 'Retour pour livraison',
    ordersAlreadyHandled: 'Toutes les commandes sont traitées',
    ordersAlreadyHandledDescription: "Nous n'avons trouvé aucune commande non traitée.",
    manuallyMarkAsHandledModal: {
      title: 'Marquer manuellement comme traité',
      shipmentsCount: '{{count}} envoi',
      shipmentsCount_other: '{{count}} envois',
      description:
        'Lorsque les envois sont marqués comme traités, ils disparaîtront de la liste. Cette action est irréversible. Les envois peuvent être trouvés sur la page de recherche.',
      confirm: 'Marquer comme traité'
    },
    manuallyMarkAsHandledSuccess: '{{count}} envoi a été marqué comme traité',
    manuallyMarkAsHandledSuccess_other: '{{count}} envois ont été marqués comme traités',
    returnToSenderSuccess: "{{count}} envoi a été retourné à l'expéditeur",
    returnToSenderSuccess_other: "{{count}} envois ont été retournés à l'expéditeur",
    selectCustomer: 'Sélectionner le client',
    customer: 'Client',
    customer_other: 'Clients',
    allCustomers: 'Tous les clients',
    selectDestination: 'Sélectionner la destination',
    destination: 'Destination finale',
    destinationDIP: 'Destination DIP',
    returnShipmentColumns: 'Informations de retour',
    allDestinations: 'Toutes les destinations',
    noDate: 'Tous',
    zeroDays: '0 jours',
    oneTo6Days: '1–6 jours',
    moreThan7Days: '> 7 jours',
    moreThan15Days: '> 15 jours',
    moreThan30Days: '> 30 jours',
    customerDate: 'Personnalisé',
    daysOnTerminal: 'Jours en terminal',
    months: 'Mois',
    lastMonths: 'Dernier {{count}} mois',
    lastMonths_other: 'Derniers {{count}} mois',
    printList: 'Imprimer la liste',
    returnToSender: "Retourner à l'expéditeur",
    returnToSenderQueued: "Retour à l'expéditeur en file d'attente",
    returnToSenderConfirmation: "Voulez-vous retourner cet envoi à l'expéditeur ?",
    returnToSenderFailed: "Impossible de retourner l'envoi à l'expéditeur",
    returnToSenderDisabledTooltip:
      'Vous ne pouvez pas retourner les envois qui ont dévié, été livrés ou sont déjà signalés pour retour',
    senderDIP: 'DIP expéditeur',
    createReturnLabel: 'Créer une étiquette de retour'
  },
  parcelHubAdmin: {
    title: 'ParcelHub',
    startTitle: 'Rechercher un envoi',
    startDescription: "Saisissez un numéro d'envoi et appuyez sur rechercher.",
    noResultsTitle: 'Aucun message trouvé',
    loadFailedTitle: 'Impossible de récupérer les messages',
    loadFailedDescription: "Le consumer ParcelHub n'a pas répondu. Réessayez ou vérifiez que le service fonctionne.",
    payloadLoadFailed: 'Impossible de récupérer le payload de ce message.',
    shipment: 'Envoi',
    topic: 'Topic',
    partition: 'Partition',
    offset: 'Offset',
    operation: 'Opération',
    packageId: 'ID du colis',
    timestamp: 'Horodatage',
    payload: 'Payload',
    viewPayload: 'Voir le payload',
    consignmentEvents: "Événement d'envoi",
    consignmentItemEvents: 'Événement de colis',
    eventCode: "Code d'événement",
    event: 'Événement',
    receivedAt: 'Reçu le',
    queuedAt: 'Mis en file le',
    processed: 'Traité',
    processedAt: 'Traité le',
    processingLag: 'Délai de traitement',
    eventsNoResultsTitle: 'Aucun événement trouvé',
    eventsLoadFailedTitle: 'Impossible de récupérer les événements',
    eventsLoadFailedDescription: 'La récupération des événements a échoué. Réessayez.',
    eventPayloadLoadFailed: 'Impossible de récupérer le payload de cet événement.'
  },
  apolloAdmin: {
    title: 'Integrations',
    emptyTitle: 'Aucune demande affichée',
    emptyDescription: 'Choisissez la date et appuyer sur rechercher.',
    reqType: 'Type de demande',
    routeId: 'Identifiant de la tournée de livraison',
    routeName: 'Nom de la tournée de livraison'
  },
  preAdviceFollowup: {
    title: 'Gérer les préavis',
    toBeHandled: 'À traiter',
    failedOrders: 'Commandes échouées',
    failedOrdersDescription: "Le destinataire n'a reçu aucune notification",
    manualPreAdvice: 'Préavis manuel',
    manualPreAdviceDescription: "Commandes avec un déclencheur manuel sur la page d'administration",
    preAdviceLocked: 'Préavis verrouillé',
    preAdviceLockedDescription: "Commandes en attente d'action",
    missingRules: 'Règles manquantes',
    missingRulesDescription: "Les commandes manquent d'une règle de préavis.",
    inProgress: 'En cours',
    inProgressDescription: 'Commandes avec préavis en cours',
    notStarted: 'Non commencé',
    notStartedDescription: "Commandes avec une règle où le préavis n'a pas été lancé",
    ordersFoundCount: '{{count}} commande trouvée',
    ordersFoundCount_other: '{{count}} commandes trouvées',
    FAILED_ORDERS: 'Commandes échouées',
    MANUAL_PRE_ADVICE: 'Préavis manuel',
    PRE_ADVICE_LOCKED: 'Préavis verrouillé',
    MISSING_RULES: 'Règles manquantes',
    IN_PROGRESS: 'En cours',
    NOT_STARTED: 'Non commencé',
    ordersAlreadyHandled: 'Toutes les commandes sont traitées',
    ordersAlreadyHandledDescription: "Nous n'avons trouvé aucune commande non traitée.",
    updatePhoneNumber: 'Changer ou ajouter un numéro de téléphone',
    updateEmailAddress: 'Changer ou ajouter une adresse e-mail',
    removeShipmentFromPreAdvice: "Retirer l'envoi du préavis",
    bookDateAndTime: "Réserver la date et l'heure",
    manuallyPreAdvice: 'Préavis manuel',
    unlockPreAdvice: 'Déverrouiller le préavis',
    lockPreAdvice: 'Verrouiller le préavis',
    triggerPreAdvice: 'Déclencher le préavis',
    selectedCustomers: '{{count}} client',
    selectedCustomers_other: '{{count}} clients',
    allCustomers: 'Tous les clients',
    selectRowWithOrderId: "Sélectionner la ligne avec l'identifiant de commande {{id}}",
    updateRecipientPhoneNumber: 'Mettre à jour le numéro de téléphone',
    phoneNumberUpdated: "Le numéro de téléphone a été mis à jour pour l'identifiant d'envoi : {{shipmentId}}",
    phoneNumberUpdatedAndPreAdviceSent:
      "Numéro de téléphone mis à jour et préavis envoyé pour l'identifiant d'envoi : {{shipmentId}}",
    samePhoneNumberAlreadySet: "Le même numéro de téléphone est déjà défini pour l'envoi.",
    updateRecipientEmailAddress: "Mettre à jour l'adresse e-mail",
    emailAddressUpdated: "L'adresse e-mail a été mise à jour pour l'identifiant d'envoi : {{shipmentId}}",
    emailAddressUpdatedAndPreAdviceSent:
      "Adresse e-mail mise à jour et préavis envoyé pour l'identifiant d'envoi : {{shipmentId}}",
    emailAddressUpdatedBulk: "L'adresse e-mail a été mise à jour pour {{count}} envoi",
    emailAddressUpdatedBulk_other: "L'adresse e-mail a été mise à jour pour {{count}} envois",
    emailAddressUpdatedAndPreAdviceSentBulk: 'Adresse e-mail mise à jour et préavis envoyé pour {{count}} envoi',
    emailAddressUpdatedAndPreAdviceSentBulk_other: 'Adresse e-mail mise à jour et préavis envoyé pour {{count}} envois',
    sameEmailAddressAlreadySet: "La même adresse e-mail est déjà définie pour l'envoi.",
    manuallyPreAdvicedSuccess: 'Préavis déclenché avec succès pour {{count}} envois',
    nrOfSelected: '{{count}} sélectionné',
    sendPreAdvice: 'Envoyer le préavis',
    unlockPreAdviceSuccess: 'Préavis déverrouillé avec succès pour {{count}} envois',
    unlockPreAdviceAndPreAdviceSent: 'Préavis déverrouillé et envoyé avec succès pour {{count}} envois',
    lockPreAdviceSuccess: 'Préavis verrouillé avec succès pour {{count}} envois',
    saveAndSendPreAdvice: 'Enregistrer et envoyer le préavis',
    finishPreAdviceFollowupSuccess: 'Envois retirés avec succès du préavis : {{count}}'
  },
  coordinates: {
    setCoordinates: 'Définir les coordonnées',
    title: 'Définir les coordonnées des adresses',
    setCoordinatesCount: 'Définir les coordonnées ({{count}})',
    zipCodeRange: 'Intervalle de codes postaux',
    goodJob: 'Bravo! Bien joué!',
    noUnresolvedShipments: 'Aucun envoi non résolu trouvé pour ce département ou ce groupe de départements',
    coordinateSaved: 'Coordonnées enregistrées pour {{address}}',
    checkMapProvider: 'Vérifier sur {{name}}',
    noDeliveryDate: 'Pas de date de livraison',
    created: 'Créé le',
    withDeliveryDate: 'Avec date de livraison ({{count}})',
    withoutDeliveryDate: 'Sans date de livraison ({{count}})',
    applyFilter: 'Appliquer le filtre',
    thereAreUnsetCoordinates: 'Vous avez {{count}} coordonnée à définir.',
    thereAreUnsetCoordinates_other: 'Vous avez {{count}} coordonnées à définir.',
    noCoordinateFound:
      "Nous n'avons pas pu trouver les coordonnées pour cette adresse. Recherchez l'adresse ou saisissez les coordonnées (par ex. 59.289976807684084, 18.010318840107406) dans le champ de recherche."
  },
  relatedOrders: {
    NONE: 'Aucune commande liée',
    MULTILEG: 'Multileg',
    PICKUP: 'Ramassage',
    TRANSPORT: 'Transport',
    DELIVERY: 'Livraison',
    CUSTOMER: 'Commande client'
  },
  vendors: {
    title: 'Fournisseurs',
    viewDetails: 'Voir les détails',
    searchLabel: 'Rechercher le nom du fournisseur, l’ID du fournisseur ou l’ID de l’unité',
    searchVendorPlaceholder: 'Rechercher le nom du fournisseur ou l’ID du fournisseur',
    searchUnitPlaceholder: 'Rechercher l’ID de l’unité',
    vendorOption: 'Nom/ID du fournisseur',
    unitOption: 'ID de l’unité',
    notFound: 'Aucun fournisseur trouvé avec cette phrase de recherche',
    initialSearch: 'Recherchez pour trouver des fournisseurs',
    informationAboutTheVendor: 'Informations sur le fournisseur',
    connectUnit: 'Connecter une unité',
    connectUnits: 'Connecter des unités',
    connectedUnits: 'Unité connectée ({{count}})',
    connectedUnits_other: 'Unités connectées ({{count}})',
    unitsConnected: '{{count}} Unité connectée',
    unitsConnected_other: '{{count}} Unités connectées',
    unitsConnected_zero: 'Aucune unités connectées',
    paymentTerms: 'Conditions de paiement',
    connected: 'Connecté',
    searchForUnitDescription:
      'Sélectionner une unité signifie que le département auquel l’unité est ajoutée assumera le coût.',
    searchForUnitTitle: '{{vendorSite}} pour {{operatingUnitName}}',
    successToast: 'Unités connectées mises à jour pour le fournisseur {{name}}',
    showConnectedUnits: 'Afficher les unités connectées',
    editConnectedUnits: 'Modifier les unités connectées',
    searchForUnit: 'Rechercher une unité',
    searchPage: 'Page de recherche',
    currencyCode: 'Code de devise',
    connectedToCompany: 'Connecté à cette entreprise',
    noConnection: 'Aucune connexion',
    connectedTo: 'Connecté à',
    nothingHereYet: 'Rien ici pour le moment',
    emptyStateSelectedVendor: 'Sélectionnez un code de site pour lier des unités ou voir les connexions existantes.',
    selfBilling: "L'autofacturation",
    setUnitSettingsTitle: 'Mettre à jour les paramètres de l’unité pour {{name}}',
    setUnitSettingsSelfBillingInternalTrade: "L'autofacturation et la transaction interne sont actifs.",
    setUnitSettingsNone: "L'autofacturation et la transaction interne ne sont pas actifs.",
    setUnitSettingsInternalTrade: "L'autofacturation n’est pas active, tandis que la transaction interne est active.",
    state: {
      COMPLETE: 'Complet',
      INCOMPLETE: 'Incomplet',
      ALL: 'Tous',
      label: "Sélectionnez l'état du fournisseur"
    }
  },
  shdAdmin: {
    successfullyDeleted: 'La matrice horaire a été supprimée avec succès',
    successfullyUploaded: 'La matrice horaire a été téléchargée avec succès',
    timeWindowForHomeDelivery: 'Plage horaire pour la livraison à domicile',
    filterByCustomerData: 'Rechercher par nom de client, sous-client ou numéro de client',
    uploadTimeMatrixFile: 'Télécharger le fichier de la matrice horaire',
    downloadExcelTemplate: 'Télécharger le modèle Excel',
    clickHereOrDragAndDrop: 'Cliquez ici ou faites glisser et déposez',
    allowedFormats: 'Les formats autorisés sont XLS et XLSX',
    existingCustomers: 'Clients existants avec SHD',
    customerPriceTooltip: 'Si le prix du client final doit être affiché, activez le commutateur',
    deleteModalTitle: 'Supprimer les fenêtres horaires',
    deleteModalDescription:
      'Si vous supprimez cette fenêtre horaire, toutes les fenêtres horaires SHD pour ce client seront supprimées. Vous ne pourrez pas récupérer cette action.',
    exportToExcel: 'Exporter vers Excel',
    toggleLabel: 'Activer/désactiver le prix du client',
    customerNumber: 'Numéro de client',
    subCustomer: 'Sous-client',
    customerName: 'Client',
    amountOfPostalCodes: 'Nombre de codes postaux',
    lastUpdatedAt: 'Dernière mise à jour',
    showCustomerPrice: 'Afficher le prix du client',
    uploadMaximumFileSizeLimit: 'La taille du fichier ne peut pas être supérieure à {{size}} Ko'
  },
  matrix: {
    title: 'Matrix',
    id: 'ID',
    pageTitle: 'Admin Matrix',
    name: 'Nom',
    filename: 'Nom du fichier',
    uploaded: 'Téléchargé',
    uploadedBy: 'Téléchargé par',
    downloadTemplate: 'Télécharger le modèle',
    byUser: 'Par utilisateur',
    country: 'Pays',
    ROUTING: 'Routage',
    LINEHAUL: 'Transport principal',
    HUB: 'Hub',
    DELIVERY: 'Livraison',
    VAS: 'VAS',
    terminals: 'Terminaux',
    searchLabel: 'Rechercher par nom ou numéro de client',
    bookingLimitsSearchLabel: 'Rechercher par nom de terminal',
    'baggage-delivery': 'Bagages',
    baggage: {
      title: 'Matrices de bagages',
      name: 'Bagages {{country}}',
      legend:
        'Si vous souhaitez mettre à jour des matrices de bagages existantes, faites-le en sélectionnant « télécharger les données de la matrice ». ',
      uploadTitle: 'pour {{country}}',
      custom: 'Matrice de code DS personnalisé',
      uploadCustomTitle: 'pour des codes DS personnalisés',
      status: 'Statut',
      uploadFail:
        "{{label}} n'a pas été accepté en raison d'informations incorrectes. Modifiez les informations et téléchargez à nouveau la matrice.",
      statuses: { accepted: 'Accepté', pending: 'En attente', rejected: 'Rejeté' }
    },
    terminalDetails: {
      details: 'Détails',
      alystraDepartmentId: 'ID de département Alystra',
      matrices: 'Matrices',
      type: 'Type',
      noMatrices: "Ce terminal n'est référencé dans aucune matrice",
      aliases: 'Alias',
      departmentId: 'ID du département',
      createdAt: 'Créé',
      noAliases: "Ce terminal n'a pas d'alias"
    },
    bookingLimits: {
      title: 'Limites de réservation',
      header: '{{name}} - Modifier les limites de réservation',
      rules: '#Règles',
      total: 'Total',
      rank: 'Priorité',
      customer: 'Client',
      customerNo: 'Numéro de client',
      serviceCode: 'Service',
      timeWindow: 'Plage horaire',
      selectTimeWindow: 'Sélectionner la plage horaire',
      noTimeWindow: 'Pas de plage horaire',
      noCustomer: 'Pas de client',
      bookingLimit: 'Limite de réservation',
      removeLimit: 'Supprimer la limite',
      addMoreLimits: 'Ajouter plus de limites',
      delete: 'Supprimer les limites de réservation',
      deleteModalDescription: 'Vous ne pourrez pas annuler cette action',
      deleted: 'Les limites de réservation ont été supprimées avec succès',
      updated: 'Les limites de réservation ont été modifiées avec succès'
    },
    master: 'Principal',
    select: 'Sélectionner la matrice {{matrix}}...',
    overflow: '+{{overflow}} de plus..',
    vasCodes: 'Codes VAS',
    connectedCustomers: {
      title: 'Clients connectés',
      button: 'Voir {{connectedCustomers}} clients connectés',
      search: 'Rechercher par nom ou numéro de client',
      subcustomer: 'Sous-client'
    },
    upload: {
      success: 'Les données de la matrice ont été téléchargées avec succès',
      question: 'Télécharger les données de la matrice',
      text: 'Télécharger Excel',
      description: 'Téléchargez la feuille de calcul Excel contenant les données pour cette matrice',
      error: 'Erreur lors du téléchargement des données sur {{name}}. {{error}}',
      invalidformat: 'Format de fichier non valide'
    },
    delete: {
      question: 'Supprimer la matrice {{name}}',
      description: 'Cela ne peut pas être annulé',
      success: 'La matrice {{name}} a été supprimée avec succès',
      error: 'Erreur lors de la suppression de {{name}}. {{error}}'
    },
    new: {
      question: 'Créer une nouvelle matrice',
      description: 'Crée une nouvelle matrice',
      success: 'La matrice {{name}} a été créée avec succès',
      error: 'Erreur lors de la création de la matrice. {{error}}'
    },
    edit: {
      question: 'Modifier la matrice {{name}}',
      error: 'Erreur lors de la mise à jour de {{name}}. {{error}}',
      success: 'La matrice {{name}} a été enregistrée avec succès'
    },
    type: 'Sélectionner le type',
    day: {
      monday: 'Lun',
      tuesday: 'Mar',
      wednesday: 'Mer',
      thursday: 'Jeu',
      friday: 'Ven',
      saturday: 'Sam',
      sunday: 'Dim'
    },
    leadTime: 'Délai de livraison',
    terminal: 'Terminal',
    terminalFrom: 'Terminal de départ',
    terminalTo: "Terminal d'arrivée",
    postalCode: 'Code postal',
    postalCodeFrom: 'Code postal de départ',
    postalCodeTo: 'Code postal de destination',
    offsetDays: 'Jours de décalage',
    cutoffTime: 'Heure limite',
    city: 'Ville',
    error: {
      duplicateName: 'Nom en double',
      duplicateServiceCode:
        'Les limites de réservation sont déjà définies pour cette combinaison de client et de code service',
      duplicateTimeWindow: 'Créneau horaire en double'
    }
  },
  serviceMapping: {
    title: 'Services',
    serviceName: 'Nom du service',
    pickupTime: 'Heure de collecte',
    pickupDuration: "Durée d'enlèvement",
    pickupPreparation: "Préparation de l'enlèvement",
    deliveryTime: 'Heure de livraison',
    deliveryDuration: 'Durée de livraison',
    deliveryPreparation: 'Préparation de la livraison',
    internalName: 'Nom interne',
    internalDescription: 'Description interne',
    externalName: 'Nom externe',
    externalDescription: 'Description externe',
    allowFlexDelivery: 'Autoriser la livraison flexible',
    timeWindow: 'Plage horaire',
    serviceMappingType: 'Type',
    serviceLevel: 'Niveau de service',
    service: 'Service',
    vas: 'VAS',
    stopsBeforeShowEta: 'Arrêts ETA',
    minutesUntilDelivery: 'ETA en minutes',
    sendAutomaticEtaSmsHeading: 'SMS ETA',
    createNew: 'Créer un nouveau',
    serviceAndVasCodes: 'Services et codes VAS',
    successfullyAdded: 'Le mappage de service a été ajouté avec succès à la liste',
    successfullyUpdated: 'Le mappage de service a été mis à jour avec succès',
    successfullyDeleted: 'Le mappage de service a été supprimé avec succès',
    editService: 'Modifier le service',
    createNewService: 'Créer un nouveau service',
    settingsHeading: 'Paramètres du service ou VAS',
    selectLevel: 'Sélectionner le niveau',
    standardLevel: 'Niveau standard',
    customerLevel: 'Niveau client',
    customerSpecific: 'Spécifique au client',
    selectServiceType: 'Sélectionner le type de service',
    vasToolTip: "Service à valeur ajoutée, par exemple, contrôle d'identité",
    customerNumber: 'Numéro client',
    pickupTimeInSeconds: "Durée de service pour l'enlèvement (secondes)",
    pickupPreparationTime: "Durée de préparation pour l'enlèvement (secondes)",
    deliveryTimeInSeconds: 'Durée de service pour la livraison (secondes)',
    deliveryPreparationTime: 'Durée de préparation pour la livraison (secondes)',
    pickupDurationSecondsApartment: 'Temps de collecte pour les appartements (en secondes)',
    deliveryDurationSecondsApartment: 'Temps de livraison pour les appartements (en secondes)',
    deliveryDurationApartmentHeading: 'Durée de livraison pour les appartements (actuellement uniquement pour H2)',
    timeWindowInMinutes: 'Plage horaire (en minutes)',
    stopsLeftHeading: "Quand souhaitez-vous que l'ETA exact soit affiché au destinataire ?",
    stopsLeftDescription: 'Si ce champ est laissé vide, la plage horaire sera affichée',
    amountOfStops: "Nombre d'arrêts",
    flexibleDelivery: 'Livraison flexible',
    flexibleDeliveryDescription: "Permet au destinataire de choisir de laisser le colis à l'extérieur de la porte",
    flexibleDeliveryCheckboxText: 'Oui, le destinataire doit être autorisé',
    flexOptions: 'Options Flex',
    flexOptionsDescription:
      "Nous proposons aux clients deux options de livraison Flex différentes. La première option, Flex Étendu, permet au livreur de déposer les marchandises à divers endroits convenus à l'adresse de livraison. La deuxième option, Flex, est une alternative plus simple où les marchandises sont placées uniquement à la limite de la propriété. Flex Étendu est l'option par défaut, mais les clients peuvent choisir de passer à l'option Flex plus simple si souhaité.",
    unattendedFlex: 'Flex (Sans surveillance)',
    extendedFlex: 'Flex Étendu (Flex)',
    linkTextToService: 'Lier le texte au service',
    linkTextToServiceDescription: "Si aucun texte n'est sélectionné, un texte par défaut sera utilisé",
    defaultText: 'Texte par défaut',
    listOfServicesAndVases: 'Liste des services et des codes VAS',
    searchService: 'Rechercher un service, VAS ou numéro client',
    customizedText: 'Texte personnalisé',
    deleteModalTitle: 'Supprimer le mappage de service',
    deleteModalDescription: 'Vous ne pourrez pas récupérer cette action',
    infoModal: {
      title: 'Ce qui est affiché où dans Glow',
      subHeading1: 'Planificateurs et conducteurs',
      description1: 'Nom interne : Le nom du service, par exemple "Livraison à domicile"',
      description2:
        'Description interne : Informations détaillées sur le service, par exemple "Cela doit être livré à la pièce choisie par le destinataire."',
      subHeading2: 'Clients et destinataires',
      description3: 'Nom externe : Le nom du service, par exemple "Livraison à domicile"',
      description4:
        'Description externe : Informations détaillées sur le service, par exemple "Vos produits seront livrés dans la pièce de votre choix".'
    },
    routeOptimizing: "Optimisation de l'itinéraire",
    routeOptimizingDescription:
      'Les informations que vous saisissez ici remplaceront les durées de service et de livraison par défaut et auront un impact sur l’optimisation des tournées. La durée de préparation peut être utilisée dans les cas où plusieurs colis sont livrés à un même destinataire. Dans ce cas, le premier colis aura une durée totale correspondant à la somme de la durée de préparation et de la durée de service de livraison. Les colis supplémentaires destinés au même destinataire auront uniquement la durée de service de livraison. <br><br>La configuration par défaut pour les enlèvements est de 15 secondes de temps de préparation et 1 seconde par expédition.<br>La configuration par défaut pour les livraisons est de 180 secondes de temps de préparation et 10 secondes par expédition.<br><strong>Veuillez noter que les modifications peuvent mettre jusqu’à 10 minutes avant d’être visibles dans le système.</strong>',
    settingsRecipientTrackingPage: 'Page de suivi du destinataire',
    etaComponentHeading: "Afficher l'ETA exact sur la page du destinataire",
    etaComponentDescription:
      "Activer cette option vous permettra de décider quand afficher l'ETA exact au destinataire au lieu de la plage horaire de l'ETA.",
    displayExactEta: "Oui, afficher l'ETA exact",
    stopsLeftSelected: "Nombre d'arrêts restants avant la livraison",
    minutesLeftSelected: 'Nombre de minutes restantes avant la livraison',
    numberOfMinutes: 'Nombre de minutes',
    numberOfStops: "Nombre d'arrêts",
    sendAutomaticEtaSmsTitle: 'Envoyer un SMS automatique au destinataire',
    sendAutomaticEtaSmsDescription:
      "Activer cette option désactivera également la possibilité pour le conducteur d'envoyer un SMS depuis l'application du conducteur.",
    sendAutomaticEtaSms: 'Envoyer un SMS automatiquement',
    missingNumberOfStops:
      'Veuillez entrer un nombre valide d\'arrêts lorsque "Envoyer un SMS automatique" est sélectionné',
    missingNumberOfMinutes:
      'Veuillez entrer un nombre valide de minutes lorsque "Envoyer un SMS automatique" est sélectionné',
    minutesNotInRange: 'Veuillez définir le nombre de minutes entre {{from}} et {{to}}',
    serviceDeliveryType: 'Type de livraison de service',
    noServiceDeliveryTypeSelected: 'Non défini',
    serviceDeliveryTypes: { Delivery: 'Livraison', Return: 'Retour', PickupPoint: 'Point de collecte' },
    Delivery: 'Livraison',
    Pickup: 'Enlèvement',
    Return: 'Retour',
    PickupPoint: 'Point de collecte',
    courierApp: 'Application du coursier',
    allowCourierDescription: "Permet au coursier d'accepter ou de refuser les envois avec ce code de service",
    allowCourierCheckbox: 'Oui, le coursier doit être autorisé',
    none: 'Aucune'
  },
  shipmentDetailsBilling: {
    finanicalStakeholder: 'Parties prenantes financières',
    item: 'Article',
    customerTotal: 'Total client',
    unitTotal: 'Total unitaire',
    orderTotal: 'Total de la commande',
    disconnectToOrginalOrder: "Déconnecter du numéro d'expédition d'origine"
  },
  upsalesRulesAdmin: {
    title: 'Règles de vente incitative',
    titleSingular: 'Règle de vente additionnelle',
    name: 'Nom',
    type: 'Type',
    searchPlaceholder: 'Rechercher des règles de ventes incitatives',
    settings: 'Paramètres',
    successfullyAdded: '{{name}} a été ajoutée avec succès à la liste',
    successfullyUpdated: '{{name}} a été mise à jour avec succès',
    createNewRule: 'Créer une nouvelle règle de ventes additionnelles',
    edit: 'Modifier',
    serviceUpgrade: 'Mise à niveau du service',
    shorterTimeWindow: 'Fenêtre de temps plus courte',
    ruleName: 'Nom de la règle de ventes additionnelles',
    serviceUpgradeDescription1: 'Le service sera mis à niveau de 3123 à 2870.',
    serviceUpgradeDescription2:
      'VAS 1381 sera automatiquement ajouté pour garantir que le chauffeur reçoive le bon paiement.',
    zipCodeRangeTitle: 'Code postal',
    zipCodeRangeDescription:
      "Sélectionnez les codes postaux que vous souhaitez inclure ou exclure dans la règle. Si vous devez retirer un code postal spécifique ou une plage d'une zone incluse, utilisez l'option d'exclusion pour affiner votre sélection.",
    fromZipCode: 'Code postal de départ',
    toZipCode: 'Code postal de destination',
    addRange: 'Ajouter une plage de codes postaux',
    addZipCode: 'Ajouter un code postal',
    noZipCodeRangesAdded: 'Vous devez fournir une plage de codes postaux',
    zipCodeRangeError: '"Code postal de départ" ne doit pas être supérieur à "Code postal de destination"',
    deleteModalTitle: 'Supprimer la règle de ventes additionnelles',
    deleteModalDescription: 'Vous ne pourrez pas annuler cette action',
    successfullyDeleted: 'La règle de ventes additionnelles a été supprimée avec succès',
    shorterTimeWindowDescription1: 'Une plage horaire plus courte est disponible pour 3332',
    windowOnlyInEvening: 'La fenêtre de temps plus courte doit être disponible uniquement en soirée',
    timeWindowOffer: 'Quelle fenêtre de temps doit être proposée au destinataire ?',
    oneHour: '1 heure',
    twoHours: '2 heures',
    threeHours: '3 heures',
    mustSelectTimeWindow: 'Vous devez indiquer la fenêtre de temps offerte au destinataire',
    include: 'Inclure',
    exclude: 'Exclure',
    zipCodeRangeType: 'Type',
    exactZipCode: 'Exact',
    zipCodeRange: 'Plage',
    zipCode: 'Code postal',
    mustSelectCountry: "Vous devez d'abord sélectionner un pays",
    includedZipCodes: 'Codes postaux inclus ({{count}})',
    excludedZipCodes: 'Codes postaux exclus ({{count}})',
    noZipCodesAddedYet: 'Aucun code postal ajouté pour le moment',
    noMatchOnZipCodeSearch: 'Aucun code postal trouvé. Essayez de filtrer avec une autre plage de codes postaux.',
    zipCodesFound: '{{count}} code postal trouvé',
    zipCodesFound_other: '{{count}} codes postaux trouvés',
    filterOnDepartments: 'Filtrer par départements',
    UPSALES_RULE_COLLISION_OCCURRED:
      'La règle existe déjà! Veuillez supprimer soit les départements suivants: {{departments}}, soit les clients suivants: {{customers}}',
    status: 'Statut',
    active: 'Actif',
    paused: 'En pause',
    pauseRule: 'Mettre la règle en pause',
    activateRule: 'Activer la règle',
    activateRuleModalDescription:
      "Vous êtes sur le point d'activer la règle. Cela signifie que la vente additionnelle sera disponible pour les destinataires. Souhaitez-vous continuer?",
    pauseRuleModalDescription:
      'Vous êtes sur le point de mettre la règle en pause. Cela signifie que la vente additionnelle ne sera pas disponible pour les destinataires. Souhaitez-vous continuer?',
    successfullyActivated: 'La règle de vente additionnelle a été activée avec succès',
    successfullyPaused: 'La règle de vente additionnelle a été mise en pause avec succès'
  },
  billingOrder: {
    create: 'Créer une commande de facturation',
    copyTo: 'Copier vers une commande de facturation',
    copyToBillingOrder: 'Copier vers une commande de facturation',
    keepConnection: 'Garder la connexion',
    disconnect: 'Déconnecter',
    creditMode: 'Crédit',
    debitMode: 'Débit',
    createCredit: 'Créer un avoir',
    credit: 'Avoir',
    done: "La commande de facturation a été créée avec succès. ID d'expédition: {{shipmentId}}",
    invalidOrderForEdit:
      "Cette commande ne peut pas être modifiée. Seules les commandes de facturation ou d'avoir non facturées peuvent être modifiées.",
    cannotBeCredited: 'Vous ne pouvez pas créditer une commande facturée dans {{systemId}}.',
    invalidOrderForCopy: "Impossible de copier l'avoir.",
    standaloneInvoice: 'Facture distincte',
    standaloneInvoiceLabel:
      "Je souhaite que cette commande de facture soit traitée individuellement et ne soit pas regroupée avec d'autres commandes pour la facturation.",
    noUnitNotSelfBilled: 'Les commandes sans unité ne seront pas compensées.',
    manualInvoiceInformation: {
      label: 'Gestion manuelle des factures',
      descriptionText:
        'Si ce champ est renseigné avec des instructions de facturation, la commande ne sera pas automatiquement facturée'
    },
    expensive: 'Le prix saisi semble inhabituellement élevé',
    creditInvoiceText: 'Avoir pour l’expédition {{shipmentId}}',
    creditInvoiceLegText: {
      CUSTOMER_ORDER: 'Avoir client pour l’expédition {{shipmentId}}',
      PICKUP_LEG: 'Avoir pour l’enlèvement de l’expédition {{shipmentId}}',
      DELIVERY_LEG: 'Avoir pour la livraison de l’expédition {{shipmentId}}'
    },
    legSelectionLabel: 'Sélectionner l’étape du transport',
    legSelectionError: 'Veuillez sélectionner l’étape du transport à créditer',
    legSelection: {
      NONE: 'Aucune',
      CUSTOMER_ORDER: 'Commande client',
      PICKUP_LEG: 'Enlèvement',
      DELIVERY_LEG: 'Livraison'
    },
    wrongPageWarning: 'Les commandes de facturation ne sont pas accessibles depuis cette page',
    wrongPageLink: 'Aller à la page des détails de la commande de facturation',
    type: {
      Invoice: 'Commande de facture',
      Invoice_other: 'Commandes de facture',
      Credit: 'Avoir',
      Credit_other: 'Avoirs',
      InternalTrade: 'Commande de commerce interne',
      InternalTrade_other: 'Commandes de commerce interne'
    }
  },
  welcomeToGlowWithName: 'Bienvenue sur Glow, {{name}}!',
  welcomeToGlowDescription: 'Utilisez la navigation à gauche pour commencer votre travail !',
  glowGlobeImage: 'Image du globe Glow',
  latestUpdatesHere: 'Voici les dernières mises à jour',
  formValidation: {
    mustProvideName: 'Vous devez fournir un nom',
    mustProvideDescription: 'Vous devez fournir une description',
    mustProvideServiceCode: 'Vous devez fournir un code de service',
    mustProvideCalendarDays: 'Vous devez fournir des jours de calendrier',
    mustProvideCutOffTime: 'Vous devez fournir une heure limite',
    mustProvideCutOffMinutes: 'Vous devez fournir des minutes de coupure',
    mustProvideDeliveryAttempts: 'Vous devez fournir des tentatives de livraison',
    mustProvideCustomer: 'Vous devez fournir un client',
    mustProvideQuantity: 'Vous devez fournir une quantité',
    mustProvideArticle: 'Vous devez fournir un article',
    mustProvideDate: 'Vous devez fournir une date',
    mustProvideTime: 'Vous devez fournir une heure',
    mustProvideDuration: 'Vous devez fournir une durée',
    mustProvideCustomerOrUnitAmount: 'Vous devez fournir un client ou un montant unitaire',
    allowedRangeIs: 'Plage autorisée : {{min}} - {{max}}'
  },
  units: {
    title: 'Unités',
    new: 'Créer une nouvelle unité',
    connectFromOtherDepartments: "Connecter depuis d'autres services",
    connect: {
      title: 'Connecter des unités au service actuel',
      description: 'Vous ne pouvez rechercher des unités que dans les services auxquels vous avez accès.',
      selected: 'Unités sélectionnées',
      noneSelected: 'Aucune unité',
      submit: 'Connecter'
    },
    assigned: "L'unité (les unités) a (ont) été connectée(s) avec succès."
  },
  productionTimeWindow: {
    addNew: 'Ajouter une nouvelle fenêtre temporelle de production',
    search: 'Rechercher des fenêtres temporelles de production',
    description:
      'Ici, vous pouvez définir une fenêtre temporelle de production pour les commandes ayant un identifiant de destinataire. Vous pouvez rechercher par identifiant de destinataire ou par plage de codes postaux - la recherche par plage de codes postaux nécessite également de sélectionner un pays. Pour ajouter une fenêtre temporelle de production, cliquez sur « Ajouter nouveau » ou recherchez une fenêtre existante pour la modifier.',
    addNewDescription:
      'Ajoutez une fenêtre temporelle indiquant quand nous pouvons livrer des colis pour cet identifiant de destinataire. Si une fenêtre temporelle de production est ajoutée, cette information sera utilisée lors du routage à la place de la fenêtre temporelle de service.',
    recipientId: 'Identifiant du destinataire',
    searchForRecipientId: 'Rechercher un identifiant de destinataire',
    recipientName: 'Nom du destinataire',
    address: 'Adresse',
    postalCode: 'Code postal',
    country: 'Pays',
    selectCountry: 'Sélectionner un pays',
    addedSuccess: 'La fenêtre temporelle de production pour {{recipientId}} a été ajoutée avec succès.',
    recipientIdValidation: 'Vous devez fournir ID du destinataire',
    timeWindowValidation: 'Vous devez fournir une plage horaire',
    invalidRecipientId: 'Identifiant de destinataire invalide',
    postalCodeRangeRequiredTogether: 'Les codes postaux de début et de fin doivent tous deux être renseignés',
    postalCodeRangeRequiresCountry: 'Sélectionnez un pays pour rechercher par plage de codes postaux',
    createdAt: 'Créé le',
    from: 'De',
    to: 'À',
    editSuccess: 'La fenêtre temporelle de production pour {{recipientId}} a été modifiée avec succès.',
    delete: 'Supprimer la fenêtre temporelle de production pour {{recipientId}} ?',
    deleteDescription:
      'La suppression de la fenêtre temporelle de production signifie que la fenêtre temporelle de service sera utilisée lors du routage pour cet identifiant de destinataire. Souhaitez-vous continuer ?',
    deleteSuccess: 'La fenêtre temporelle de production pour {{recipientId}} a été supprimée avec succès.',
    noResults: 'Aucune fenêtre temporelle de production trouvée',
    noResultsDescription:
      'Essayez de rechercher avec un autre identifiant de destinataire, ou par plage de codes postaux. Vous pouvez aussi créer une nouvelle fenêtre temporelle de production en appuyant sur le bouton dans le coin supérieur droit.',
    noResultsPostalCodeDescription:
      'Aucune fenêtre temporelle de production ne correspond à cette plage de codes postaux. Essayez plutôt de rechercher par identifiant de destinataire, sans plage de codes postaux.',
    fromTimeAfterToTime: "L'heure de début doit être antérieure à l'heure de fin"
  },
  loadCarrierModal: {
    title: 'Groupe de supports de charge: {{loadCarrierId}}',
    description: 'Commandes dans le groupe'
  },
  routesOverview: {
    palletRuleOverridden: 'Règle des palettes ignorée',
    routeNotFoundTitle: 'Itinéraire introuvable',
    routeNotFoundDescription: 'Il a peut-être été supprimé.',
    shipmentStatus: {
      CREATED: 'Créée',
      ASSIGNED: 'Assigned',
      UNASSIGNED: 'Non affectée',
      COLLECTED: 'Collected',
      DELIVERED: 'Delivered',
      DEVIATED: 'Echec',
      COMMENT: 'Commentaires',
      RESOLVED: 'Résolue',
      UNRESOLVED: 'Non résolue',
      OFFERED: 'Offerte',
      REJECTED: 'Refusée',
      ACCEPTED: 'Acceptée',
      RETURNED: 'Retournée',
      DELETED: 'Supprimée',
      UNCONFIRMED: 'Non confirmé',
      REFUSED: 'Refusé'
    },
    offeredAtTime: 'Commande offerte à {{time}}',
    plannedRoute: 'Trajet planifié',
    routes: 'Trajets',
    routesCount: '{{filtered}} sur {{total}} trajets',
    searchRouteOrDriver: 'Rechercher le nom du trajet ou du conducteur',
    manuallyAdjustRoute: 'Ajuster le trajet manuellement',
    changeRoute: 'Changer de trajet',
    plannedRouteTime: 'Heure planifiée du trajet',
    notOptimized: {
      title: "Le trajet n'est pas optimisé",
      optimizationFailed:
        "L'optimisation du trajet a échoué : le trajet utilise une version de secours non optimisée. ETA et ETD ne sont pas disponibles.",
      manuallyPlanned: 'Le trajet a été planifié manuellement sans optimisation : ETA et ETD ne sont pas disponibles.'
    },
    statusOfRoute: 'Statut du trajet',
    incorrectETA: 'La page de suivi destinataire affiche des ETA incorrectes',
    adjustedFinishTime: 'Heure ajustée de la dernière livraison : {{time}}',
    driverIsDelayed: 'Le conducteur a {{delayed}} min de retard {{suffix}}.',
    deviations: '{{count}} déviation',
    deviations_other: '{{count}} déviations',
    successfullyDeleted: '{{name}} supprimé avec succès',
    successfullyReversedDeliveryOrder: 'Ordre de livraison inversé avec succès',
    colorPicker: 'Sélecteur de couleur',
    deleteAllRoutesConfirmDialogText: 'Êtes‑vous sûr de vouloir supprimer tous les créneaux ?',
    stops: 'Arrêts',
    stop: 'Arrêt',
    waitingTime: 'Temps d’attente',
    totalWaitingTime: 'Temps d’attente total',
    stopsAfterPlannedEndTime: '{{count}} livraison après l’heure prévue du trajet ({{time}}).',
    stopsAfterPlannedEndTime_other: '{{count}} livraisons après l’heure prévue du trajet ({{time}}).',
    unassignShipmentFromRoute: 'Désassigner l’envoi du trajet',
    unassign: 'Désassigner',
    priceInformation: 'Informations tarifaires',
    billingOrderShipment: 'Ordre de facturation',
    trips: 'Trajets',
    routeSettings: 'Paramètres de trajet',
    driverPhoneNumber: 'Numéro de téléphone du conducteur',
    selectVehicle: 'Sélectionner un véhicule',
    nameOfRoute: 'Nom du trajet',
    setStartTime: 'Définir l’heure de début',
    setEndDate: 'Date de fin',
    setEndTime: 'Définir l’heure de fin',
    endDateValidationError: 'La date de fin doit être la date de la tournée ou le jour suivant',
    endTimeValidationError: 'L’heure de fin doit être après l’heure de début',
    addMapArea: 'Ajouter une zone sur la carte',
    editMapArea: 'Modifier la zone sur la carte',
    areaWasUpdated: 'Zone sur {{name}} modifiée avec succès',
    areaWasCreated: 'Zone ajoutée à {{name}} avec succès',
    areaWasDeleted: 'Zone supprimée sur {{name}} avec succès',
    addAreaRoute: 'Ajouter une zone au trajet',
    updateAreaRoute: 'Mettre à jour la zone du trajet',
    deleteMapArea: 'Supprimer la zone sur la carte',
    templates: 'Modèles',
    loadTemplate: 'Charger le modèle',
    deleteTemplate: 'Supprimer le modèle',
    saveAsTemplate: 'Enregistrer comme modèle',
    saveTemplate: 'Enregistrer le modèle',
    templateWasCreated: '{{name}} a été créé avec succès',
    templateWasLoaded: '{{name}} a été chargé avec succès',
    templateWasDeleted: '{{name}} a été supprimé avec succès',
    loadTemplateSubHeading: 'Sélectionnez le modèle que vous voulez ajouter.',
    createANew: 'Créer un nouveau',
    orUpdateExisting: 'ou mettre à jour l’existant',
    saveTemplateRulesNote:
      'Seuls les codes postaux associés à une règle de tournée sont repris dans le modèle. Les codes postaux autonomes ne sont pas enregistrés.',
    saveTemplateDepartmentGroupNote:
      'Cette vue couvre plusieurs départements. Les règles de tournée d’autres départements ne seront pas reprises dans ce modèle.',
    deleteTemplateSubHeading: 'Sélectionnez le modèle que vous voulez supprimer.',
    defaultTemplate: 'Modèle par défaut',
    defaultTemplateSubHeading:
      'Sélectionnez le modèle que vous souhaitez utiliser par défaut. Ce modèle peut ensuite être utilisé pour la création automatique d’itinéraires, qui est activée dans la section Départements sous Administration.',
    setDefaultTemplates: 'Définir le modèle par défaut',
    selectDefaultTemplate: 'Sélectionner le modèle par défaut pour {{department}}',
    defaultTemplates: 'Modèles par défaut',
    normalTemplates: 'Modèles normaux',
    templateDefaultsSet: 'Modèles par défaut définis',
    selectTemplate: 'Sélectionner le modèle',
    selectTemplateToOverride: 'Sélectionner le modèle à remplacer',
    nameOfTemplate: 'Nom du modèle',
    templateIsRequired: 'Un modèle doit être sélectionné',
    templateOrNameIsRequired: 'Modèle ou nom doit être sélectionné',
    areYouDonePlanning: 'Avez‑vous terminé la planification des trajets ?',
    noBackPage: 'Non, retour à la page',
    yesDone: 'Oui, j’ai terminé',
    manageRouteRules: 'Gérer les règles de tournée',
    eligibleForAutoDispatch: "Éligible à l'auto-dispatch des commandes d'enlèvement",
    postalCodeRangesSet: 'Plages de codes postaux définies',
    unsavedPostalCodeRule: "Ajoutez la règle de code postal avant d'enregistrer",
    applyToConnectedRule: 'Appliquer ces modifications à la règle de tournée associée "{{name}}"',
    serviceExclusionDescription:
      'Les commandes ayant l’un de ces codes de service ne sont jamais affectées à cette tournée par l’auto-dispatch.',
    postalCodeRulesSaved: 'Règles de code postal mises à jour avec succès',
    postalCodeRulesSavedAndApplied:
      'Règles de code postal mises à jour avec succès et également appliquées à la règle "{{name}}"',
    postalCodesTab: 'Codes postaux',
    routeRuleTab: 'Règle de tournée',
    connectRouteRuleSubHeading:
      'Associez une règle de tournée à cette tournée. Les règles de code postal de la tournée seront remplacées par celles de la règle sélectionnée.',
    selectRouteRule: 'Sélectionner une règle de tournée',
    routeRuleIsRequired: 'Une règle de tournée doit être sélectionnée',
    routeRuleConnected: 'Les règles de code postal ont été remplacées à partir de la règle de tournée "{{name}}"',
    postalCodeRuleType: 'Type de règle',
    includePostalCodes: 'Inclure',
    excludePostalCodes: 'Exclure',
    postalCodeRange: 'Plage',
    exactPostalCode: 'Code postal exact',
    postalCodeFrom: 'Code postal de début',
    postalCodeTo: 'Code postal de fin',
    addPostalCodeRule: 'Ajouter une règle de code postal',
    noPostalCodeRules: 'Aucune ajoutée pour le moment',
    savedPostalCodeRules: 'Règles de code postal enregistrées',
    postalCodeRuleRequired: 'Le code postal est requis',
    postalCodeRuleConflict: {
      duplicate: 'Cette règle de code postal existe déjà',
      overlap: 'La règle chevauche la règle existante "{{rule}}"',
      excludeNotContained: 'La règle d\'exclusion "{{rule}}" doit être comprise dans une plage d\'inclusion',
      excludeCoversInclude: 'Une règle d\'exclusion ne peut pas couvrir toute la plage d\'inclusion "{{rule}}"'
    },
    skipAutoDispatch: "Désactiver l'auto-dispatch",
    enableAutoDispatch: "Activer l'auto-dispatch",
    skipAutoDispatchSuccess: "{{name}} a été désactivé pour l'auto-dispatch avec succès",
    enableAutoDispatchSuccess: "{{name}} a été activé pour l'auto-dispatch avec succès",
    completedRoute: '{{name}} a été complété',
    routeCreatedMessage: 'Trajet enregistré avec succès et ajouté à la liste',
    createRoute: 'Créer un trajet',
    saveAndCreateRoute: 'Enregistrer et créer un nouveau trajet',
    routeWasDeleted: 'Trajet supprimé avec succès',
    routeWasUpdated: 'Trajet mis à jour avec succès',
    routeWasUpdated_other: 'Trajets mis à jour avec succès',
    routeWasDeleted_other: 'Trajets supprimés avec succès',
    sendPrePickupSms: 'Envoyer SMS de suivi pré‑ramassage',
    deleteAllRoutes: 'Supprimer tous les trajets',
    routesNotStarted: 'Trajets non commencés',
    noRoutes: 'Aucun itinéraire n’a encore été créé',
    viewStopsGrouped: 'Regrouper les arrêts',
    showCompletedDeliveries: 'Afficher les livraisons terminées',
    showRemainingDeliveries: 'Afficher les livraisons restantes',
    orders: 'Commandes',
    onlyUnaccepted: 'uniquement non acceptées',
    onlyRoutesWithUnacceptedOrders: 'Afficher uniquement les itinéraires avec des commandes non acceptées',
    activeFilters: 'Filtres actifs',
    clearFilters: 'Effacer le filtre',
    clearSearch: 'Effacer la recherche',
    removeFilter: 'Supprimer le filtre {{name}}',
    selectedCount: '{{count}} sélectionné',
    selectedCount_other: '{{count}} sélectionnés',
    selectedCount_zero: 'aucun sélectionné',
    routeState: 'État de l’itinéraire',
    routeLabels: 'Étiquettes de tournée',
    state: 'État',
    routeNameAZ: 'Nom de l’itinéraire A–Z',
    routeNameZA: 'Nom de l’itinéraire Z–A',
    routeStartedAZ: 'Route commencée A-Z',
    routeNotStartedAZ: 'Route non commencée A-Z',
    deletePlannedStopFromSlot: "Supprimer l'arrêt planifié du créneau",
    deleteBreakFromSlot: 'Supprimer le temps de pause du créneau',
    plannedStopDeletedFromSlot: "L'arrêt planifié a été supprimé du créneau avec succès",
    movedOrderToRouteSuccess: "Commande déplacée vers l'itinéraire {{routeName}}",
    movedOrderToRouteSuccess_other: "{{count}} commandes déplacées vers l'itinéraire {{routeName}}",
    moveOrderToRouteQuestion: "Déplacer commande vers l'itinéraire {{routeName}} ?",
    moveOrderToRouteQuestion_other: "Déplacer {{count}} commandes vers l'itinéraire {{routeName}} ?",
    couldNotMoveOrderToRoute: "Impossible de déplacer la commande vers l'itinéraire {{routeName}}",
    failedToOptimizeSlotAfterDeletingPlannedStop:
      "Impossible d'optimiser l'itinéraire après la suppression de l'arrêt planifié",
    actionsForAllShipments: 'Actions pour toutes les expéditions',
    removePlannedStopFromRouteAndReoptimize:
      "L'arrêt planifié sera retiré de l'itinéraire et l'itinéraire sera automatiquement ré-optimisé.",
    unassignShipmentFromRouteAndReoptimize:
      "L'expédition sera retirée de l'itinéraire et l'itinéraire sera automatiquement ré-optimisé.",
    unassignShipmentFromRouteAndReoptimize_other:
      "Les expéditions seront retirées de l'itinéraire et l'itinéraire sera automatiquement ré-optimisé.",
    quickEditDisabledTooltip: "Vous n'avez pas accès au département de cette commande.",
    routeLabel: 'Étiquette de tournée',
    selectRouteLabel: 'Sélectionner une étiquette de tournée',
    labelFilter: {
      title: 'Filtrer les tournées par étiquette',
      description:
        'Ce département a des étiquettes de tournée. Sélectionnez une ou plusieurs étiquettes pour restreindre les tournées affichées.',
      selectLabels: 'Sélectionner des étiquettes',
      apply: 'Appliquer le filtre',
      showAll: 'Afficher toutes les tournées',
      or: 'OU',
      and: 'ET'
    },
    mustSelectVehicle: 'Vous devez sélectionner un véhicule'
  },
  reports: {
    serviceTimeWindow: 'Livré dans la fenêtre de temps de service',
    estimatedTimeWindow: 'Livré dans le temps estimé',
    correctLocation: 'Livré au bon endroit',
    withinSTW: 'Dans STW',
    withinETD: 'Dans ETD',
    withinPAW: 'Dans PAW',
    followedRoutes: 'Itinéraires suivis',
    departmentTitle: 'Rapport pour {{name}}',
    serviceWindow: 'Fenêtre de service',
    estimatedWindow: 'Fenêtre estimée',
    quality: 'Qualité',
    scrollToStop: "Défiler jusqu'à l'arrêt",
    stopGraphLabel: "Données d'arrêt",
    hiddenStopsTooltip: 'Ce graphique contient des arrêts masqués. Cliquez pour voir quels arrêts',
    graphContainsHiddenStops: 'Ce graphique contient des arrêts masqués',
    stopWasHiddenDueToDeliveryDateSetTo: "L'arrêt {{stopNumber}} a été masqué car la date de livraison était {{date}}",
    stopWasHiddenDueToDeliveryDateNotSet: "L'arrêt {{stopNumber}} a été masqué car il n'a pas été terminé",
    productionAccuracy: 'Fenêtre de production',
    productionAccuracyTimeWindow: 'Livré dans la fenêtre de production',
    actualStop: 'Ordre réel des arrêts',
    plannedStop: 'Ordre planifié des arrêts',
    serviceTimeWindowTooltip: '{{number}} arrêts livrés dans la fenêtre horaire de service.',
    estimatedTimeWindowTooltip: '{{number}} arrêts livrés dans la fenêtre horaire estimée.',
    correctLocationTooltip: '{{number}} arrêts livrés au bon endroit.',
    followedRoutesTooltipStops: '{{number}} arrêts effectués dans le bon ordre.',
    followedRoutesTooltipOrders: '{{number}} commandes livrées dans le bon ordre.',
    productionAccuracyTooltip: '{{number}} d’arrêts livrés dans la fenêtre de production.'
  },
  settings: {
    profile: 'Profil',
    departmentsSaved: 'Vos départements ont été enregistrés'
  },
  iamOnboarding: {
    description:
      'Il semble qu’aucun département ne soit encore connecté à votre compte. Vous pouvez ajouter les départements auxquels vous avez besoin d’accéder via les Paramètres dans le menu à gauche.',
    goToSettings: 'Aller aux Paramètres'
  },
  iamMigrationModal: {
    title: 'Action requise : demandez le rôle One Identity Glow',
    body: 'En tant qu’employé Posten & Bring, vous avez désormais besoin du rôle ci-dessous pour vous connecter à Glow. Veuillez demander ce rôle dans One Identity.',
    instructions:
      'Allez sur <a>{{iamUrl}}</a> et demandez le rôle. Une fois votre demande approuvée, vous pourrez vous connecter à Glow avec votre compte Posten.',
    roleLabel: 'Rôle à demander',
    copyRole: 'Copier le nom du rôle',
    copied: 'Copié',
    applyForRole: 'Demander le rôle',
    confirmCheckbox: 'Je confirme avoir demandé le rôle F_APP_S55475-GLOW_USR',
    confirm: 'Continuer'
  }
}
export default fr
